/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AI Logistics API
 * Bilty / LR management for AI Logistics — internal API.
 * OpenAPI spec version: 0.1.0
 */
import { customFetch } from '../lib/api-fetch';
export interface AddressBlock {
  label: string;
  line1: string;
  line2: string;
  /** @pattern ^[1-9][0-9]{5}$ */
  postal_code: string;
  state: string;
  country?: string;
}

export interface AttachmentUploadUrlRequest {
  content_type: string;
}

export interface AttachmentUploadUrlResponse {
  put_url: string;
  object_key: string;
  expires_in: number;
}

export interface BankBlock {
  name: string;
  branch: string;
  account_holder: string;
  /**
   * @minLength 6
   * @maxLength 20
   */
  account_no: string;
  /** @pattern ^[A-Z]{4}0[A-Z0-9]{6}$ */
  ifsc: string;
}

export interface Bilty360List {
  items: Bilty360Row[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

export type Bilty360RowBiltyNo = string | null;

export type Bilty360RowVendorPartyId = string | null;

export interface Bilty360Row {
  id: string;
  branch_id: string;
  fy_start_year: number;
  bilty_no: Bilty360RowBiltyNo;
  bilty_date: string;
  from_city: string;
  to_city: string;
  bilty_status: string;
  consignor_party_id: string;
  vendor_party_id?: Bilty360RowVendorPartyId;
  party_name: string;
  vendor_name: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  customer_billed: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  customer_paid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vendor_cost: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vendor_paid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  margin: string;
  chain_status: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  pass_through_charges?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  freight_revenue?: string;
}

export interface BiltyCancel {
  /**
   * @minLength 3
   * @maxLength 1000
   */
  reason: string;
}

export type BiltyChargeRevisionReadChangedByUserId = string | null;

export type BiltyChargeRevisionReadNote = string | null;

export interface BiltyChargeRevisionRead {
  id: string;
  changed_at: string;
  changed_by_user_id: BiltyChargeRevisionReadChangedByUserId;
  source: string;
  field: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  old_amount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  new_amount: string;
  note: BiltyChargeRevisionReadNote;
}

export type BiltyChargesUpdateLoadingUnloadingCharge = number | string | null;

export type BiltyChargesUpdateKantaCharge = number | string | null;

export type BiltyChargesUpdateOtherCharge = number | string | null;

export type BiltyChargesUpdateDetentionCharges = number | string | null;

export type BiltyChargesUpdateNote = string | null;

/**
 * Destination charges revised after the fact — from the invoice screen
once the warehouse has quoted hamali / detention (V48 P2). Only the fields
sent are touched; each change leaves an old→new row on the bilty.
 */
export interface BiltyChargesUpdate {
  loading_unloading_charge?: BiltyChargesUpdateLoadingUnloadingCharge;
  kanta_charge?: BiltyChargesUpdateKantaCharge;
  other_charge?: BiltyChargesUpdateOtherCharge;
  detention_charges?: BiltyChargesUpdateDetentionCharges;
  note?: BiltyChargesUpdateNote;
}

export type BiltyCreateBiltyNo = string | null;

export type BiltyCreateBillingPartyId = string | null;

export type BiltyCreateDeliveryType = string | null;

export type BiltyCreateLoadType = 'ftl' | 'ltl' | null;

export type BiltyCreateTruckId = string | null;

export type BiltyCreateDriverId = string | null;

export type BiltyCreateVehicleHiringCharge = number | string;

export type BiltyCreateVehicleCommissionCharge = number | string;

export type BiltyCreateInvoiceNumber = string | null;

export type BiltyCreateInvoiceDate = string | null;

export type BiltyCreateEwayBillNumber = string | null;

export type BiltyCreateEwayBillAmount = number | string | null;

export type BiltyCreateEwayExpDate = string | null;

export type BiltyCreatePoNumber = string | null;

export type BiltyCreateBasicFreight = number | string;

export type BiltyCreateLoadingUnloadingCharge = number | string;

export type BiltyCreateKantaCharge = number | string;

export type BiltyCreateOtherCharge = number | string;

export type BiltyCreateGstRate = number | string;

export type BiltyCreateAdvancePaidAmount = number | string;

export type BiltyCreatePaidVia = string | null;

export type BiltyCreateRiskType = string | null;

export type BiltyCreateInsuredBy = 'consignor' | 'consignee' | 'transit' | null;

export type BiltyCreateDetentionCharges = number | string;

export type BiltyCreateDetentionBasis = string | null;

export type BiltyCreateOtherRemarks = string | null;

export type BiltyCreateGrSeq = number | null;

export interface BiltyCreate {
  branch_id: string;
  fy_start_year: number;
  bilty_no?: BiltyCreateBiltyNo;
  bilty_date: string;
  /** @maxLength 120 */
  from_city: string;
  /** @maxLength 120 */
  to_city: string;
  consignor_party_id: string;
  consignee_party_id: string;
  billing_party_id?: BiltyCreateBillingPartyId;
  delivery_type?: BiltyCreateDeliveryType;
  load_type?: BiltyCreateLoadType;
  truck_id?: BiltyCreateTruckId;
  driver_id?: BiltyCreateDriverId;
  /** @maxLength 20 */
  vehicle_hire_basis?: string;
  vehicle_hiring_charge?: BiltyCreateVehicleHiringCharge;
  vehicle_commission_charge?: BiltyCreateVehicleCommissionCharge;
  invoice_number?: BiltyCreateInvoiceNumber;
  invoice_date?: BiltyCreateInvoiceDate;
  eway_bill_number?: BiltyCreateEwayBillNumber;
  eway_bill_amount?: BiltyCreateEwayBillAmount;
  eway_exp_date?: BiltyCreateEwayExpDate;
  po_number?: BiltyCreatePoNumber;
  /** @maxLength 20 */
  pay_type?: string;
  basic_freight?: BiltyCreateBasicFreight;
  loading_unloading_charge?: BiltyCreateLoadingUnloadingCharge;
  kanta_charge?: BiltyCreateKantaCharge;
  other_charge?: BiltyCreateOtherCharge;
  gst_rate?: BiltyCreateGstRate;
  /** @maxLength 20 */
  gst_payable_by?: string;
  advance_paid_amount?: BiltyCreateAdvancePaidAmount;
  paid_via?: BiltyCreatePaidVia;
  is_insured?: boolean;
  risk_type?: BiltyCreateRiskType;
  insured_by?: BiltyCreateInsuredBy;
  /** @maxLength 40 */
  mode_of_transport?: string;
  detention_charges?: BiltyCreateDetentionCharges;
  detention_basis?: BiltyCreateDetentionBasis;
  other_remarks?: BiltyCreateOtherRemarks;
  is_backdated?: boolean;
  gr_seq?: BiltyCreateGrSeq;
  materials?: BiltyMaterialCreate[];
}

export type BiltyDocItemKind = typeof BiltyDocItemKind[keyof typeof BiltyDocItemKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BiltyDocItemKind = {
  lr_consignor: 'lr_consignor',
  lr_consignee: 'lr_consignee',
  lr_lorry: 'lr_lorry',
  lr_file: 'lr_file',
  loading_slip: 'loading_slip',
  delivery_memo: 'delivery_memo',
  invoice: 'invoice',
  lorry_hire_challan: 'lorry_hire_challan',
} as const;

export type BiltyDocItemDetail = string | null;

export type BiltyDocItemRelatedId = string | null;

export interface BiltyDocItem {
  kind: BiltyDocItemKind;
  label: string;
  pdf_url: string;
  detail?: BiltyDocItemDetail;
  related_id?: BiltyDocItemRelatedId;
}

export interface BiltyDocs {
  items: BiltyDocItem[];
}

export type BiltyExtractionFromCity = string | null;

export type BiltyExtractionToCity = string | null;

export type BiltyExtractionTruckNumber = string | null;

export type BiltyExtractionDriverName = string | null;

export type BiltyExtractionDriverMobile = string | null;

export type BiltyExtractionVendorHiringCharge = string | null;

export type BiltyExtractionVendorCommissionCharge = string | null;

export type BiltyExtractionPayType = string | null;

export type BiltyExtractionGstRate = string | null;

export type BiltyExtractionGstPayableBy = string | null;

export type BiltyExtractionRemarks = string | null;

export interface BiltyExtraction {
  from_city?: BiltyExtractionFromCity;
  to_city?: BiltyExtractionToCity;
  consignor?: ExtractedParty;
  consignee?: ExtractedParty;
  materials?: ExtractedMaterialLine[];
  truck_number?: BiltyExtractionTruckNumber;
  driver_name?: BiltyExtractionDriverName;
  driver_mobile?: BiltyExtractionDriverMobile;
  vendor_hiring_charge?: BiltyExtractionVendorHiringCharge;
  vendor_commission_charge?: BiltyExtractionVendorCommissionCharge;
  pay_type?: BiltyExtractionPayType;
  gst_rate?: BiltyExtractionGstRate;
  gst_payable_by?: BiltyExtractionGstPayableBy;
  remarks?: BiltyExtractionRemarks;
  ai_filled_fields?: string[];
}

export interface BiltyList {
  items: BiltyRead[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

export type BiltyMaterialCreateMaterialId = string | null;

export type BiltyMaterialCreateDescription = string | null;

export type BiltyMaterialCreateActualWeightMt = number | string;

export type BiltyMaterialCreateChargeWeightMt = number | string;

export type BiltyMaterialCreateFreightRate = number | string;

export interface BiltyMaterialCreate {
  material_id?: BiltyMaterialCreateMaterialId;
  /** @maxLength 256 */
  name: string;
  description?: BiltyMaterialCreateDescription;
  /** @maxLength 16 */
  hsn_code: string;
  /** @maxLength 64 */
  packaging_type?: string;
  actual_weight_mt?: BiltyMaterialCreateActualWeightMt;
  charge_weight_mt?: BiltyMaterialCreateChargeWeightMt;
  /** @maxLength 8 */
  unit?: string;
  /** @minimum 0 */
  no_of_articles?: number;
  /** @maxLength 20 */
  charge_rate_basis?: string;
  fixed_rate?: boolean;
  freight_rate?: BiltyMaterialCreateFreightRate;
}

export type BiltyMaterialReadMaterialId = string | null;

export type BiltyMaterialReadDescription = string | null;

export interface BiltyMaterialRead {
  id: string;
  material_id: BiltyMaterialReadMaterialId;
  name: string;
  description: BiltyMaterialReadDescription;
  hsn_code: string;
  packaging_type: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  actual_weight_mt: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  charge_weight_mt: string;
  unit: string;
  no_of_articles: number;
  charge_rate_basis: string;
  fixed_rate: boolean;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  freight_rate: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_rate: string;
}

export type BiltyPromoteBodyPayload = BiltyUpdate | null;

export interface BiltyPromoteBody {
  /** @maxLength 20 */
  target_status: string;
  payload?: BiltyPromoteBodyPayload;
}

export type BiltyReadBiltyNo = string | null;

export type BiltyReadGrSeq = number | null;

export type BiltyReadFromState = string | null;

export type BiltyReadToState = string | null;

export type BiltyReadBillingPartyId = string | null;

export type BiltyReadBillingPartyName = string | null;

export type BiltyReadDeliveryType = string | null;

export type BiltyReadTruckId = string | null;

export type BiltyReadDriverId = string | null;

export type BiltyReadInvoiceNumber = string | null;

export type BiltyReadInvoiceDate = string | null;

export type BiltyReadEwayBillNumber = string | null;

export type BiltyReadEwayBillAmount = string | null;

export type BiltyReadEwayExpDate = string | null;

export type BiltyReadPoNumber = string | null;

export type BiltyReadPaidVia = string | null;

export type BiltyReadRiskType = string | null;

export type BiltyReadInsuredBy = string | null;

export type BiltyReadDetentionBasis = string | null;

export type BiltyReadOtherRemarks = string | null;

export type BiltyReadCancellationReason = string | null;

export type BiltyReadCancelledAt = string | null;

export type BiltyReadCancelledByUserId = string | null;

export type BiltyReadDeliveryMemoId = string | null;

export type BiltyReadChallanId = string | null;

export type BiltyReadChallanNo = string | null;

export type BiltyReadLhcId = string | null;

export type BiltyReadLhcNo = string | null;

export type BiltyReadInvoiceId = string | null;

export type BiltyReadInvoiceNo = string | null;

export interface BiltyRead {
  id: string;
  branch_id: string;
  fy_start_year: number;
  bilty_no: BiltyReadBiltyNo;
  gr_seq: BiltyReadGrSeq;
  series: string;
  gr_no_display: string;
  bilty_date: string;
  from_city: string;
  to_city: string;
  from_state: BiltyReadFromState;
  to_state: BiltyReadToState;
  consignor_party_id: string;
  consignee_party_id: string;
  billing_party_id: BiltyReadBillingPartyId;
  billing_party_name: BiltyReadBillingPartyName;
  payer_party_id: string;
  payer_party_name: string;
  payer_role: string;
  consignor_name: string;
  consignee_name: string;
  consignor_address_snapshot: string;
  consignee_address_snapshot: string;
  delivery_type: BiltyReadDeliveryType;
  load_type?: string;
  truck_id: BiltyReadTruckId;
  truck_number: string;
  driver_id: BiltyReadDriverId;
  vehicle_hire_basis: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vehicle_hiring_charge: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vehicle_commission_charge: string;
  invoice_number: BiltyReadInvoiceNumber;
  invoice_date: BiltyReadInvoiceDate;
  eway_bill_number: BiltyReadEwayBillNumber;
  eway_bill_amount: BiltyReadEwayBillAmount;
  eway_exp_date: BiltyReadEwayExpDate;
  po_number: BiltyReadPoNumber;
  pay_type: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  basic_freight: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  loading_unloading_charge: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  kanta_charge: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  other_charge: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst_rate: string;
  gst_payable_by: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  advance_paid_amount: string;
  paid_via: BiltyReadPaidVia;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  remaining_amount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_amount_with_gst: string;
  is_insured: boolean;
  risk_type: BiltyReadRiskType;
  insured_by: BiltyReadInsuredBy;
  mode_of_transport: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  detention_charges: string;
  detention_basis: BiltyReadDetentionBasis;
  other_remarks: BiltyReadOtherRemarks;
  status: string;
  cancelled: boolean;
  cancellation_reason?: BiltyReadCancellationReason;
  cancelled_at?: BiltyReadCancelledAt;
  cancelled_by_user_id?: BiltyReadCancelledByUserId;
  created_by_user_id: string;
  created_at: string;
  updated_at: string;
  materials: BiltyMaterialRead[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vendor_cost: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  margin: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  pass_through_charges?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  freight_revenue?: string;
  charge_revisions?: BiltyChargeRevisionRead[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  customer_paid?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vendor_paid?: string;
  delivery_memo_id?: BiltyReadDeliveryMemoId;
  challan_id?: BiltyReadChallanId;
  challan_no?: BiltyReadChallanNo;
  lhc_id?: BiltyReadLhcId;
  lhc_no?: BiltyReadLhcNo;
  invoice_id?: BiltyReadInvoiceId;
  invoice_no?: BiltyReadInvoiceNo;
}

export type BiltySummaryByStatus = {[key: string]: number};

/**
 * Tiles + status-pill counts for a filtered range of bilties (V53).
 */
export interface BiltySummary {
  count: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  billed: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  pass_through: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vendor_cost: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  margin: string;
  by_status: BiltySummaryByStatus;
}

export type BiltyUpdateBiltyDate = string | null;

export type BiltyUpdateFromCity = string | null;

export type BiltyUpdateToCity = string | null;

export type BiltyUpdateConsignorPartyId = string | null;

export type BiltyUpdateConsigneePartyId = string | null;

export type BiltyUpdateBillingPartyId = string | null;

export type BiltyUpdateDeliveryType = string | null;

export type BiltyUpdateLoadType = 'ftl' | 'ltl' | null;

export type BiltyUpdateTruckId = string | null;

export type BiltyUpdateDriverId = string | null;

export type BiltyUpdateVehicleHireBasis = string | null;

export type BiltyUpdateVehicleHiringCharge = number | string | null;

export type BiltyUpdateVehicleCommissionCharge = number | string | null;

export type BiltyUpdateInvoiceNumber = string | null;

export type BiltyUpdateInvoiceDate = string | null;

export type BiltyUpdateEwayBillNumber = string | null;

export type BiltyUpdateEwayBillAmount = number | string | null;

export type BiltyUpdateEwayExpDate = string | null;

export type BiltyUpdatePoNumber = string | null;

export type BiltyUpdatePayType = string | null;

export type BiltyUpdateBasicFreight = number | string | null;

export type BiltyUpdateLoadingUnloadingCharge = number | string | null;

export type BiltyUpdateKantaCharge = number | string | null;

export type BiltyUpdateOtherCharge = number | string | null;

export type BiltyUpdateGstRate = number | string | null;

export type BiltyUpdateGstPayableBy = string | null;

export type BiltyUpdateAdvancePaidAmount = number | string | null;

export type BiltyUpdatePaidVia = string | null;

export type BiltyUpdateIsInsured = boolean | null;

export type BiltyUpdateRiskType = string | null;

export type BiltyUpdateInsuredBy = 'consignor' | 'consignee' | 'transit' | null;

export type BiltyUpdateModeOfTransport = string | null;

export type BiltyUpdateDetentionCharges = number | string | null;

export type BiltyUpdateDetentionBasis = string | null;

export type BiltyUpdateOtherRemarks = string | null;

export type BiltyUpdateIsBackdated = boolean | null;

export type BiltyUpdateMaterials = BiltyMaterialCreate[] | null;

export interface BiltyUpdate {
  bilty_date?: BiltyUpdateBiltyDate;
  from_city?: BiltyUpdateFromCity;
  to_city?: BiltyUpdateToCity;
  consignor_party_id?: BiltyUpdateConsignorPartyId;
  consignee_party_id?: BiltyUpdateConsigneePartyId;
  billing_party_id?: BiltyUpdateBillingPartyId;
  delivery_type?: BiltyUpdateDeliveryType;
  load_type?: BiltyUpdateLoadType;
  truck_id?: BiltyUpdateTruckId;
  driver_id?: BiltyUpdateDriverId;
  vehicle_hire_basis?: BiltyUpdateVehicleHireBasis;
  vehicle_hiring_charge?: BiltyUpdateVehicleHiringCharge;
  vehicle_commission_charge?: BiltyUpdateVehicleCommissionCharge;
  invoice_number?: BiltyUpdateInvoiceNumber;
  invoice_date?: BiltyUpdateInvoiceDate;
  eway_bill_number?: BiltyUpdateEwayBillNumber;
  eway_bill_amount?: BiltyUpdateEwayBillAmount;
  eway_exp_date?: BiltyUpdateEwayExpDate;
  po_number?: BiltyUpdatePoNumber;
  pay_type?: BiltyUpdatePayType;
  basic_freight?: BiltyUpdateBasicFreight;
  loading_unloading_charge?: BiltyUpdateLoadingUnloadingCharge;
  kanta_charge?: BiltyUpdateKantaCharge;
  other_charge?: BiltyUpdateOtherCharge;
  gst_rate?: BiltyUpdateGstRate;
  gst_payable_by?: BiltyUpdateGstPayableBy;
  advance_paid_amount?: BiltyUpdateAdvancePaidAmount;
  paid_via?: BiltyUpdatePaidVia;
  is_insured?: BiltyUpdateIsInsured;
  risk_type?: BiltyUpdateRiskType;
  insured_by?: BiltyUpdateInsuredBy;
  mode_of_transport?: BiltyUpdateModeOfTransport;
  detention_charges?: BiltyUpdateDetentionCharges;
  detention_basis?: BiltyUpdateDetentionBasis;
  other_remarks?: BiltyUpdateOtherRemarks;
  is_backdated?: BiltyUpdateIsBackdated;
  materials?: BiltyUpdateMaterials;
}

export interface BranchCreate {
  name: string;
  type: BranchType;
  city: string;
  status?: RecordStatus;
}

export interface BranchList {
  items: BranchRead[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

/**
 * Monthly bucket of revenue / cost / margin for a branch (or all).
 */
export interface BranchPLMonth {
  month: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  revenue: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  pass_through_charges?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vendor_cost: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  margin: string;
  bilty_count: number;
}

export type BranchPLResponseBranchId = string | null;

export type BranchPLResponseBranchName = string | null;

/**
 * Date-bounded P&L grouped by YYYY-MM.
 */
export interface BranchPLResponse {
  branch_id: BranchPLResponseBranchId;
  branch_name: BranchPLResponseBranchName;
  from_date: string;
  to_date: string;
  rows: BranchPLMonth[];
  totals: BranchPLMonth;
}

export interface BranchRead {
  id: string;
  name: string;
  type: BranchType;
  city: string;
  status: RecordStatus;
  created_at: string;
  updated_at: string;
}

export type BranchType = typeof BranchType[keyof typeof BranchType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BranchType = {
  head_office: 'head_office',
  sub_branch: 'sub_branch',
} as const;

export type BranchUpdateName = string | null;

export type BranchUpdateType = BranchType | null;

export type BranchUpdateCity = string | null;

export type BranchUpdateStatus = RecordStatus | null;

export interface BranchUpdate {
  name?: BranchUpdateName;
  type?: BranchUpdateType;
  city?: BranchUpdateCity;
  status?: BranchUpdateStatus;
}

export interface CashSummary {
  from_date: string;
  to_date: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  receipts_in: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  capital_in: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  vendor_paid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  expenses_office: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  expenses_personal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  closing_balance: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  margin: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  net_profit: string;
}

/**
 * One bilty on a truck challan — data auto-pulled from the bilty (V31).
 */
export interface ChallanBiltyRow {
  bilty_id: string;
  gr_no: string;
  consignor_name: string;
  from_city: string;
  to_city: string;
  material: string;
  packages: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  weight_mt: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  freight: string;
  status: string;
}

export interface CompanyExtra {
  operational: AddressBlock;
  registered: AddressBlock;
  bank: BankBlock;
  /** @maxItems 20 */
  branches?: string[];
}

export type CompanyProfileReadTagline = string | null;

export type CompanyProfileReadEstablishedYear = number | null;

export type CompanyProfileReadContactWebsite = string | null;

export type CompanyProfileReadGstin = string | null;

export type CompanyProfileReadPan = string | null;

export type CompanyProfileReadCin = string | null;

export type CompanyProfileReadMsme = string | null;

export type CompanyProfileReadIsoCertification = string | null;

export type CompanyProfileReadUpdatedByUserId = string | null;

export interface CompanyProfileRead {
  id: string;
  legal_name: string;
  trade_name: string;
  tagline: CompanyProfileReadTagline;
  established_year: CompanyProfileReadEstablishedYear;
  contact_phone: string;
  contact_email: string;
  contact_website: CompanyProfileReadContactWebsite;
  gstin: CompanyProfileReadGstin;
  pan: CompanyProfileReadPan;
  cin: CompanyProfileReadCin;
  msme: CompanyProfileReadMsme;
  iso_certification: CompanyProfileReadIsoCertification;
  jurisdiction: string;
  extra: CompanyExtra;
  updated_at: string;
  updated_by_user_id: CompanyProfileReadUpdatedByUserId;
}

export type CompanyProfileUpdateTagline = string | null;

export type CompanyProfileUpdateEstablishedYear = number | null;

export type CompanyProfileUpdateContactWebsite = string | null;

export type CompanyProfileUpdateGstin = string | null;

export type CompanyProfileUpdatePan = string | null;

export type CompanyProfileUpdateCin = string | null;

export type CompanyProfileUpdateMsme = string | null;

export type CompanyProfileUpdateIsoCertification = string | null;

/**
 * Full replace. Use PUT for the entire object.
 */
export interface CompanyProfileUpdate {
  legal_name: string;
  trade_name: string;
  tagline?: CompanyProfileUpdateTagline;
  established_year?: CompanyProfileUpdateEstablishedYear;
  contact_phone: string;
  contact_email: string;
  contact_website?: CompanyProfileUpdateContactWebsite;
  gstin?: CompanyProfileUpdateGstin;
  pan?: CompanyProfileUpdatePan;
  cin?: CompanyProfileUpdateCin;
  msme?: CompanyProfileUpdateMsme;
  iso_certification?: CompanyProfileUpdateIsoCertification;
  jurisdiction: string;
  extra: CompanyExtra;
}

export interface CustomerOutstandingRow {
  party_id: string;
  party_name: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  billed: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  received: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  tds: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  short_pay: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unallocated_credit?: string;
  open_invoices: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bucket_0_30: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bucket_31_60: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bucket_61_90: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bucket_90_plus: string;
}

export type DeepHealthResponseDbCurrentUser = string | null;

export type DeepHealthResponseDbCurrentSchema = string | null;

export interface DeepHealthResponse {
  status: string;
  app_env: string;
  db_schema: string;
  db_reachable: boolean;
  db_current_user: DeepHealthResponseDbCurrentUser;
  db_current_schema: DeepHealthResponseDbCurrentSchema;
}

export type DeliveryMemoCreatePodImageUrl = string | null;

export type DeliveryMemoCreateSignedBy = string | null;

export type DeliveryMemoCreateDeliveredAt = string | null;

export type DeliveryMemoCreateRemarks = string | null;

export interface DeliveryMemoCreate {
  bilty_id: string;
  pod_image_url?: DeliveryMemoCreatePodImageUrl;
  signed_by?: DeliveryMemoCreateSignedBy;
  delivered_at?: DeliveryMemoCreateDeliveredAt;
  remarks?: DeliveryMemoCreateRemarks;
}

export interface DocumentDistributionResponse {
  fy_start_year: number;
  items: DocumentStatusCount[];
}

export interface DocumentStatusCount {
  status: string;
  count: number;
}

export type DriverCreateLicenseValidity = string | null;

export interface DriverCreate {
  name: string;
  /** @maxLength 20 */
  mobile_no: string;
  /** @maxLength 32 */
  license_no: string;
  license_validity?: DriverCreateLicenseValidity;
  status?: RecordStatus;
}

export interface DriverList {
  items: DriverRead[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

export type DriverReadLicenseValidity = string | null;

export interface DriverRead {
  id: string;
  name: string;
  mobile_no: string;
  license_no: string;
  license_validity: DriverReadLicenseValidity;
  status: RecordStatus;
  created_at: string;
  updated_at: string;
}

export type DriverUpdateName = string | null;

export type DriverUpdateMobileNo = string | null;

export type DriverUpdateLicenseNo = string | null;

export type DriverUpdateLicenseValidity = string | null;

export type DriverUpdateStatus = RecordStatus | null;

export interface DriverUpdate {
  name?: DriverUpdateName;
  mobile_no?: DriverUpdateMobileNo;
  license_no?: DriverUpdateLicenseNo;
  license_validity?: DriverUpdateLicenseValidity;
  status?: DriverUpdateStatus;
}

export type ExpenseBiltyRefBiltyNo = string | null;

export interface ExpenseBiltyRef {
  bilty_id: string;
  bilty_no: ExpenseBiltyRefBiltyNo;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  applied_amount: string;
}

export interface ExpenseCategoryCreate {
  /**
   * @minLength 1
   * @maxLength 80
   */
  name: string;
  is_personal?: boolean;
}

export interface ExpenseCategoryRead {
  id: string;
  name: string;
  is_personal: boolean;
}

export type ExpenseCreateKind = typeof ExpenseCreateKind[keyof typeof ExpenseCreateKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExpenseCreateKind = {
  expense: 'expense',
  capital_in: 'capital_in',
} as const;

export type ExpenseCreateCategoryId = string | null;

export type ExpenseCreateCategoryName = string | null;

export type ExpenseCreateAmount = number | string;

export type ExpenseCreateMode = typeof ExpenseCreateMode[keyof typeof ExpenseCreateMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExpenseCreateMode = {
  neft: 'neft',
  rtgs: 'rtgs',
  imps: 'imps',
  upi: 'upi',
  cheque: 'cheque',
  cash: 'cash',
} as const;

export type ExpenseCreateRefNo = string | null;

export type ExpenseCreatePaidTo = string | null;

export type ExpenseCreateNote = string | null;

export type ExpenseCreateAttachmentKey = string | null;

export type ExpenseCreateBranchId = string | null;

export interface ExpenseCreate {
  entry_date: string;
  kind?: ExpenseCreateKind;
  category_id?: ExpenseCreateCategoryId;
  category_name?: ExpenseCreateCategoryName;
  category_is_personal?: boolean;
  amount: ExpenseCreateAmount;
  mode?: ExpenseCreateMode;
  ref_no?: ExpenseCreateRefNo;
  paid_to?: ExpenseCreatePaidTo;
  note?: ExpenseCreateNote;
  attachment_key?: ExpenseCreateAttachmentKey;
  bilty_ids?: string[];
  branch_id?: ExpenseCreateBranchId;
}

export interface ExpenseList {
  items: ExpenseRead[];
  total: number;
  page: number;
  page_size: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_expense?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_personal?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_capital_in?: string;
}

export type ExpenseReadCategoryId = string | null;

export type ExpenseReadCategoryName = string | null;

export type ExpenseReadRefNo = string | null;

export type ExpenseReadPaidTo = string | null;

export type ExpenseReadNote = string | null;

export type ExpenseReadAttachmentKey = string | null;

export type ExpenseReadCreatedByEmail = string | null;

export interface ExpenseRead {
  id: string;
  branch_id: string;
  entry_date: string;
  kind: string;
  category_id: ExpenseReadCategoryId;
  category_name: ExpenseReadCategoryName;
  is_personal: boolean;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  mode: string;
  ref_no?: ExpenseReadRefNo;
  paid_to?: ExpenseReadPaidTo;
  note?: ExpenseReadNote;
  attachment_key?: ExpenseReadAttachmentKey;
  created_at: string;
  created_by_email?: ExpenseReadCreatedByEmail;
  bilties?: ExpenseBiltyRef[];
}

export interface ExtractRequest {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  text: string;
}

export interface ExtractResponse {
  extracted: BiltyExtraction;
  model: string;
  input_tokens: number;
  output_tokens: number;
}

export type ExtractedMaterialLineName = string | null;

export type ExtractedMaterialLineHsnCode = string | null;

export type ExtractedMaterialLineWeightMt = string | null;

export type ExtractedMaterialLineRatePerMt = string | null;

export type ExtractedMaterialLineNoOfArticles = number | null;

export interface ExtractedMaterialLine {
  name?: ExtractedMaterialLineName;
  hsn_code?: ExtractedMaterialLineHsnCode;
  weight_mt?: ExtractedMaterialLineWeightMt;
  rate_per_mt?: ExtractedMaterialLineRatePerMt;
  no_of_articles?: ExtractedMaterialLineNoOfArticles;
}

export type ExtractedPartyGstNumber = string | null;

export type ExtractedPartyName = string | null;

export type ExtractedPartyRawAddress = string | null;

export type ExtractedPartyCity = string | null;

export interface ExtractedParty {
  gst_number?: ExtractedPartyGstNumber;
  name?: ExtractedPartyName;
  raw_address?: ExtractedPartyRawAddress;
  city?: ExtractedPartyCity;
}

export type GSTR1InvoiceLinePartyGstin = string | null;

/**
 * One taxable line per non-cancelled bilty for B2B / B2B-RCM / B2C-S.
 */
export interface GSTR1InvoiceLine {
  bilty_id: string;
  bilty_no: string;
  bilty_date: string;
  party_gstin: GSTR1InvoiceLinePartyGstin;
  party_name: string;
  place_of_supply: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  taxable_value: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst_rate: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  igst_amount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cgst_amount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  sgst_amount: string;
  is_reverse_charge: boolean;
  hsn: string;
}

export type GSTR1ResponseBranchId = string | null;

export type GSTR1ResponseBranchName = string | null;

export type GSTR1ResponseCompanyGstin = string | null;

/**
 * A month's outward-supply return, split into the three GSTR-1 sections.
 */
export interface GSTR1Response {
  yyyy_mm: string;
  branch_id: GSTR1ResponseBranchId;
  branch_name: GSTR1ResponseBranchName;
  company_gstin: GSTR1ResponseCompanyGstin;
  b2b: GSTR1InvoiceLine[];
  b2b_rcm: GSTR1InvoiceLine[];
  b2cs: GSTR1InvoiceLine[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totals_taxable: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totals_igst: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totals_cgst: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totals_sgst: string;
  invoice_count: number;
}

export type GSTR3BResponseBranchId = string | null;

export type GSTR3BResponseBranchName = string | null;

export type GSTR3BResponseCompanyGstin = string | null;

/**
 * Monthly summary block matching the GSTR-3B form layout.
 */
export interface GSTR3BResponse {
  yyyy_mm: string;
  branch_id: GSTR3BResponseBranchId;
  branch_name: GSTR3BResponseBranchName;
  company_gstin: GSTR3BResponseCompanyGstin;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outward_taxable: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outward_zero_rated: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outward_rcm_taxable: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outward_nil_rated: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  igst_payable: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cgst_payable: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  sgst_payable: string;
  invoice_count: number;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export interface HealthResponse {
  status: string;
  app_env: string;
  db_schema: string;
}

export type InvoiceBatchCreatePoNumber = string | null;

export type InvoiceBatchCreatePoDate = string | null;

export type InvoiceBatchCreateRemark = string | null;

export interface InvoiceBatchCreate {
  branch_id: string;
  fy_start_year: number;
  /** @maxLength 32 */
  invoice_no: string;
  invoice_date: string;
  party_id: string;
  /** @minItems 1 */
  bilty_ids: string[];
  po_number?: InvoiceBatchCreatePoNumber;
  po_date?: InvoiceBatchCreatePoDate;
  remark?: InvoiceBatchCreateRemark;
}

export interface InvoiceBatchRead {
  invoice_id: string;
  invoice_no: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst_amount: string;
  bilty_count: number;
}

export type InvoiceBiltyLineBiltyNo = string | null;

export interface InvoiceBiltyLine {
  id: string;
  bilty_no: InvoiceBiltyLineBiltyNo;
  bilty_date: string;
  from_city: string;
  to_city: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
}

export type InvoiceCreateTotal = number | string;

export type InvoiceCreateGstAmount = number | string;

export interface InvoiceCreate {
  branch_id: string;
  fy_start_year: number;
  /** @maxLength 32 */
  invoice_no: string;
  invoice_date: string;
  party_id: string;
  total?: InvoiceCreateTotal;
  gst_amount?: InvoiceCreateGstAmount;
}

export type InvoiceDetailBranchCode = string | null;

export type InvoiceDetailPartyName = string | null;

export type InvoiceDetailPoNumber = string | null;

export type InvoiceDetailPoDate = string | null;

export type InvoiceDetailRemark = string | null;

/**
 * Invoice header + its bilty lines + every receipt applied to it (V49).
 */
export interface InvoiceDetail {
  id: string;
  branch_id: string;
  branch_code?: InvoiceDetailBranchCode;
  fy_start_year: number;
  invoice_no: string;
  invoice_date: string;
  party_id: string;
  party_name?: InvoiceDetailPartyName;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst_amount: string;
  po_number?: InvoiceDetailPoNumber;
  po_date?: InvoiceDetailPoDate;
  remark?: InvoiceDetailRemark;
  status: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paid_amount?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding?: string;
  created_at: string;
  bilties?: InvoiceBiltyLine[];
  receipts?: ReceiptRead[];
}

export interface InvoiceList {
  items: InvoiceRead[];
  total: number;
  page: number;
  page_size: number;
}

export type InvoiceReadBranchCode = string | null;

export type InvoiceReadPartyName = string | null;

export type InvoiceReadPoNumber = string | null;

export type InvoiceReadPoDate = string | null;

export type InvoiceReadRemark = string | null;

export interface InvoiceRead {
  id: string;
  branch_id: string;
  branch_code?: InvoiceReadBranchCode;
  fy_start_year: number;
  invoice_no: string;
  invoice_date: string;
  party_id: string;
  party_name?: InvoiceReadPartyName;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst_amount: string;
  po_number?: InvoiceReadPoNumber;
  po_date?: InvoiceReadPoDate;
  remark?: InvoiceReadRemark;
  status: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paid_amount?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding?: string;
  created_at: string;
}

export interface JourneyList {
  items: JourneyRead[];
}

export type JourneyReadBiltyId = string | null;

export type JourneyReadChallanId = string | null;

export type JourneyReadChallanNo = string | null;

export type JourneyReadDriverName = string | null;

export type JourneyReadLastPolledAt = string | null;

export type JourneyReadLastError = string | null;

export interface JourneyRead {
  bilty_id?: JourneyReadBiltyId;
  challan_id?: JourneyReadChallanId;
  challan_no?: JourneyReadChallanNo;
  truck_number: string;
  driver_name?: JourneyReadDriverName;
  route: string;
  gr_refs: string[];
  status: string;
  trackable: boolean;
  last_polled_at?: JourneyReadLastPolledAt;
  last_error?: JourneyReadLastError;
  pings: TollPingRead[];
}

/**
 * Outcome of one automated labelling pass.
 */
export interface LabelRunRead {
  considered: number;
  labelled: number;
  unresolved: number;
}

export type LhcCreateLhcNo = string | null;

export type LhcCreateFromCity = string | null;

export type LhcCreateToCity = string | null;

export type LhcCreateBrokerPartyId = string | null;

export type LhcCreateOwnerPartyId = string | null;

export type LhcCreateHireAmount = number | string;

export type LhcCreateAdvanceAmount = number | string;

export type LhcCreateAdvanceRefNo = string | null;

export type LhcCreateAdvancePaidOn = string | null;

export type LhcCreateAdvanceMode = typeof LhcCreateAdvanceMode[keyof typeof LhcCreateAdvanceMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LhcCreateAdvanceMode = {
  neft: 'neft',
  rtgs: 'rtgs',
  imps: 'imps',
  upi: 'upi',
  cheque: 'cheque',
  cash: 'cash',
} as const;

export interface LhcCreate {
  challan_id: string;
  lhc_no?: LhcCreateLhcNo;
  lhc_date: string;
  from_city?: LhcCreateFromCity;
  to_city?: LhcCreateToCity;
  broker_party_id?: LhcCreateBrokerPartyId;
  owner_party_id?: LhcCreateOwnerPartyId;
  hire_amount?: LhcCreateHireAmount;
  advance_amount?: LhcCreateAdvanceAmount;
  advance_ref_no?: LhcCreateAdvanceRefNo;
  advance_paid_on?: LhcCreateAdvancePaidOn;
  advance_mode?: LhcCreateAdvanceMode;
  other_charges?: LhcOtherChargeCreate[];
}

export interface LhcList {
  items: LhcRead[];
  total: number;
  page: number;
  page_size: number;
}

export type LhcOtherChargeCreateAmount = number | string;

export interface LhcOtherChargeCreate {
  /**
   * @minLength 1
   * @maxLength 500
   */
  description: string;
  amount: LhcOtherChargeCreateAmount;
}

export interface LhcOtherChargeRead {
  id: string;
  description: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  created_at: string;
}

export type LhcReadLhcSeq = number | null;

export type LhcReadChallanNo = string | null;

export type LhcReadTruckRegNo = string | null;

export type LhcReadDriverId = string | null;

export type LhcReadDriverName = string | null;

export type LhcReadBrokerPartyId = string | null;

export type LhcReadBrokerName = string | null;

export type LhcReadOwnerPartyId = string | null;

export type LhcReadOwnerName = string | null;

export type LhcReadAdvanceRefNo = string | null;

export type LhcReadAdvancePaidOn = string | null;

export interface LhcRead {
  id: string;
  branch_id: string;
  fy_start_year: number;
  lhc_no: string;
  lhc_seq: LhcReadLhcSeq;
  lhc_date: string;
  challan_id: string;
  challan_no?: LhcReadChallanNo;
  gr_numbers?: string[];
  truck_id: string;
  truck_reg_no?: LhcReadTruckRegNo;
  driver_id: LhcReadDriverId;
  driver_name?: LhcReadDriverName;
  from_city: string;
  to_city: string;
  broker_party_id: LhcReadBrokerPartyId;
  broker_name?: LhcReadBrokerName;
  owner_party_id: LhcReadOwnerPartyId;
  owner_name?: LhcReadOwnerName;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  hire_amount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  advance_amount: string;
  advance_ref_no?: LhcReadAdvanceRefNo;
  advance_paid_on?: LhcReadAdvancePaidOn;
  advance_mode?: string;
  other_charges?: LhcOtherChargeRead[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  other_total?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_amount?: string;
  payments?: VendorPaymentRead[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paid_total?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  balance_due?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  balance_amount?: string;
  status: string;
  created_at: string;
}

export type LhcUpdateLhcDate = string | null;

export type LhcUpdateFromCity = string | null;

export type LhcUpdateToCity = string | null;

export type LhcUpdateBrokerPartyId = string | null;

export type LhcUpdateOwnerPartyId = string | null;

export type LhcUpdateHireAmount = number | string | null;

export type LhcUpdateAdvanceAmount = number | string | null;

export type LhcUpdateAdvanceRefNo = string | null;

export type LhcUpdateAdvancePaidOn = string | null;

export type LhcUpdateAdvanceMode = 'neft' | 'rtgs' | 'imps' | 'upi' | 'cheque' | 'cash' | null;

export interface LhcUpdate {
  lhc_date?: LhcUpdateLhcDate;
  from_city?: LhcUpdateFromCity;
  to_city?: LhcUpdateToCity;
  broker_party_id?: LhcUpdateBrokerPartyId;
  owner_party_id?: LhcUpdateOwnerPartyId;
  hire_amount?: LhcUpdateHireAmount;
  advance_amount?: LhcUpdateAdvanceAmount;
  advance_ref_no?: LhcUpdateAdvanceRefNo;
  advance_paid_on?: LhcUpdateAdvancePaidOn;
  advance_mode?: LhcUpdateAdvanceMode;
}

export interface LinkBiltyBody {
  bilty_id: string;
}

export type LoadingSlipCreateSlipNo = string | null;

export type LoadingSlipCreateDriverId = string | null;

export type LoadingSlipCreateTotalFreight = number | string;

export interface LoadingSlipCreate {
  branch_id: string;
  fy_start_year: number;
  slip_no?: LoadingSlipCreateSlipNo;
  loading_date: string;
  truck_id: string;
  driver_id?: LoadingSlipCreateDriverId;
  total_freight?: LoadingSlipCreateTotalFreight;
  with_bilty?: boolean;
  bilty_ids?: string[];
}

export type LoadingSlipDetailBranchCode = string | null;

export type LoadingSlipDetailChallanSeq = number | null;

export type LoadingSlipDetailTruckRegNo = string | null;

export type LoadingSlipDetailDriverId = string | null;

export type LoadingSlipDetailDriverName = string | null;

export type LoadingSlipDetailLhcId = string | null;

export type LoadingSlipDetailLhcNo = string | null;

export interface LoadingSlipDetail {
  id: string;
  branch_id: string;
  branch_code?: LoadingSlipDetailBranchCode;
  fy_start_year: number;
  slip_no: string;
  challan_seq?: LoadingSlipDetailChallanSeq;
  loading_date: string;
  truck_id: string;
  truck_reg_no?: LoadingSlipDetailTruckRegNo;
  driver_id?: LoadingSlipDetailDriverId;
  driver_name?: LoadingSlipDetailDriverName;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_freight: string;
  with_bilty: boolean;
  status: string;
  created_at: string;
  lhc_id?: LoadingSlipDetailLhcId;
  lhc_no?: LoadingSlipDetailLhcNo;
  bilties?: ChallanBiltyRow[];
}

export interface LoadingSlipList {
  items: LoadingSlipRead[];
  total: number;
  page: number;
  page_size: number;
}

export type LoadingSlipReadBranchCode = string | null;

export type LoadingSlipReadChallanSeq = number | null;

export type LoadingSlipReadTruckRegNo = string | null;

export type LoadingSlipReadDriverId = string | null;

export type LoadingSlipReadDriverName = string | null;

export type LoadingSlipReadLhcId = string | null;

export type LoadingSlipReadLhcNo = string | null;

export interface LoadingSlipRead {
  id: string;
  branch_id: string;
  branch_code?: LoadingSlipReadBranchCode;
  fy_start_year: number;
  slip_no: string;
  challan_seq?: LoadingSlipReadChallanSeq;
  loading_date: string;
  truck_id: string;
  truck_reg_no?: LoadingSlipReadTruckRegNo;
  driver_id?: LoadingSlipReadDriverId;
  driver_name?: LoadingSlipReadDriverName;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_freight: string;
  with_bilty: boolean;
  status: string;
  created_at: string;
  lhc_id?: LoadingSlipReadLhcId;
  lhc_no?: LoadingSlipReadLhcNo;
}

export interface LoginBody {
  /**
   * @minLength 3
   * @maxLength 320
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 256
   */
  password: string;
}

export type LookupCrossingReadDirection = string | null;

export type LookupCrossingReadLat = number | null;

export type LookupCrossingReadLon = number | null;

/**
 * One crossing from an ad-hoc lookup.

Deliberately not `TollPingRead`: that shape carries `source` and the plaza
master's city/state, which only exist for crossings we stored. A lookup
stores nothing, so promising those fields would mean always sending null.
 */
export interface LookupCrossingRead {
  plaza_name: string;
  crossed_at: string;
  direction?: LookupCrossingReadDirection;
  lat?: LookupCrossingReadLat;
  lon?: LookupCrossingReadLon;
}

export type ManualTaxInvoiceCreateBuyerGstin = string | null;

export type ManualTaxInvoiceCreateViaVehicle = string | null;

export type ManualTaxInvoiceCreateGoodsDesc = string | null;

export type ManualTaxInvoiceCreateTerms = string | null;

export type ManualTaxInvoiceCreateBankDetails = string | null;

export interface ManualTaxInvoiceCreate {
  /**
   * @minLength 1
   * @maxLength 64
   */
  invoice_no: string;
  invoice_date: string;
  buyer_gstin?: ManualTaxInvoiceCreateBuyerGstin;
  /**
   * @minLength 1
   * @maxLength 256
   */
  buyer_name: string;
  buyer_address?: string;
  /**
   * @minLength 1
   * @maxLength 15
   */
  carrier_gstin: string;
  carrier_address: string;
  /** @minItems 1 */
  items: ManualTaxInvoiceItemInput[];
  via_vehicle?: ManualTaxInvoiceCreateViaVehicle;
  goods_desc?: ManualTaxInvoiceCreateGoodsDesc;
  rcm?: boolean;
  terms?: ManualTaxInvoiceCreateTerms;
  bank_details?: ManualTaxInvoiceCreateBankDetails;
}

export type ManualTaxInvoiceItemInputBiltiNo = string | null;

export type ManualTaxInvoiceItemInputBiltiDate = string | null;

export type ManualTaxInvoiceItemInputDestination = string | null;

export type ManualTaxInvoiceItemInputPkg = string | null;

export type ManualTaxInvoiceItemInputWeight = string | null;

export type ManualTaxInvoiceItemInputCustomer = string | null;

export type ManualTaxInvoiceItemInputCustomerInvoice = string | null;

export type ManualTaxInvoiceItemInputLorryNo = string | null;

export type ManualTaxInvoiceItemInputAmount = number | string;

export type ManualTaxInvoiceItemInputMiscCharge = number | string;

export type ManualTaxInvoiceItemInputFreight = number | string;

export interface ManualTaxInvoiceItemInput {
  bilti_no?: ManualTaxInvoiceItemInputBiltiNo;
  bilti_date?: ManualTaxInvoiceItemInputBiltiDate;
  destination?: ManualTaxInvoiceItemInputDestination;
  pkg?: ManualTaxInvoiceItemInputPkg;
  weight?: ManualTaxInvoiceItemInputWeight;
  customer?: ManualTaxInvoiceItemInputCustomer;
  customer_invoice?: ManualTaxInvoiceItemInputCustomerInvoice;
  lorry_no?: ManualTaxInvoiceItemInputLorryNo;
  amount?: ManualTaxInvoiceItemInputAmount;
  misc_charge?: ManualTaxInvoiceItemInputMiscCharge;
  freight?: ManualTaxInvoiceItemInputFreight;
}

export type ManualTaxInvoiceItemOutputBiltiNo = string | null;

export type ManualTaxInvoiceItemOutputBiltiDate = string | null;

export type ManualTaxInvoiceItemOutputDestination = string | null;

export type ManualTaxInvoiceItemOutputPkg = string | null;

export type ManualTaxInvoiceItemOutputWeight = string | null;

export type ManualTaxInvoiceItemOutputCustomer = string | null;

export type ManualTaxInvoiceItemOutputCustomerInvoice = string | null;

export type ManualTaxInvoiceItemOutputLorryNo = string | null;

export interface ManualTaxInvoiceItemOutput {
  bilti_no?: ManualTaxInvoiceItemOutputBiltiNo;
  bilti_date?: ManualTaxInvoiceItemOutputBiltiDate;
  destination?: ManualTaxInvoiceItemOutputDestination;
  pkg?: ManualTaxInvoiceItemOutputPkg;
  weight?: ManualTaxInvoiceItemOutputWeight;
  customer?: ManualTaxInvoiceItemOutputCustomer;
  customer_invoice?: ManualTaxInvoiceItemOutputCustomerInvoice;
  lorry_no?: ManualTaxInvoiceItemOutputLorryNo;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  misc_charge?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  freight?: string;
}

export interface ManualTaxInvoiceList {
  items: ManualTaxInvoiceRead[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

export type ManualTaxInvoiceReadBuyerGstin = string | null;

export type ManualTaxInvoiceReadViaVehicle = string | null;

export type ManualTaxInvoiceReadGoodsDesc = string | null;

export type ManualTaxInvoiceReadAmountInWords = string | null;

export type ManualTaxInvoiceReadTerms = string | null;

export type ManualTaxInvoiceReadBankDetails = string | null;

export interface ManualTaxInvoiceRead {
  id: string;
  invoice_no: string;
  invoice_date: string;
  buyer_gstin: ManualTaxInvoiceReadBuyerGstin;
  buyer_name: string;
  buyer_address: string;
  carrier_gstin: string;
  carrier_address: string;
  items: ManualTaxInvoiceItemOutput[];
  via_vehicle: ManualTaxInvoiceReadViaVehicle;
  goods_desc: ManualTaxInvoiceReadGoodsDesc;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_amount: string;
  amount_in_words: ManualTaxInvoiceReadAmountInWords;
  rcm: boolean;
  terms: ManualTaxInvoiceReadTerms;
  bank_details: ManualTaxInvoiceReadBankDetails;
  created_at: string;
  updated_at: string;
}

export type ManualTaxInvoiceUpdateBuyerGstin = string | null;

export type ManualTaxInvoiceUpdateViaVehicle = string | null;

export type ManualTaxInvoiceUpdateGoodsDesc = string | null;

export type ManualTaxInvoiceUpdateTerms = string | null;

export type ManualTaxInvoiceUpdateBankDetails = string | null;

/**
 * Full-replace payload for editing an existing manual tax invoice (admin-only).

Identical field set to :class:`ManualTaxInvoiceCreate` — every field is
editable, including ``invoice_no``. The edit form submits the complete body.
 */
export interface ManualTaxInvoiceUpdate {
  /**
   * @minLength 1
   * @maxLength 64
   */
  invoice_no: string;
  invoice_date: string;
  buyer_gstin?: ManualTaxInvoiceUpdateBuyerGstin;
  /**
   * @minLength 1
   * @maxLength 256
   */
  buyer_name: string;
  buyer_address?: string;
  /**
   * @minLength 1
   * @maxLength 15
   */
  carrier_gstin: string;
  carrier_address: string;
  /** @minItems 1 */
  items: ManualTaxInvoiceItemInput[];
  via_vehicle?: ManualTaxInvoiceUpdateViaVehicle;
  goods_desc?: ManualTaxInvoiceUpdateGoodsDesc;
  rcm?: boolean;
  terms?: ManualTaxInvoiceUpdateTerms;
  bank_details?: ManualTaxInvoiceUpdateBankDetails;
}

export interface MaterialCreate {
  name: string;
  /** @maxLength 16 */
  hsn_code: string;
  /** @maxLength 128 */
  category: string;
  status?: RecordStatus;
}

export interface MaterialList {
  items: MaterialRead[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

export interface MaterialRead {
  id: string;
  name: string;
  hsn_code: string;
  category: string;
  status: RecordStatus;
  created_at: string;
  updated_at: string;
}

export type MaterialUpdateName = string | null;

export type MaterialUpdateHsnCode = string | null;

export type MaterialUpdateCategory = string | null;

export type MaterialUpdateStatus = RecordStatus | null;

export interface MaterialUpdate {
  name?: MaterialUpdateName;
  hsn_code?: MaterialUpdateHsnCode;
  category?: MaterialUpdateCategory;
  status?: MaterialUpdateStatus;
}

export type MeResponseBranchId = string | null;

export type MeResponseUserId = string | null;

export type MeResponseRole = string | null;

export interface MeResponse {
  sub: string;
  email: string;
  groups: string[];
  branch_id?: MeResponseBranchId;
  user_id?: MeResponseUserId;
  role?: MeResponseRole;
}

export interface OpenInvoiceRow {
  invoice_id: string;
  invoice_no: string;
  invoice_date: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
}

export interface OutstandingResponse {
  as_of: string;
  customers: CustomerOutstandingRow[];
  vendors: VendorOutstandingRow[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_receivable: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total_payable: string;
}

export type PartyCreateGstNumber = string | null;

export type PartyCreateCustomerCode = string | null;

export type PartyCreateEmail = string | null;

export type PartyCreateState = string | null;

export interface PartyCreate {
  role: PartyRole;
  has_gst?: boolean;
  gst_number?: PartyCreateGstNumber;
  customer_code?: PartyCreateCustomerCode;
  name: string;
  email?: PartyCreateEmail;
  address?: string;
  city: string;
  state?: PartyCreateState;
  status?: RecordStatus;
}

export type PartyLedgerResponsePartyGstin = string | null;

/**
 * A date-bounded statement for a single customer party.
 */
export interface PartyLedgerResponse {
  party_id: string;
  party_name: string;
  party_gstin: PartyLedgerResponsePartyGstin;
  from_date: string;
  to_date: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  opening_balance: string;
  rows: PartyLedgerRow[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  closing_balance: string;
}

/**
 * One row of a party-ledger statement (chronological).
 */
export interface PartyLedgerRow {
  date: string;
  kind: string;
  ref_no: string;
  description: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  debit: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  credit: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  balance: string;
}

export interface PartyList {
  items: PartyRead[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

export type PartyReadGstNumber = string | null;

export type PartyReadCustomerCode = string | null;

export type PartyReadEmail = string | null;

export type PartyReadState = string | null;

export interface PartyRead {
  id: string;
  role: PartyRole;
  has_gst: boolean;
  gst_number: PartyReadGstNumber;
  customer_code: PartyReadCustomerCode;
  name: string;
  email: PartyReadEmail;
  address: string;
  city: string;
  state: PartyReadState;
  status: RecordStatus;
  created_at: string;
  updated_at: string;
}

export type PartyRole = typeof PartyRole[keyof typeof PartyRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PartyRole = {
  customer: 'customer',
  vendor: 'vendor',
  both: 'both',
  broker: 'broker',
} as const;

export type PartyUpdateRole = PartyRole | null;

export type PartyUpdateHasGst = boolean | null;

export type PartyUpdateGstNumber = string | null;

export type PartyUpdateCustomerCode = string | null;

export type PartyUpdateName = string | null;

export type PartyUpdateEmail = string | null;

export type PartyUpdateAddress = string | null;

export type PartyUpdateCity = string | null;

export type PartyUpdateState = string | null;

export type PartyUpdateStatus = RecordStatus | null;

export interface PartyUpdate {
  role?: PartyUpdateRole;
  has_gst?: PartyUpdateHasGst;
  gst_number?: PartyUpdateGstNumber;
  customer_code?: PartyUpdateCustomerCode;
  name?: PartyUpdateName;
  email?: PartyUpdateEmail;
  address?: PartyUpdateAddress;
  city?: PartyUpdateCity;
  state?: PartyUpdateState;
  status?: PartyUpdateStatus;
}

export interface PodUploadUrlRequest {
  bilty_id: string;
  content_type: string;
}

export interface PodUploadUrlResponse {
  put_url: string;
  object_key: string;
  expires_in: number;
}

export interface PollSummaryRead {
  trucks: number;
  stored: number;
  failed: number;
  skipped: number;
  results: TruckPollResultRead[];
}

export type ReceiptAllocationInAppliedAmount = number | string;

export interface ReceiptAllocationIn {
  invoice_id: string;
  applied_amount: ReceiptAllocationInAppliedAmount;
}

export interface ReceiptAllocationRead {
  invoice_id: string;
  invoice_no: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  applied_amount: string;
}

export type ReceiptCreateBranchId = string | null;

export type ReceiptCreateAmount = number | string;

export type ReceiptCreateMode = typeof ReceiptCreateMode[keyof typeof ReceiptCreateMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceiptCreateMode = {
  neft: 'neft',
  rtgs: 'rtgs',
  imps: 'imps',
  upi: 'upi',
  cheque: 'cheque',
  cash: 'cash',
} as const;

export type ReceiptCreateRefNo = string | null;

export type ReceiptCreateTdsAmount = number | string;

export type ReceiptCreateShortPayAmount = number | string;

export type ReceiptCreateShortPayReason = string | null;

export type ReceiptCreateNote = string | null;

export type ReceiptCreateAttachmentKey = string | null;

export interface ReceiptCreate {
  party_id: string;
  branch_id?: ReceiptCreateBranchId;
  amount: ReceiptCreateAmount;
  paid_at: string;
  mode: ReceiptCreateMode;
  ref_no?: ReceiptCreateRefNo;
  tds_amount?: ReceiptCreateTdsAmount;
  short_pay_amount?: ReceiptCreateShortPayAmount;
  short_pay_reason?: ReceiptCreateShortPayReason;
  note?: ReceiptCreateNote;
  attachment_key?: ReceiptCreateAttachmentKey;
  allocations?: ReceiptAllocationIn[];
}

export interface ReceiptList {
  items: ReceiptRead[];
  total: number;
  page: number;
  page_size: number;
}

export type ReceiptReadPartyName = string | null;

export type ReceiptReadShortPayReason = string | null;

export type ReceiptReadRefNo = string | null;

export type ReceiptReadNote = string | null;

export type ReceiptReadAttachmentKey = string | null;

export type ReceiptReadCreatedByEmail = string | null;

export interface ReceiptRead {
  id: string;
  branch_id: string;
  party_id: string;
  party_name?: ReceiptReadPartyName;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  tds_amount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  short_pay_amount: string;
  short_pay_reason?: ReceiptReadShortPayReason;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gross_applied: string;
  paid_at: string;
  mode: string;
  ref_no?: ReceiptReadRefNo;
  note?: ReceiptReadNote;
  attachment_key?: ReceiptReadAttachmentKey;
  created_at: string;
  created_by_email?: ReceiptReadCreatedByEmail;
  on_account?: boolean;
  allocations?: ReceiptAllocationRead[];
}

export type RecordStatus = typeof RecordStatus[keyof typeof RecordStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordStatus = {
  active: 'active',
  inactive: 'inactive',
} as const;

export type TollPingReadDirection = string | null;

export type TollPingReadLat = number | null;

export type TollPingReadLon = number | null;

export type TollPingReadCity = string | null;

export type TollPingReadState = string | null;

export interface TollPingRead {
  plaza_name: string;
  crossed_at: string;
  direction?: TollPingReadDirection;
  lat?: TollPingReadLat;
  lon?: TollPingReadLon;
  source: string;
  city?: TollPingReadCity;
  state?: TollPingReadState;
}

export interface TollPlazaList {
  items: TollPlazaListItem[];
  unlabelled: number;
}

export type TollPlazaListItemCity = string | null;

export type TollPlazaListItemState = string | null;

export type TollPlazaListItemLat = number | null;

export type TollPlazaListItemLon = number | null;

export interface TollPlazaListItem {
  id: string;
  plaza_name: string;
  city?: TollPlazaListItemCity;
  state?: TollPlazaListItemState;
  lat?: TollPlazaListItemLat;
  lon?: TollPlazaListItemLon;
  crossings?: number;
}

export type TollPlazaReadCity = string | null;

export type TollPlazaReadState = string | null;

export type TollPlazaReadLat = number | null;

export type TollPlazaReadLon = number | null;

export interface TollPlazaRead {
  id: string;
  plaza_name: string;
  city?: TollPlazaReadCity;
  state?: TollPlazaReadState;
  lat?: TollPlazaReadLat;
  lon?: TollPlazaReadLon;
}

export type TollPlazaUpdateCity = string | null;

export type TollPlazaUpdateState = string | null;

/**
 * Only the human-supplied fields are editable — the name and coordinates
come from the provider and would be overwritten on the next crossing.
 */
export interface TollPlazaUpdate {
  city?: TollPlazaUpdateCity;
  state?: TollPlazaUpdateState;
}

export type TruckCreateOwnerPartyId = string | null;

export type TruckCreateOwnerMobile = string | null;

export type TruckCreateOwnerPan = string | null;

export type TruckCreateBrokerPartyId = string | null;

export type TruckCreateBrokerMobile = string | null;

export type TruckCreateChassisNo = string | null;

export type TruckCreateEngineNo = string | null;

export type TruckCreateRcExpiry = string | null;

export type TruckCreatePucNo = string | null;

export type TruckCreatePucExpiry = string | null;

export type TruckCreateFitnessNo = string | null;

export type TruckCreateFitnessExpiry = string | null;

export type TruckCreateRoadTax = string | null;

export type TruckCreateRoadTaxExpiry = string | null;

export type TruckCreatePermitNo = string | null;

export type TruckCreatePermitExpiry = string | null;

export type TruckCreateInsuranceNo = string | null;

export type TruckCreateInsuranceExpiry = string | null;

export interface TruckCreate {
  /** @maxLength 32 */
  number: string;
  /** @maxLength 64 */
  type: string;
  ownership: TruckOwnership;
  owner_party_id?: TruckCreateOwnerPartyId;
  owner_mobile?: TruckCreateOwnerMobile;
  owner_pan?: TruckCreateOwnerPan;
  broker_party_id?: TruckCreateBrokerPartyId;
  broker_mobile?: TruckCreateBrokerMobile;
  chassis_no?: TruckCreateChassisNo;
  engine_no?: TruckCreateEngineNo;
  rc_expiry?: TruckCreateRcExpiry;
  puc_no?: TruckCreatePucNo;
  puc_expiry?: TruckCreatePucExpiry;
  fitness_no?: TruckCreateFitnessNo;
  fitness_expiry?: TruckCreateFitnessExpiry;
  road_tax?: TruckCreateRoadTax;
  road_tax_expiry?: TruckCreateRoadTaxExpiry;
  permit_no?: TruckCreatePermitNo;
  permit_expiry?: TruckCreatePermitExpiry;
  insurance_no?: TruckCreateInsuranceNo;
  insurance_expiry?: TruckCreateInsuranceExpiry;
  status?: RecordStatus;
}

export interface TruckList {
  items: TruckRead[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

export interface TruckLookupRead {
  truck_number: string;
  fetched_at: string;
  crossings: LookupCrossingRead[];
}

export type TruckOwnership = typeof TruckOwnership[keyof typeof TruckOwnership];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TruckOwnership = {
  hired: 'hired',
  owned: 'owned',
} as const;

export type TruckPollResultReadSkippedReason = string | null;

export type TruckPollResultReadError = string | null;

export interface TruckPollResultRead {
  truck_number: string;
  fetched: number;
  stored: number;
  skipped_reason?: TruckPollResultReadSkippedReason;
  error?: TruckPollResultReadError;
}

export type TruckReadOwnerPartyId = string | null;

export type TruckReadOwnerMobile = string | null;

export type TruckReadOwnerPan = string | null;

export type TruckReadBrokerPartyId = string | null;

export type TruckReadBrokerMobile = string | null;

export type TruckReadChassisNo = string | null;

export type TruckReadEngineNo = string | null;

export type TruckReadRcExpiry = string | null;

export type TruckReadPucNo = string | null;

export type TruckReadPucExpiry = string | null;

export type TruckReadFitnessNo = string | null;

export type TruckReadFitnessExpiry = string | null;

export type TruckReadRoadTax = string | null;

export type TruckReadRoadTaxExpiry = string | null;

export type TruckReadPermitNo = string | null;

export type TruckReadPermitExpiry = string | null;

export type TruckReadInsuranceNo = string | null;

export type TruckReadInsuranceExpiry = string | null;

export interface TruckRead {
  id: string;
  number: string;
  type: string;
  ownership: TruckOwnership;
  owner_party_id: TruckReadOwnerPartyId;
  owner_mobile: TruckReadOwnerMobile;
  owner_pan: TruckReadOwnerPan;
  broker_party_id: TruckReadBrokerPartyId;
  broker_mobile: TruckReadBrokerMobile;
  chassis_no: TruckReadChassisNo;
  engine_no: TruckReadEngineNo;
  rc_expiry: TruckReadRcExpiry;
  puc_no: TruckReadPucNo;
  puc_expiry: TruckReadPucExpiry;
  fitness_no: TruckReadFitnessNo;
  fitness_expiry: TruckReadFitnessExpiry;
  road_tax: TruckReadRoadTax;
  road_tax_expiry: TruckReadRoadTaxExpiry;
  permit_no: TruckReadPermitNo;
  permit_expiry: TruckReadPermitExpiry;
  insurance_no: TruckReadInsuranceNo;
  insurance_expiry: TruckReadInsuranceExpiry;
  status: RecordStatus;
  created_at: string;
  updated_at: string;
}

export type TruckUpdateNumber = string | null;

export type TruckUpdateType = string | null;

export type TruckUpdateOwnership = TruckOwnership | null;

export type TruckUpdateOwnerPartyId = string | null;

export type TruckUpdateOwnerMobile = string | null;

export type TruckUpdateOwnerPan = string | null;

export type TruckUpdateBrokerPartyId = string | null;

export type TruckUpdateBrokerMobile = string | null;

export type TruckUpdateChassisNo = string | null;

export type TruckUpdateEngineNo = string | null;

export type TruckUpdateRcExpiry = string | null;

export type TruckUpdatePucNo = string | null;

export type TruckUpdatePucExpiry = string | null;

export type TruckUpdateFitnessNo = string | null;

export type TruckUpdateFitnessExpiry = string | null;

export type TruckUpdateRoadTax = string | null;

export type TruckUpdateRoadTaxExpiry = string | null;

export type TruckUpdatePermitNo = string | null;

export type TruckUpdatePermitExpiry = string | null;

export type TruckUpdateInsuranceNo = string | null;

export type TruckUpdateInsuranceExpiry = string | null;

export type TruckUpdateStatus = RecordStatus | null;

export interface TruckUpdate {
  number?: TruckUpdateNumber;
  type?: TruckUpdateType;
  ownership?: TruckUpdateOwnership;
  owner_party_id?: TruckUpdateOwnerPartyId;
  owner_mobile?: TruckUpdateOwnerMobile;
  owner_pan?: TruckUpdateOwnerPan;
  broker_party_id?: TruckUpdateBrokerPartyId;
  broker_mobile?: TruckUpdateBrokerMobile;
  chassis_no?: TruckUpdateChassisNo;
  engine_no?: TruckUpdateEngineNo;
  rc_expiry?: TruckUpdateRcExpiry;
  puc_no?: TruckUpdatePucNo;
  puc_expiry?: TruckUpdatePucExpiry;
  fitness_no?: TruckUpdateFitnessNo;
  fitness_expiry?: TruckUpdateFitnessExpiry;
  road_tax?: TruckUpdateRoadTax;
  road_tax_expiry?: TruckUpdateRoadTaxExpiry;
  permit_no?: TruckUpdatePermitNo;
  permit_expiry?: TruckUpdatePermitExpiry;
  insurance_no?: TruckUpdateInsuranceNo;
  insurance_expiry?: TruckUpdateInsuranceExpiry;
  status?: TruckUpdateStatus;
}

export type UserAdminUpdateFirstName = string | null;

export type UserAdminUpdateLastName = string | null;

export type UserAdminUpdatePhone = string | null;

export type UserAdminUpdateAvatarUrl = string | null;

export type UserAdminUpdateDesignation = string | null;

export type UserAdminUpdateEmail = string | null;

export type UserAdminUpdateCognitoSub = string | null;

export type UserAdminUpdateRole = UserRole | null;

export type UserAdminUpdateBranchId = string | null;

export type UserAdminUpdateStatus = RecordStatus | null;

/**
 * Admin PATCH /users/{id}: profile fields plus governance.
 */
export interface UserAdminUpdate {
  first_name?: UserAdminUpdateFirstName;
  last_name?: UserAdminUpdateLastName;
  phone?: UserAdminUpdatePhone;
  avatar_url?: UserAdminUpdateAvatarUrl;
  designation?: UserAdminUpdateDesignation;
  email?: UserAdminUpdateEmail;
  cognito_sub?: UserAdminUpdateCognitoSub;
  role?: UserAdminUpdateRole;
  branch_id?: UserAdminUpdateBranchId;
  status?: UserAdminUpdateStatus;
}

export interface UserCreate {
  /** @maxLength 320 */
  email: string;
  /** @maxLength 128 */
  cognito_sub: string;
  role: UserRole;
  branch_id: string;
  status?: RecordStatus;
}

export interface UserList {
  items: UserRead[];
  total: number;
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  page_size: number;
}

export type UserMeUpdateFirstName = string | null;

export type UserMeUpdateLastName = string | null;

export type UserMeUpdatePhone = string | null;

export type UserMeUpdateAvatarUrl = string | null;

export type UserMeUpdateDesignation = string | null;

/**
 * Self-service: editable profile fields only (no role / branch / status).
 */
export interface UserMeUpdate {
  first_name?: UserMeUpdateFirstName;
  last_name?: UserMeUpdateLastName;
  phone?: UserMeUpdatePhone;
  avatar_url?: UserMeUpdateAvatarUrl;
  designation?: UserMeUpdateDesignation;
}

export type UserReadFirstName = string | null;

export type UserReadLastName = string | null;

export type UserReadPhone = string | null;

export type UserReadAvatarUrl = string | null;

export type UserReadDesignation = string | null;

export type UserReadLastLoginAt = string | null;

export type UserReadBranchName = string | null;

export interface UserRead {
  id: string;
  email: string;
  cognito_sub: string;
  role: UserRole;
  branch_id: string;
  status: RecordStatus;
  first_name?: UserReadFirstName;
  last_name?: UserReadLastName;
  phone?: UserReadPhone;
  avatar_url?: UserReadAvatarUrl;
  designation?: UserReadDesignation;
  last_login_at?: UserReadLastLoginAt;
  branch_name?: UserReadBranchName;
  created_at: string;
  updated_at: string;
}

export type UserRole = typeof UserRole[keyof typeof UserRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRole = {
  admin: 'admin',
  user: 'user',
} as const;

export type ValidationErrorLocItem = string | number;

export type ValidationErrorCtx = { [key: string]: unknown };

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
  input?: unknown;
  ctx?: ValidationErrorCtx;
}

/**
 * A date-bounded statement for a single vendor (truck-owner party).
 */
export interface VendorLedgerResponse {
  vendor_id: string;
  vendor_name: string;
  from_date: string;
  to_date: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  opening_balance: string;
  rows: VendorLedgerRow[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  closing_balance: string;
}

/**
 * One row of a vendor-ledger statement (chronological).
 */
export interface VendorLedgerRow {
  date: string;
  kind: string;
  ref_no: string;
  description: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  debit: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  credit: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  balance: string;
}

export type VendorOutstandingRowPartyId = string | null;

export interface VendorOutstandingRow {
  party_id: VendorOutstandingRowPartyId;
  party_name: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  hire_total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
  open_lhcs: number;
}

export type VendorPaymentCreateAmount = number | string;

export type VendorPaymentCreateMode = typeof VendorPaymentCreateMode[keyof typeof VendorPaymentCreateMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorPaymentCreateMode = {
  neft: 'neft',
  rtgs: 'rtgs',
  imps: 'imps',
  upi: 'upi',
  cheque: 'cheque',
  cash: 'cash',
} as const;

export type VendorPaymentCreateRefNo = string | null;

export type VendorPaymentCreateNote = string | null;

export type VendorPaymentCreateAttachmentKey = string | null;

/**
 * A balance payment to the lorry owner against one LHC.

The advance is not recorded here — it is agreed on the contract and lives
on the LHC itself (`advance_amount` + `advance_ref_no` / `advance_paid_on`).
 */
export interface VendorPaymentCreate {
  amount: VendorPaymentCreateAmount;
  paid_at: string;
  mode: VendorPaymentCreateMode;
  ref_no?: VendorPaymentCreateRefNo;
  note?: VendorPaymentCreateNote;
  attachment_key?: VendorPaymentCreateAttachmentKey;
  settle?: boolean;
}

export type VendorPaymentReadRefNo = string | null;

export type VendorPaymentReadNote = string | null;

export type VendorPaymentReadAttachmentKey = string | null;

export interface VendorPaymentRead {
  id: string;
  kind: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  paid_at: string;
  mode: string;
  ref_no?: VendorPaymentReadRefNo;
  note?: VendorPaymentReadNote;
  attachment_key?: VendorPaymentReadAttachmentKey;
  created_at: string;
}

export interface WaSessionCreate {
  /**
   * @minLength 1
   * @maxLength 80
   */
  label: string;
}

export interface WaSessionList {
  items: WaSessionRead[];
}

export type WaSessionQrQr = string | null;

/**
 * The live QR to render. Rotates roughly every 20s while pending.
 */
export interface WaSessionQr {
  session_id: string;
  status: string;
  qr?: WaSessionQrQr;
}

export type WaSessionReadPhoneNumber = string | null;

export type WaSessionReadLinkedAt = string | null;

export type WaSessionReadLastError = string | null;

export interface WaSessionRead {
  id: string;
  label: string;
  status: string;
  phone_number?: WaSessionReadPhoneNumber;
  linked_at?: WaSessionReadLinkedAt;
  last_error?: WaSessionReadLastError;
  created_at: string;
}

export type LoginApiAuthLoginPost200 = {[key: string]: boolean};

export type RefreshApiAuthRefreshPost200 = {[key: string]: boolean};

export type LogoutApiAuthLogoutPost200 = {[key: string]: boolean};

export type ListBranchesApiBranchesGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
q?: string | null;
status?: RecordStatus | null;
};

export type ListUsersApiUsersGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
q?: string | null;
status?: RecordStatus | null;
};

export type ListPartiesApiPartiesGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
q?: string | null;
status?: RecordStatus | null;
role?: PartyRole | null;
};

export type ListTrucksApiTrucksGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
q?: string | null;
status?: RecordStatus | null;
};

export type ListDriversApiDriversGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
q?: string | null;
status?: RecordStatus | null;
};

export type ListMaterialsApiMaterialsGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
q?: string | null;
status?: RecordStatus | null;
};

export type ListBiltyApiBiltyGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
status?: string | null;
q?: string | null;
include_cancelled?: boolean;
party_id?: string | null;
unbilled?: boolean;
unchallaned?: boolean;
challanable?: boolean;
from_date?: string | null;
to_date?: string | null;
};

export type BiltySummaryApiBiltySummaryGetParams = {
status?: string | null;
q?: string | null;
party_id?: string | null;
from_date?: string | null;
to_date?: string | null;
};

export type ExportBiltiesCsvApiBiltyExportCsvGetParams = {
status?: string | null;
q?: string | null;
party_id?: string | null;
from_date?: string | null;
to_date?: string | null;
};

export type BiltyPdfGetApiBiltyBiltyIdPdfGetParams = {
copy?: string | null;
};

export type BiltyPdfPostApiBiltyBiltyIdPdfPostParams = {
copy?: string | null;
};

export type ListLoadingSlipsApiLoadingSlipsGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
status?: string | null;
fy?: number | null;
q?: string | null;
without_lhc?: boolean;
};

export type CreateLoadingSlipApiLoadingSlipsPost201 = {[key: string]: string | string};

export type LinkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPost201 = {[key: string]: string};

export type UnlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDelete200 = {[key: string]: string};

export type CreateOrUpdateDeliveryMemoApiDeliveryMemosPost201 = {[key: string]: string};

export type ListInvoicesApiInvoicesGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
status?: string | null;
fy?: number | null;
q?: string | null;
};

export type CreateInvoiceApiInvoicesPost201 = {[key: string]: string};

export type LinkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPost201 = {[key: string]: string};

export type ListLhcsApiLorryHireChallansGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
status?: string | null;
q?: string | null;
};

export type LookupTruckApiTrackLookupGetParams = {
/**
 * @minLength 1
 * @maxLength 32
 */
truck_number: string;
};

export type GetBilty360ApiReportsBilty360GetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
fy_start_year?: number | null;
party_id?: string | null;
vendor_id?: string | null;
route_q?: string | null;
month?: number | null;
chain_status?: string | null;
bilty_status?: string | null;
};

export type GetDocumentDistributionApiReportsDocumentDistributionGetParams = {
/**
 * @minimum 2000
 * @maximum 2100
 */
fy_start_year: number;
};

export type PartyLedgerApiLedgersPartyPartyIdGetParams = {
/**
 * Inclusive start
 */
from_date: string;
/**
 * Inclusive end
 */
to_date: string;
};

export type VendorLedgerApiLedgersVendorVendorIdGetParams = {
/**
 * Inclusive start
 */
from_date: string;
/**
 * Inclusive end
 */
to_date: string;
};

export type BranchPlApiLedgersBranchPlGetParams = {
from_date: string;
to_date: string;
/**
 * Admin: omit for consolidated
 */
branch_id?: string | null;
};

export type PartyLedgerPdfApiLedgersPartyPartyIdPdfGetParams = {
from_date: string;
to_date: string;
};

export type VendorLedgerPdfApiLedgersVendorVendorIdPdfGetParams = {
from_date: string;
to_date: string;
};

export type BranchPlPdfApiLedgersBranchPlPdfGetParams = {
from_date: string;
to_date: string;
branch_id?: string | null;
};

export type ListReceiptsApiPaymentsReceiptsGetParams = {
party_id?: string | null;
from_date?: string | null;
to_date?: string | null;
q?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
};

export type OpenInvoicesApiPaymentsOpenInvoicesGetParams = {
party_id: string;
};

export type OutstandingApiPaymentsOutstandingGetParams = {
as_of?: string | null;
};

export type AttachmentRedirectApiPaymentsAttachmentGetParams = {
key: string;
};

export type ListCategoriesApiCashBookCategoriesGetParams = {
q?: string | null;
};

export type ListExpensesApiCashBookExpensesGetParams = {
from_date?: string | null;
to_date?: string | null;
category_id?: string | null;
bilty_id?: string | null;
kind?: string | null;
q?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
};

export type SummaryApiCashBookSummaryGetParams = {
from_date: string;
to_date: string;
};

export type Gstr1JsonApiGstGstr1GetParams = {
/**
 * Calendar month, e.g. '2026-05'
 */
yyyy_mm: string;
branch_id?: string | null;
};

export type Gstr1PdfApiGstGstr1PdfGetParams = {
yyyy_mm: string;
branch_id?: string | null;
};

export type Gstr1GstnUploadApiGstGstr1GstnUploadGetParams = {
yyyy_mm: string;
branch_id?: string | null;
};

export type Gstr3bJsonApiGstGstr3bGetParams = {
/**
 * Calendar month, e.g. '2026-05'
 */
yyyy_mm: string;
branch_id?: string | null;
};

export type Gstr3bPdfApiGstGstr3bPdfGetParams = {
yyyy_mm: string;
branch_id?: string | null;
};

export type ListManualTaxInvoicesApiManualTaxInvoicesGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
page_size?: number;
q?: string | null;
};

/**
 * @summary Login
 */
export type loginApiAuthLoginPostResponse200 = {
  data: LoginApiAuthLoginPost200
  status: 200
}

export type loginApiAuthLoginPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type loginApiAuthLoginPostResponseSuccess = (loginApiAuthLoginPostResponse200) & {
  headers: Headers;
};
export type loginApiAuthLoginPostResponseError = (loginApiAuthLoginPostResponse422) & {
  headers: Headers;
};

export type loginApiAuthLoginPostResponse = (loginApiAuthLoginPostResponseSuccess | loginApiAuthLoginPostResponseError)

export const getLoginApiAuthLoginPostUrl = () => {


  

  return `/api/auth/login`
}

export const loginApiAuthLoginPost = async (loginBody: LoginBody, options?: RequestInit): Promise<loginApiAuthLoginPostResponse> => {
  
  return customFetch<loginApiAuthLoginPostResponse>(getLoginApiAuthLoginPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      loginBody,)
  }
);}



/**
 * Exchange the refresh-token cookie for fresh id/access tokens.
 * @summary Refresh
 */
export type refreshApiAuthRefreshPostResponse200 = {
  data: RefreshApiAuthRefreshPost200
  status: 200
}

export type refreshApiAuthRefreshPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type refreshApiAuthRefreshPostResponseSuccess = (refreshApiAuthRefreshPostResponse200) & {
  headers: Headers;
};
export type refreshApiAuthRefreshPostResponseError = (refreshApiAuthRefreshPostResponse422) & {
  headers: Headers;
};

export type refreshApiAuthRefreshPostResponse = (refreshApiAuthRefreshPostResponseSuccess | refreshApiAuthRefreshPostResponseError)

export const getRefreshApiAuthRefreshPostUrl = () => {


  

  return `/api/auth/refresh`
}

export const refreshApiAuthRefreshPost = async ( options?: RequestInit): Promise<refreshApiAuthRefreshPostResponse> => {
  
  return customFetch<refreshApiAuthRefreshPostResponse>(getRefreshApiAuthRefreshPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Logout
 */
export type logoutApiAuthLogoutPostResponse200 = {
  data: LogoutApiAuthLogoutPost200
  status: 200
}
    
export type logoutApiAuthLogoutPostResponseSuccess = (logoutApiAuthLogoutPostResponse200) & {
  headers: Headers;
};
;

export type logoutApiAuthLogoutPostResponse = (logoutApiAuthLogoutPostResponseSuccess)

export const getLogoutApiAuthLogoutPostUrl = () => {


  

  return `/api/auth/logout`
}

export const logoutApiAuthLogoutPost = async ( options?: RequestInit): Promise<logoutApiAuthLogoutPostResponse> => {
  
  return customFetch<logoutApiAuthLogoutPostResponse>(getLogoutApiAuthLogoutPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Me
 */
export type meApiAuthMeGetResponse200 = {
  data: MeResponse
  status: 200
}
    
export type meApiAuthMeGetResponseSuccess = (meApiAuthMeGetResponse200) & {
  headers: Headers;
};
;

export type meApiAuthMeGetResponse = (meApiAuthMeGetResponseSuccess)

export const getMeApiAuthMeGetUrl = () => {


  

  return `/api/auth/me`
}

export const meApiAuthMeGet = async ( options?: RequestInit): Promise<meApiAuthMeGetResponse> => {
  
  return customFetch<meApiAuthMeGetResponse>(getMeApiAuthMeGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Health
 */
export type healthApiHealthGetResponse200 = {
  data: HealthResponse
  status: 200
}
    
export type healthApiHealthGetResponseSuccess = (healthApiHealthGetResponse200) & {
  headers: Headers;
};
;

export type healthApiHealthGetResponse = (healthApiHealthGetResponseSuccess)

export const getHealthApiHealthGetUrl = () => {


  

  return `/api/health`
}

export const healthApiHealthGet = async ( options?: RequestInit): Promise<healthApiHealthGetResponse> => {
  
  return customFetch<healthApiHealthGetResponse>(getHealthApiHealthGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Deep Health
 */
export type deepHealthApiHealthDeepGetResponse200 = {
  data: DeepHealthResponse
  status: 200
}
    
export type deepHealthApiHealthDeepGetResponseSuccess = (deepHealthApiHealthDeepGetResponse200) & {
  headers: Headers;
};
;

export type deepHealthApiHealthDeepGetResponse = (deepHealthApiHealthDeepGetResponseSuccess)

export const getDeepHealthApiHealthDeepGetUrl = () => {


  

  return `/api/health/deep`
}

export const deepHealthApiHealthDeepGet = async ( options?: RequestInit): Promise<deepHealthApiHealthDeepGetResponse> => {
  
  return customFetch<deepHealthApiHealthDeepGetResponse>(getDeepHealthApiHealthDeepGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Branches
 */
export type listBranchesApiBranchesGetResponse200 = {
  data: BranchList
  status: 200
}

export type listBranchesApiBranchesGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listBranchesApiBranchesGetResponseSuccess = (listBranchesApiBranchesGetResponse200) & {
  headers: Headers;
};
export type listBranchesApiBranchesGetResponseError = (listBranchesApiBranchesGetResponse422) & {
  headers: Headers;
};

export type listBranchesApiBranchesGetResponse = (listBranchesApiBranchesGetResponseSuccess | listBranchesApiBranchesGetResponseError)

export const getListBranchesApiBranchesGetUrl = (params?: ListBranchesApiBranchesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/branches/?${stringifiedParams}` : `/api/branches/`
}

export const listBranchesApiBranchesGet = async (params?: ListBranchesApiBranchesGetParams, options?: RequestInit): Promise<listBranchesApiBranchesGetResponse> => {
  
  return customFetch<listBranchesApiBranchesGetResponse>(getListBranchesApiBranchesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Branch
 */
export type createBranchApiBranchesPostResponse201 = {
  data: BranchRead
  status: 201
}

export type createBranchApiBranchesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createBranchApiBranchesPostResponseSuccess = (createBranchApiBranchesPostResponse201) & {
  headers: Headers;
};
export type createBranchApiBranchesPostResponseError = (createBranchApiBranchesPostResponse422) & {
  headers: Headers;
};

export type createBranchApiBranchesPostResponse = (createBranchApiBranchesPostResponseSuccess | createBranchApiBranchesPostResponseError)

export const getCreateBranchApiBranchesPostUrl = () => {


  

  return `/api/branches/`
}

export const createBranchApiBranchesPost = async (branchCreate: BranchCreate, options?: RequestInit): Promise<createBranchApiBranchesPostResponse> => {
  
  return customFetch<createBranchApiBranchesPostResponse>(getCreateBranchApiBranchesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      branchCreate,)
  }
);}



/**
 * @summary Get Branch
 */
export type getBranchApiBranchesBranchIdGetResponse200 = {
  data: BranchRead
  status: 200
}

export type getBranchApiBranchesBranchIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getBranchApiBranchesBranchIdGetResponseSuccess = (getBranchApiBranchesBranchIdGetResponse200) & {
  headers: Headers;
};
export type getBranchApiBranchesBranchIdGetResponseError = (getBranchApiBranchesBranchIdGetResponse422) & {
  headers: Headers;
};

export type getBranchApiBranchesBranchIdGetResponse = (getBranchApiBranchesBranchIdGetResponseSuccess | getBranchApiBranchesBranchIdGetResponseError)

export const getGetBranchApiBranchesBranchIdGetUrl = (branchId: string,) => {


  

  return `/api/branches/${branchId}`
}

export const getBranchApiBranchesBranchIdGet = async (branchId: string, options?: RequestInit): Promise<getBranchApiBranchesBranchIdGetResponse> => {
  
  return customFetch<getBranchApiBranchesBranchIdGetResponse>(getGetBranchApiBranchesBranchIdGetUrl(branchId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Branch
 */
export type updateBranchApiBranchesBranchIdPatchResponse200 = {
  data: BranchRead
  status: 200
}

export type updateBranchApiBranchesBranchIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updateBranchApiBranchesBranchIdPatchResponseSuccess = (updateBranchApiBranchesBranchIdPatchResponse200) & {
  headers: Headers;
};
export type updateBranchApiBranchesBranchIdPatchResponseError = (updateBranchApiBranchesBranchIdPatchResponse422) & {
  headers: Headers;
};

export type updateBranchApiBranchesBranchIdPatchResponse = (updateBranchApiBranchesBranchIdPatchResponseSuccess | updateBranchApiBranchesBranchIdPatchResponseError)

export const getUpdateBranchApiBranchesBranchIdPatchUrl = (branchId: string,) => {


  

  return `/api/branches/${branchId}`
}

export const updateBranchApiBranchesBranchIdPatch = async (branchId: string,
    branchUpdate: BranchUpdate, options?: RequestInit): Promise<updateBranchApiBranchesBranchIdPatchResponse> => {
  
  return customFetch<updateBranchApiBranchesBranchIdPatchResponse>(getUpdateBranchApiBranchesBranchIdPatchUrl(branchId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      branchUpdate,)
  }
);}



/**
 * @summary Delete Branch
 */
export type deleteBranchApiBranchesBranchIdDeleteResponse200 = {
  data: BranchRead
  status: 200
}

export type deleteBranchApiBranchesBranchIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteBranchApiBranchesBranchIdDeleteResponseSuccess = (deleteBranchApiBranchesBranchIdDeleteResponse200) & {
  headers: Headers;
};
export type deleteBranchApiBranchesBranchIdDeleteResponseError = (deleteBranchApiBranchesBranchIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteBranchApiBranchesBranchIdDeleteResponse = (deleteBranchApiBranchesBranchIdDeleteResponseSuccess | deleteBranchApiBranchesBranchIdDeleteResponseError)

export const getDeleteBranchApiBranchesBranchIdDeleteUrl = (branchId: string,) => {


  

  return `/api/branches/${branchId}`
}

export const deleteBranchApiBranchesBranchIdDelete = async (branchId: string, options?: RequestInit): Promise<deleteBranchApiBranchesBranchIdDeleteResponse> => {
  
  return customFetch<deleteBranchApiBranchesBranchIdDeleteResponse>(getDeleteBranchApiBranchesBranchIdDeleteUrl(branchId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Get Company Profile
 */
export type getCompanyProfileApiCompanyProfileGetResponse200 = {
  data: CompanyProfileRead
  status: 200
}
    
export type getCompanyProfileApiCompanyProfileGetResponseSuccess = (getCompanyProfileApiCompanyProfileGetResponse200) & {
  headers: Headers;
};
;

export type getCompanyProfileApiCompanyProfileGetResponse = (getCompanyProfileApiCompanyProfileGetResponseSuccess)

export const getGetCompanyProfileApiCompanyProfileGetUrl = () => {


  

  return `/api/company-profile/`
}

export const getCompanyProfileApiCompanyProfileGet = async ( options?: RequestInit): Promise<getCompanyProfileApiCompanyProfileGetResponse> => {
  
  return customFetch<getCompanyProfileApiCompanyProfileGetResponse>(getGetCompanyProfileApiCompanyProfileGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Replace Company Profile
 */
export type replaceCompanyProfileApiCompanyProfilePutResponse200 = {
  data: CompanyProfileRead
  status: 200
}

export type replaceCompanyProfileApiCompanyProfilePutResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type replaceCompanyProfileApiCompanyProfilePutResponseSuccess = (replaceCompanyProfileApiCompanyProfilePutResponse200) & {
  headers: Headers;
};
export type replaceCompanyProfileApiCompanyProfilePutResponseError = (replaceCompanyProfileApiCompanyProfilePutResponse422) & {
  headers: Headers;
};

export type replaceCompanyProfileApiCompanyProfilePutResponse = (replaceCompanyProfileApiCompanyProfilePutResponseSuccess | replaceCompanyProfileApiCompanyProfilePutResponseError)

export const getReplaceCompanyProfileApiCompanyProfilePutUrl = () => {


  

  return `/api/company-profile/`
}

export const replaceCompanyProfileApiCompanyProfilePut = async (companyProfileUpdate: CompanyProfileUpdate, options?: RequestInit): Promise<replaceCompanyProfileApiCompanyProfilePutResponse> => {
  
  return customFetch<replaceCompanyProfileApiCompanyProfilePutResponse>(getReplaceCompanyProfileApiCompanyProfilePutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      companyProfileUpdate,)
  }
);}



/**
 * @summary Get Me
 */
export type getMeApiUsersMeGetResponse200 = {
  data: UserRead
  status: 200
}
    
export type getMeApiUsersMeGetResponseSuccess = (getMeApiUsersMeGetResponse200) & {
  headers: Headers;
};
;

export type getMeApiUsersMeGetResponse = (getMeApiUsersMeGetResponseSuccess)

export const getGetMeApiUsersMeGetUrl = () => {


  

  return `/api/users/me`
}

export const getMeApiUsersMeGet = async ( options?: RequestInit): Promise<getMeApiUsersMeGetResponse> => {
  
  return customFetch<getMeApiUsersMeGetResponse>(getGetMeApiUsersMeGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Me
 */
export type updateMeApiUsersMePatchResponse200 = {
  data: UserRead
  status: 200
}

export type updateMeApiUsersMePatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updateMeApiUsersMePatchResponseSuccess = (updateMeApiUsersMePatchResponse200) & {
  headers: Headers;
};
export type updateMeApiUsersMePatchResponseError = (updateMeApiUsersMePatchResponse422) & {
  headers: Headers;
};

export type updateMeApiUsersMePatchResponse = (updateMeApiUsersMePatchResponseSuccess | updateMeApiUsersMePatchResponseError)

export const getUpdateMeApiUsersMePatchUrl = () => {


  

  return `/api/users/me`
}

export const updateMeApiUsersMePatch = async (userMeUpdate: UserMeUpdate, options?: RequestInit): Promise<updateMeApiUsersMePatchResponse> => {
  
  return customFetch<updateMeApiUsersMePatchResponse>(getUpdateMeApiUsersMePatchUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userMeUpdate,)
  }
);}



/**
 * @summary List Users
 */
export type listUsersApiUsersGetResponse200 = {
  data: UserList
  status: 200
}

export type listUsersApiUsersGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listUsersApiUsersGetResponseSuccess = (listUsersApiUsersGetResponse200) & {
  headers: Headers;
};
export type listUsersApiUsersGetResponseError = (listUsersApiUsersGetResponse422) & {
  headers: Headers;
};

export type listUsersApiUsersGetResponse = (listUsersApiUsersGetResponseSuccess | listUsersApiUsersGetResponseError)

export const getListUsersApiUsersGetUrl = (params?: ListUsersApiUsersGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/?${stringifiedParams}` : `/api/users/`
}

export const listUsersApiUsersGet = async (params?: ListUsersApiUsersGetParams, options?: RequestInit): Promise<listUsersApiUsersGetResponse> => {
  
  return customFetch<listUsersApiUsersGetResponse>(getListUsersApiUsersGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create User
 */
export type createUserApiUsersPostResponse201 = {
  data: UserRead
  status: 201
}

export type createUserApiUsersPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createUserApiUsersPostResponseSuccess = (createUserApiUsersPostResponse201) & {
  headers: Headers;
};
export type createUserApiUsersPostResponseError = (createUserApiUsersPostResponse422) & {
  headers: Headers;
};

export type createUserApiUsersPostResponse = (createUserApiUsersPostResponseSuccess | createUserApiUsersPostResponseError)

export const getCreateUserApiUsersPostUrl = () => {


  

  return `/api/users/`
}

export const createUserApiUsersPost = async (userCreate: UserCreate, options?: RequestInit): Promise<createUserApiUsersPostResponse> => {
  
  return customFetch<createUserApiUsersPostResponse>(getCreateUserApiUsersPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userCreate,)
  }
);}



/**
 * @summary Get User
 */
export type getUserApiUsersUserIdGetResponse200 = {
  data: UserRead
  status: 200
}

export type getUserApiUsersUserIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getUserApiUsersUserIdGetResponseSuccess = (getUserApiUsersUserIdGetResponse200) & {
  headers: Headers;
};
export type getUserApiUsersUserIdGetResponseError = (getUserApiUsersUserIdGetResponse422) & {
  headers: Headers;
};

export type getUserApiUsersUserIdGetResponse = (getUserApiUsersUserIdGetResponseSuccess | getUserApiUsersUserIdGetResponseError)

export const getGetUserApiUsersUserIdGetUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const getUserApiUsersUserIdGet = async (userId: string, options?: RequestInit): Promise<getUserApiUsersUserIdGetResponse> => {
  
  return customFetch<getUserApiUsersUserIdGetResponse>(getGetUserApiUsersUserIdGetUrl(userId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Admin Update User
 */
export type adminUpdateUserApiUsersUserIdPatchResponse200 = {
  data: UserRead
  status: 200
}

export type adminUpdateUserApiUsersUserIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type adminUpdateUserApiUsersUserIdPatchResponseSuccess = (adminUpdateUserApiUsersUserIdPatchResponse200) & {
  headers: Headers;
};
export type adminUpdateUserApiUsersUserIdPatchResponseError = (adminUpdateUserApiUsersUserIdPatchResponse422) & {
  headers: Headers;
};

export type adminUpdateUserApiUsersUserIdPatchResponse = (adminUpdateUserApiUsersUserIdPatchResponseSuccess | adminUpdateUserApiUsersUserIdPatchResponseError)

export const getAdminUpdateUserApiUsersUserIdPatchUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const adminUpdateUserApiUsersUserIdPatch = async (userId: string,
    userAdminUpdate: UserAdminUpdate, options?: RequestInit): Promise<adminUpdateUserApiUsersUserIdPatchResponse> => {
  
  return customFetch<adminUpdateUserApiUsersUserIdPatchResponse>(getAdminUpdateUserApiUsersUserIdPatchUrl(userId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userAdminUpdate,)
  }
);}



/**
 * @summary Delete User
 */
export type deleteUserApiUsersUserIdDeleteResponse200 = {
  data: UserRead
  status: 200
}

export type deleteUserApiUsersUserIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteUserApiUsersUserIdDeleteResponseSuccess = (deleteUserApiUsersUserIdDeleteResponse200) & {
  headers: Headers;
};
export type deleteUserApiUsersUserIdDeleteResponseError = (deleteUserApiUsersUserIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteUserApiUsersUserIdDeleteResponse = (deleteUserApiUsersUserIdDeleteResponseSuccess | deleteUserApiUsersUserIdDeleteResponseError)

export const getDeleteUserApiUsersUserIdDeleteUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const deleteUserApiUsersUserIdDelete = async (userId: string, options?: RequestInit): Promise<deleteUserApiUsersUserIdDeleteResponse> => {
  
  return customFetch<deleteUserApiUsersUserIdDeleteResponse>(getDeleteUserApiUsersUserIdDeleteUrl(userId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Parties
 */
export type listPartiesApiPartiesGetResponse200 = {
  data: PartyList
  status: 200
}

export type listPartiesApiPartiesGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listPartiesApiPartiesGetResponseSuccess = (listPartiesApiPartiesGetResponse200) & {
  headers: Headers;
};
export type listPartiesApiPartiesGetResponseError = (listPartiesApiPartiesGetResponse422) & {
  headers: Headers;
};

export type listPartiesApiPartiesGetResponse = (listPartiesApiPartiesGetResponseSuccess | listPartiesApiPartiesGetResponseError)

export const getListPartiesApiPartiesGetUrl = (params?: ListPartiesApiPartiesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/parties/?${stringifiedParams}` : `/api/parties/`
}

export const listPartiesApiPartiesGet = async (params?: ListPartiesApiPartiesGetParams, options?: RequestInit): Promise<listPartiesApiPartiesGetResponse> => {
  
  return customFetch<listPartiesApiPartiesGetResponse>(getListPartiesApiPartiesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Party
 */
export type createPartyApiPartiesPostResponse201 = {
  data: PartyRead
  status: 201
}

export type createPartyApiPartiesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createPartyApiPartiesPostResponseSuccess = (createPartyApiPartiesPostResponse201) & {
  headers: Headers;
};
export type createPartyApiPartiesPostResponseError = (createPartyApiPartiesPostResponse422) & {
  headers: Headers;
};

export type createPartyApiPartiesPostResponse = (createPartyApiPartiesPostResponseSuccess | createPartyApiPartiesPostResponseError)

export const getCreatePartyApiPartiesPostUrl = () => {


  

  return `/api/parties/`
}

export const createPartyApiPartiesPost = async (partyCreate: PartyCreate, options?: RequestInit): Promise<createPartyApiPartiesPostResponse> => {
  
  return customFetch<createPartyApiPartiesPostResponse>(getCreatePartyApiPartiesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partyCreate,)
  }
);}



/**
 * @summary Get Party
 */
export type getPartyApiPartiesPartyIdGetResponse200 = {
  data: PartyRead
  status: 200
}

export type getPartyApiPartiesPartyIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getPartyApiPartiesPartyIdGetResponseSuccess = (getPartyApiPartiesPartyIdGetResponse200) & {
  headers: Headers;
};
export type getPartyApiPartiesPartyIdGetResponseError = (getPartyApiPartiesPartyIdGetResponse422) & {
  headers: Headers;
};

export type getPartyApiPartiesPartyIdGetResponse = (getPartyApiPartiesPartyIdGetResponseSuccess | getPartyApiPartiesPartyIdGetResponseError)

export const getGetPartyApiPartiesPartyIdGetUrl = (partyId: string,) => {


  

  return `/api/parties/${partyId}`
}

export const getPartyApiPartiesPartyIdGet = async (partyId: string, options?: RequestInit): Promise<getPartyApiPartiesPartyIdGetResponse> => {
  
  return customFetch<getPartyApiPartiesPartyIdGetResponse>(getGetPartyApiPartiesPartyIdGetUrl(partyId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Party
 */
export type updatePartyApiPartiesPartyIdPatchResponse200 = {
  data: PartyRead
  status: 200
}

export type updatePartyApiPartiesPartyIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updatePartyApiPartiesPartyIdPatchResponseSuccess = (updatePartyApiPartiesPartyIdPatchResponse200) & {
  headers: Headers;
};
export type updatePartyApiPartiesPartyIdPatchResponseError = (updatePartyApiPartiesPartyIdPatchResponse422) & {
  headers: Headers;
};

export type updatePartyApiPartiesPartyIdPatchResponse = (updatePartyApiPartiesPartyIdPatchResponseSuccess | updatePartyApiPartiesPartyIdPatchResponseError)

export const getUpdatePartyApiPartiesPartyIdPatchUrl = (partyId: string,) => {


  

  return `/api/parties/${partyId}`
}

export const updatePartyApiPartiesPartyIdPatch = async (partyId: string,
    partyUpdate: PartyUpdate, options?: RequestInit): Promise<updatePartyApiPartiesPartyIdPatchResponse> => {
  
  return customFetch<updatePartyApiPartiesPartyIdPatchResponse>(getUpdatePartyApiPartiesPartyIdPatchUrl(partyId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partyUpdate,)
  }
);}



/**
 * @summary Delete Party
 */
export type deletePartyApiPartiesPartyIdDeleteResponse200 = {
  data: PartyRead
  status: 200
}

export type deletePartyApiPartiesPartyIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deletePartyApiPartiesPartyIdDeleteResponseSuccess = (deletePartyApiPartiesPartyIdDeleteResponse200) & {
  headers: Headers;
};
export type deletePartyApiPartiesPartyIdDeleteResponseError = (deletePartyApiPartiesPartyIdDeleteResponse422) & {
  headers: Headers;
};

export type deletePartyApiPartiesPartyIdDeleteResponse = (deletePartyApiPartiesPartyIdDeleteResponseSuccess | deletePartyApiPartiesPartyIdDeleteResponseError)

export const getDeletePartyApiPartiesPartyIdDeleteUrl = (partyId: string,) => {


  

  return `/api/parties/${partyId}`
}

export const deletePartyApiPartiesPartyIdDelete = async (partyId: string, options?: RequestInit): Promise<deletePartyApiPartiesPartyIdDeleteResponse> => {
  
  return customFetch<deletePartyApiPartiesPartyIdDeleteResponse>(getDeletePartyApiPartiesPartyIdDeleteUrl(partyId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Trucks
 */
export type listTrucksApiTrucksGetResponse200 = {
  data: TruckList
  status: 200
}

export type listTrucksApiTrucksGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listTrucksApiTrucksGetResponseSuccess = (listTrucksApiTrucksGetResponse200) & {
  headers: Headers;
};
export type listTrucksApiTrucksGetResponseError = (listTrucksApiTrucksGetResponse422) & {
  headers: Headers;
};

export type listTrucksApiTrucksGetResponse = (listTrucksApiTrucksGetResponseSuccess | listTrucksApiTrucksGetResponseError)

export const getListTrucksApiTrucksGetUrl = (params?: ListTrucksApiTrucksGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/trucks/?${stringifiedParams}` : `/api/trucks/`
}

export const listTrucksApiTrucksGet = async (params?: ListTrucksApiTrucksGetParams, options?: RequestInit): Promise<listTrucksApiTrucksGetResponse> => {
  
  return customFetch<listTrucksApiTrucksGetResponse>(getListTrucksApiTrucksGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Truck
 */
export type createTruckApiTrucksPostResponse201 = {
  data: TruckRead
  status: 201
}

export type createTruckApiTrucksPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createTruckApiTrucksPostResponseSuccess = (createTruckApiTrucksPostResponse201) & {
  headers: Headers;
};
export type createTruckApiTrucksPostResponseError = (createTruckApiTrucksPostResponse422) & {
  headers: Headers;
};

export type createTruckApiTrucksPostResponse = (createTruckApiTrucksPostResponseSuccess | createTruckApiTrucksPostResponseError)

export const getCreateTruckApiTrucksPostUrl = () => {


  

  return `/api/trucks/`
}

export const createTruckApiTrucksPost = async (truckCreate: TruckCreate, options?: RequestInit): Promise<createTruckApiTrucksPostResponse> => {
  
  return customFetch<createTruckApiTrucksPostResponse>(getCreateTruckApiTrucksPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      truckCreate,)
  }
);}



/**
 * @summary Get Truck
 */
export type getTruckApiTrucksTruckIdGetResponse200 = {
  data: TruckRead
  status: 200
}

export type getTruckApiTrucksTruckIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getTruckApiTrucksTruckIdGetResponseSuccess = (getTruckApiTrucksTruckIdGetResponse200) & {
  headers: Headers;
};
export type getTruckApiTrucksTruckIdGetResponseError = (getTruckApiTrucksTruckIdGetResponse422) & {
  headers: Headers;
};

export type getTruckApiTrucksTruckIdGetResponse = (getTruckApiTrucksTruckIdGetResponseSuccess | getTruckApiTrucksTruckIdGetResponseError)

export const getGetTruckApiTrucksTruckIdGetUrl = (truckId: string,) => {


  

  return `/api/trucks/${truckId}`
}

export const getTruckApiTrucksTruckIdGet = async (truckId: string, options?: RequestInit): Promise<getTruckApiTrucksTruckIdGetResponse> => {
  
  return customFetch<getTruckApiTrucksTruckIdGetResponse>(getGetTruckApiTrucksTruckIdGetUrl(truckId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Truck
 */
export type updateTruckApiTrucksTruckIdPatchResponse200 = {
  data: TruckRead
  status: 200
}

export type updateTruckApiTrucksTruckIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updateTruckApiTrucksTruckIdPatchResponseSuccess = (updateTruckApiTrucksTruckIdPatchResponse200) & {
  headers: Headers;
};
export type updateTruckApiTrucksTruckIdPatchResponseError = (updateTruckApiTrucksTruckIdPatchResponse422) & {
  headers: Headers;
};

export type updateTruckApiTrucksTruckIdPatchResponse = (updateTruckApiTrucksTruckIdPatchResponseSuccess | updateTruckApiTrucksTruckIdPatchResponseError)

export const getUpdateTruckApiTrucksTruckIdPatchUrl = (truckId: string,) => {


  

  return `/api/trucks/${truckId}`
}

export const updateTruckApiTrucksTruckIdPatch = async (truckId: string,
    truckUpdate: TruckUpdate, options?: RequestInit): Promise<updateTruckApiTrucksTruckIdPatchResponse> => {
  
  return customFetch<updateTruckApiTrucksTruckIdPatchResponse>(getUpdateTruckApiTrucksTruckIdPatchUrl(truckId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      truckUpdate,)
  }
);}



/**
 * @summary Delete Truck
 */
export type deleteTruckApiTrucksTruckIdDeleteResponse200 = {
  data: TruckRead
  status: 200
}

export type deleteTruckApiTrucksTruckIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteTruckApiTrucksTruckIdDeleteResponseSuccess = (deleteTruckApiTrucksTruckIdDeleteResponse200) & {
  headers: Headers;
};
export type deleteTruckApiTrucksTruckIdDeleteResponseError = (deleteTruckApiTrucksTruckIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteTruckApiTrucksTruckIdDeleteResponse = (deleteTruckApiTrucksTruckIdDeleteResponseSuccess | deleteTruckApiTrucksTruckIdDeleteResponseError)

export const getDeleteTruckApiTrucksTruckIdDeleteUrl = (truckId: string,) => {


  

  return `/api/trucks/${truckId}`
}

export const deleteTruckApiTrucksTruckIdDelete = async (truckId: string, options?: RequestInit): Promise<deleteTruckApiTrucksTruckIdDeleteResponse> => {
  
  return customFetch<deleteTruckApiTrucksTruckIdDeleteResponse>(getDeleteTruckApiTrucksTruckIdDeleteUrl(truckId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Drivers
 */
export type listDriversApiDriversGetResponse200 = {
  data: DriverList
  status: 200
}

export type listDriversApiDriversGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listDriversApiDriversGetResponseSuccess = (listDriversApiDriversGetResponse200) & {
  headers: Headers;
};
export type listDriversApiDriversGetResponseError = (listDriversApiDriversGetResponse422) & {
  headers: Headers;
};

export type listDriversApiDriversGetResponse = (listDriversApiDriversGetResponseSuccess | listDriversApiDriversGetResponseError)

export const getListDriversApiDriversGetUrl = (params?: ListDriversApiDriversGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/drivers/?${stringifiedParams}` : `/api/drivers/`
}

export const listDriversApiDriversGet = async (params?: ListDriversApiDriversGetParams, options?: RequestInit): Promise<listDriversApiDriversGetResponse> => {
  
  return customFetch<listDriversApiDriversGetResponse>(getListDriversApiDriversGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Driver
 */
export type createDriverApiDriversPostResponse201 = {
  data: DriverRead
  status: 201
}

export type createDriverApiDriversPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createDriverApiDriversPostResponseSuccess = (createDriverApiDriversPostResponse201) & {
  headers: Headers;
};
export type createDriverApiDriversPostResponseError = (createDriverApiDriversPostResponse422) & {
  headers: Headers;
};

export type createDriverApiDriversPostResponse = (createDriverApiDriversPostResponseSuccess | createDriverApiDriversPostResponseError)

export const getCreateDriverApiDriversPostUrl = () => {


  

  return `/api/drivers/`
}

export const createDriverApiDriversPost = async (driverCreate: DriverCreate, options?: RequestInit): Promise<createDriverApiDriversPostResponse> => {
  
  return customFetch<createDriverApiDriversPostResponse>(getCreateDriverApiDriversPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      driverCreate,)
  }
);}



/**
 * @summary Get Driver
 */
export type getDriverApiDriversDriverIdGetResponse200 = {
  data: DriverRead
  status: 200
}

export type getDriverApiDriversDriverIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getDriverApiDriversDriverIdGetResponseSuccess = (getDriverApiDriversDriverIdGetResponse200) & {
  headers: Headers;
};
export type getDriverApiDriversDriverIdGetResponseError = (getDriverApiDriversDriverIdGetResponse422) & {
  headers: Headers;
};

export type getDriverApiDriversDriverIdGetResponse = (getDriverApiDriversDriverIdGetResponseSuccess | getDriverApiDriversDriverIdGetResponseError)

export const getGetDriverApiDriversDriverIdGetUrl = (driverId: string,) => {


  

  return `/api/drivers/${driverId}`
}

export const getDriverApiDriversDriverIdGet = async (driverId: string, options?: RequestInit): Promise<getDriverApiDriversDriverIdGetResponse> => {
  
  return customFetch<getDriverApiDriversDriverIdGetResponse>(getGetDriverApiDriversDriverIdGetUrl(driverId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Driver
 */
export type updateDriverApiDriversDriverIdPatchResponse200 = {
  data: DriverRead
  status: 200
}

export type updateDriverApiDriversDriverIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updateDriverApiDriversDriverIdPatchResponseSuccess = (updateDriverApiDriversDriverIdPatchResponse200) & {
  headers: Headers;
};
export type updateDriverApiDriversDriverIdPatchResponseError = (updateDriverApiDriversDriverIdPatchResponse422) & {
  headers: Headers;
};

export type updateDriverApiDriversDriverIdPatchResponse = (updateDriverApiDriversDriverIdPatchResponseSuccess | updateDriverApiDriversDriverIdPatchResponseError)

export const getUpdateDriverApiDriversDriverIdPatchUrl = (driverId: string,) => {


  

  return `/api/drivers/${driverId}`
}

export const updateDriverApiDriversDriverIdPatch = async (driverId: string,
    driverUpdate: DriverUpdate, options?: RequestInit): Promise<updateDriverApiDriversDriverIdPatchResponse> => {
  
  return customFetch<updateDriverApiDriversDriverIdPatchResponse>(getUpdateDriverApiDriversDriverIdPatchUrl(driverId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      driverUpdate,)
  }
);}



/**
 * @summary Delete Driver
 */
export type deleteDriverApiDriversDriverIdDeleteResponse200 = {
  data: DriverRead
  status: 200
}

export type deleteDriverApiDriversDriverIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteDriverApiDriversDriverIdDeleteResponseSuccess = (deleteDriverApiDriversDriverIdDeleteResponse200) & {
  headers: Headers;
};
export type deleteDriverApiDriversDriverIdDeleteResponseError = (deleteDriverApiDriversDriverIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteDriverApiDriversDriverIdDeleteResponse = (deleteDriverApiDriversDriverIdDeleteResponseSuccess | deleteDriverApiDriversDriverIdDeleteResponseError)

export const getDeleteDriverApiDriversDriverIdDeleteUrl = (driverId: string,) => {


  

  return `/api/drivers/${driverId}`
}

export const deleteDriverApiDriversDriverIdDelete = async (driverId: string, options?: RequestInit): Promise<deleteDriverApiDriversDriverIdDeleteResponse> => {
  
  return customFetch<deleteDriverApiDriversDriverIdDeleteResponse>(getDeleteDriverApiDriversDriverIdDeleteUrl(driverId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Materials
 */
export type listMaterialsApiMaterialsGetResponse200 = {
  data: MaterialList
  status: 200
}

export type listMaterialsApiMaterialsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listMaterialsApiMaterialsGetResponseSuccess = (listMaterialsApiMaterialsGetResponse200) & {
  headers: Headers;
};
export type listMaterialsApiMaterialsGetResponseError = (listMaterialsApiMaterialsGetResponse422) & {
  headers: Headers;
};

export type listMaterialsApiMaterialsGetResponse = (listMaterialsApiMaterialsGetResponseSuccess | listMaterialsApiMaterialsGetResponseError)

export const getListMaterialsApiMaterialsGetUrl = (params?: ListMaterialsApiMaterialsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/materials/?${stringifiedParams}` : `/api/materials/`
}

export const listMaterialsApiMaterialsGet = async (params?: ListMaterialsApiMaterialsGetParams, options?: RequestInit): Promise<listMaterialsApiMaterialsGetResponse> => {
  
  return customFetch<listMaterialsApiMaterialsGetResponse>(getListMaterialsApiMaterialsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Material
 */
export type createMaterialApiMaterialsPostResponse201 = {
  data: MaterialRead
  status: 201
}

export type createMaterialApiMaterialsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createMaterialApiMaterialsPostResponseSuccess = (createMaterialApiMaterialsPostResponse201) & {
  headers: Headers;
};
export type createMaterialApiMaterialsPostResponseError = (createMaterialApiMaterialsPostResponse422) & {
  headers: Headers;
};

export type createMaterialApiMaterialsPostResponse = (createMaterialApiMaterialsPostResponseSuccess | createMaterialApiMaterialsPostResponseError)

export const getCreateMaterialApiMaterialsPostUrl = () => {


  

  return `/api/materials/`
}

export const createMaterialApiMaterialsPost = async (materialCreate: MaterialCreate, options?: RequestInit): Promise<createMaterialApiMaterialsPostResponse> => {
  
  return customFetch<createMaterialApiMaterialsPostResponse>(getCreateMaterialApiMaterialsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      materialCreate,)
  }
);}



/**
 * @summary Get Material
 */
export type getMaterialApiMaterialsMaterialIdGetResponse200 = {
  data: MaterialRead
  status: 200
}

export type getMaterialApiMaterialsMaterialIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getMaterialApiMaterialsMaterialIdGetResponseSuccess = (getMaterialApiMaterialsMaterialIdGetResponse200) & {
  headers: Headers;
};
export type getMaterialApiMaterialsMaterialIdGetResponseError = (getMaterialApiMaterialsMaterialIdGetResponse422) & {
  headers: Headers;
};

export type getMaterialApiMaterialsMaterialIdGetResponse = (getMaterialApiMaterialsMaterialIdGetResponseSuccess | getMaterialApiMaterialsMaterialIdGetResponseError)

export const getGetMaterialApiMaterialsMaterialIdGetUrl = (materialId: string,) => {


  

  return `/api/materials/${materialId}`
}

export const getMaterialApiMaterialsMaterialIdGet = async (materialId: string, options?: RequestInit): Promise<getMaterialApiMaterialsMaterialIdGetResponse> => {
  
  return customFetch<getMaterialApiMaterialsMaterialIdGetResponse>(getGetMaterialApiMaterialsMaterialIdGetUrl(materialId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Material
 */
export type updateMaterialApiMaterialsMaterialIdPatchResponse200 = {
  data: MaterialRead
  status: 200
}

export type updateMaterialApiMaterialsMaterialIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updateMaterialApiMaterialsMaterialIdPatchResponseSuccess = (updateMaterialApiMaterialsMaterialIdPatchResponse200) & {
  headers: Headers;
};
export type updateMaterialApiMaterialsMaterialIdPatchResponseError = (updateMaterialApiMaterialsMaterialIdPatchResponse422) & {
  headers: Headers;
};

export type updateMaterialApiMaterialsMaterialIdPatchResponse = (updateMaterialApiMaterialsMaterialIdPatchResponseSuccess | updateMaterialApiMaterialsMaterialIdPatchResponseError)

export const getUpdateMaterialApiMaterialsMaterialIdPatchUrl = (materialId: string,) => {


  

  return `/api/materials/${materialId}`
}

export const updateMaterialApiMaterialsMaterialIdPatch = async (materialId: string,
    materialUpdate: MaterialUpdate, options?: RequestInit): Promise<updateMaterialApiMaterialsMaterialIdPatchResponse> => {
  
  return customFetch<updateMaterialApiMaterialsMaterialIdPatchResponse>(getUpdateMaterialApiMaterialsMaterialIdPatchUrl(materialId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      materialUpdate,)
  }
);}



/**
 * @summary Delete Material
 */
export type deleteMaterialApiMaterialsMaterialIdDeleteResponse200 = {
  data: MaterialRead
  status: 200
}

export type deleteMaterialApiMaterialsMaterialIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteMaterialApiMaterialsMaterialIdDeleteResponseSuccess = (deleteMaterialApiMaterialsMaterialIdDeleteResponse200) & {
  headers: Headers;
};
export type deleteMaterialApiMaterialsMaterialIdDeleteResponseError = (deleteMaterialApiMaterialsMaterialIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteMaterialApiMaterialsMaterialIdDeleteResponse = (deleteMaterialApiMaterialsMaterialIdDeleteResponseSuccess | deleteMaterialApiMaterialsMaterialIdDeleteResponseError)

export const getDeleteMaterialApiMaterialsMaterialIdDeleteUrl = (materialId: string,) => {


  

  return `/api/materials/${materialId}`
}

export const deleteMaterialApiMaterialsMaterialIdDelete = async (materialId: string, options?: RequestInit): Promise<deleteMaterialApiMaterialsMaterialIdDeleteResponse> => {
  
  return customFetch<deleteMaterialApiMaterialsMaterialIdDeleteResponse>(getDeleteMaterialApiMaterialsMaterialIdDeleteUrl(materialId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Bilty
 */
export type listBiltyApiBiltyGetResponse200 = {
  data: BiltyList
  status: 200
}

export type listBiltyApiBiltyGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listBiltyApiBiltyGetResponseSuccess = (listBiltyApiBiltyGetResponse200) & {
  headers: Headers;
};
export type listBiltyApiBiltyGetResponseError = (listBiltyApiBiltyGetResponse422) & {
  headers: Headers;
};

export type listBiltyApiBiltyGetResponse = (listBiltyApiBiltyGetResponseSuccess | listBiltyApiBiltyGetResponseError)

export const getListBiltyApiBiltyGetUrl = (params?: ListBiltyApiBiltyGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bilty/?${stringifiedParams}` : `/api/bilty/`
}

export const listBiltyApiBiltyGet = async (params?: ListBiltyApiBiltyGetParams, options?: RequestInit): Promise<listBiltyApiBiltyGetResponse> => {
  
  return customFetch<listBiltyApiBiltyGetResponse>(getListBiltyApiBiltyGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Bilty
 */
export type createBiltyApiBiltyPostResponse201 = {
  data: BiltyRead
  status: 201
}

export type createBiltyApiBiltyPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createBiltyApiBiltyPostResponseSuccess = (createBiltyApiBiltyPostResponse201) & {
  headers: Headers;
};
export type createBiltyApiBiltyPostResponseError = (createBiltyApiBiltyPostResponse422) & {
  headers: Headers;
};

export type createBiltyApiBiltyPostResponse = (createBiltyApiBiltyPostResponseSuccess | createBiltyApiBiltyPostResponseError)

export const getCreateBiltyApiBiltyPostUrl = () => {


  

  return `/api/bilty/`
}

export const createBiltyApiBiltyPost = async (biltyCreate: BiltyCreate, options?: RequestInit): Promise<createBiltyApiBiltyPostResponse> => {
  
  return customFetch<createBiltyApiBiltyPostResponse>(getCreateBiltyApiBiltyPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      biltyCreate,)
  }
);}



/**
 * Tiles + pill counts over the whole filtered range (V53).
 * @summary Bilty Summary
 */
export type biltySummaryApiBiltySummaryGetResponse200 = {
  data: BiltySummary
  status: 200
}

export type biltySummaryApiBiltySummaryGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type biltySummaryApiBiltySummaryGetResponseSuccess = (biltySummaryApiBiltySummaryGetResponse200) & {
  headers: Headers;
};
export type biltySummaryApiBiltySummaryGetResponseError = (biltySummaryApiBiltySummaryGetResponse422) & {
  headers: Headers;
};

export type biltySummaryApiBiltySummaryGetResponse = (biltySummaryApiBiltySummaryGetResponseSuccess | biltySummaryApiBiltySummaryGetResponseError)

export const getBiltySummaryApiBiltySummaryGetUrl = (params?: BiltySummaryApiBiltySummaryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bilty/summary?${stringifiedParams}` : `/api/bilty/summary`
}

export const biltySummaryApiBiltySummaryGet = async (params?: BiltySummaryApiBiltySummaryGetParams, options?: RequestInit): Promise<biltySummaryApiBiltySummaryGetResponse> => {
  
  return customFetch<biltySummaryApiBiltySummaryGetResponse>(getBiltySummaryApiBiltySummaryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The list as CSV — same filters, every page (V53).
 * @summary Export Bilties Csv
 */
export type exportBiltiesCsvApiBiltyExportCsvGetResponse200 = {
  data: unknown
  status: 200
}

export type exportBiltiesCsvApiBiltyExportCsvGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type exportBiltiesCsvApiBiltyExportCsvGetResponseSuccess = (exportBiltiesCsvApiBiltyExportCsvGetResponse200) & {
  headers: Headers;
};
export type exportBiltiesCsvApiBiltyExportCsvGetResponseError = (exportBiltiesCsvApiBiltyExportCsvGetResponse422) & {
  headers: Headers;
};

export type exportBiltiesCsvApiBiltyExportCsvGetResponse = (exportBiltiesCsvApiBiltyExportCsvGetResponseSuccess | exportBiltiesCsvApiBiltyExportCsvGetResponseError)

export const getExportBiltiesCsvApiBiltyExportCsvGetUrl = (params?: ExportBiltiesCsvApiBiltyExportCsvGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bilty/export.csv?${stringifiedParams}` : `/api/bilty/export.csv`
}

export const exportBiltiesCsvApiBiltyExportCsvGet = async (params?: ExportBiltiesCsvApiBiltyExportCsvGetParams, options?: RequestInit): Promise<exportBiltiesCsvApiBiltyExportCsvGetResponse> => {
  
  return customFetch<exportBiltiesCsvApiBiltyExportCsvGetResponse>(getExportBiltiesCsvApiBiltyExportCsvGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Bilty Docs
 */
export type listBiltyDocsApiBiltyBiltyIdDocsGetResponse200 = {
  data: BiltyDocs
  status: 200
}

export type listBiltyDocsApiBiltyBiltyIdDocsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listBiltyDocsApiBiltyBiltyIdDocsGetResponseSuccess = (listBiltyDocsApiBiltyBiltyIdDocsGetResponse200) & {
  headers: Headers;
};
export type listBiltyDocsApiBiltyBiltyIdDocsGetResponseError = (listBiltyDocsApiBiltyBiltyIdDocsGetResponse422) & {
  headers: Headers;
};

export type listBiltyDocsApiBiltyBiltyIdDocsGetResponse = (listBiltyDocsApiBiltyBiltyIdDocsGetResponseSuccess | listBiltyDocsApiBiltyBiltyIdDocsGetResponseError)

export const getListBiltyDocsApiBiltyBiltyIdDocsGetUrl = (biltyId: string,) => {


  

  return `/api/bilty/${biltyId}/docs`
}

export const listBiltyDocsApiBiltyBiltyIdDocsGet = async (biltyId: string, options?: RequestInit): Promise<listBiltyDocsApiBiltyBiltyIdDocsGetResponse> => {
  
  return customFetch<listBiltyDocsApiBiltyBiltyIdDocsGetResponse>(getListBiltyDocsApiBiltyBiltyIdDocsGetUrl(biltyId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Bilty Pdf Get
 */
export type biltyPdfGetApiBiltyBiltyIdPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type biltyPdfGetApiBiltyBiltyIdPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type biltyPdfGetApiBiltyBiltyIdPdfGetResponseSuccess = (biltyPdfGetApiBiltyBiltyIdPdfGetResponse200) & {
  headers: Headers;
};
export type biltyPdfGetApiBiltyBiltyIdPdfGetResponseError = (biltyPdfGetApiBiltyBiltyIdPdfGetResponse422) & {
  headers: Headers;
};

export type biltyPdfGetApiBiltyBiltyIdPdfGetResponse = (biltyPdfGetApiBiltyBiltyIdPdfGetResponseSuccess | biltyPdfGetApiBiltyBiltyIdPdfGetResponseError)

export const getBiltyPdfGetApiBiltyBiltyIdPdfGetUrl = (biltyId: string,
    params?: BiltyPdfGetApiBiltyBiltyIdPdfGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bilty/${biltyId}/pdf?${stringifiedParams}` : `/api/bilty/${biltyId}/pdf`
}

export const biltyPdfGetApiBiltyBiltyIdPdfGet = async (biltyId: string,
    params?: BiltyPdfGetApiBiltyBiltyIdPdfGetParams, options?: RequestInit): Promise<biltyPdfGetApiBiltyBiltyIdPdfGetResponse> => {
  
  return customFetch<biltyPdfGetApiBiltyBiltyIdPdfGetResponse>(getBiltyPdfGetApiBiltyBiltyIdPdfGetUrl(biltyId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Bilty Pdf Post
 */
export type biltyPdfPostApiBiltyBiltyIdPdfPostResponse200 = {
  data: unknown
  status: 200
}

export type biltyPdfPostApiBiltyBiltyIdPdfPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type biltyPdfPostApiBiltyBiltyIdPdfPostResponseSuccess = (biltyPdfPostApiBiltyBiltyIdPdfPostResponse200) & {
  headers: Headers;
};
export type biltyPdfPostApiBiltyBiltyIdPdfPostResponseError = (biltyPdfPostApiBiltyBiltyIdPdfPostResponse422) & {
  headers: Headers;
};

export type biltyPdfPostApiBiltyBiltyIdPdfPostResponse = (biltyPdfPostApiBiltyBiltyIdPdfPostResponseSuccess | biltyPdfPostApiBiltyBiltyIdPdfPostResponseError)

export const getBiltyPdfPostApiBiltyBiltyIdPdfPostUrl = (biltyId: string,
    params?: BiltyPdfPostApiBiltyBiltyIdPdfPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bilty/${biltyId}/pdf?${stringifiedParams}` : `/api/bilty/${biltyId}/pdf`
}

export const biltyPdfPostApiBiltyBiltyIdPdfPost = async (biltyId: string,
    params?: BiltyPdfPostApiBiltyBiltyIdPdfPostParams, options?: RequestInit): Promise<biltyPdfPostApiBiltyBiltyIdPdfPostResponse> => {
  
  return customFetch<biltyPdfPostApiBiltyBiltyIdPdfPostResponse>(getBiltyPdfPostApiBiltyBiltyIdPdfPostUrl(biltyId,params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Get Bilty
 */
export type getBiltyApiBiltyBiltyIdGetResponse200 = {
  data: BiltyRead
  status: 200
}

export type getBiltyApiBiltyBiltyIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getBiltyApiBiltyBiltyIdGetResponseSuccess = (getBiltyApiBiltyBiltyIdGetResponse200) & {
  headers: Headers;
};
export type getBiltyApiBiltyBiltyIdGetResponseError = (getBiltyApiBiltyBiltyIdGetResponse422) & {
  headers: Headers;
};

export type getBiltyApiBiltyBiltyIdGetResponse = (getBiltyApiBiltyBiltyIdGetResponseSuccess | getBiltyApiBiltyBiltyIdGetResponseError)

export const getGetBiltyApiBiltyBiltyIdGetUrl = (biltyId: string,) => {


  

  return `/api/bilty/${biltyId}`
}

export const getBiltyApiBiltyBiltyIdGet = async (biltyId: string, options?: RequestInit): Promise<getBiltyApiBiltyBiltyIdGetResponse> => {
  
  return customFetch<getBiltyApiBiltyBiltyIdGetResponse>(getGetBiltyApiBiltyBiltyIdGetUrl(biltyId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Patch Bilty
 */
export type patchBiltyApiBiltyBiltyIdPatchResponse200 = {
  data: BiltyRead
  status: 200
}

export type patchBiltyApiBiltyBiltyIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type patchBiltyApiBiltyBiltyIdPatchResponseSuccess = (patchBiltyApiBiltyBiltyIdPatchResponse200) & {
  headers: Headers;
};
export type patchBiltyApiBiltyBiltyIdPatchResponseError = (patchBiltyApiBiltyBiltyIdPatchResponse422) & {
  headers: Headers;
};

export type patchBiltyApiBiltyBiltyIdPatchResponse = (patchBiltyApiBiltyBiltyIdPatchResponseSuccess | patchBiltyApiBiltyBiltyIdPatchResponseError)

export const getPatchBiltyApiBiltyBiltyIdPatchUrl = (biltyId: string,) => {


  

  return `/api/bilty/${biltyId}`
}

export const patchBiltyApiBiltyBiltyIdPatch = async (biltyId: string,
    biltyUpdate: BiltyUpdate, options?: RequestInit): Promise<patchBiltyApiBiltyBiltyIdPatchResponse> => {
  
  return customFetch<patchBiltyApiBiltyBiltyIdPatchResponse>(getPatchBiltyApiBiltyBiltyIdPatchUrl(biltyId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      biltyUpdate,)
  }
);}



/**
 * @summary Delete Bilty
 */
export type deleteBiltyApiBiltyBiltyIdDeleteResponse200 = {
  data: BiltyRead
  status: 200
}

export type deleteBiltyApiBiltyBiltyIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteBiltyApiBiltyBiltyIdDeleteResponseSuccess = (deleteBiltyApiBiltyBiltyIdDeleteResponse200) & {
  headers: Headers;
};
export type deleteBiltyApiBiltyBiltyIdDeleteResponseError = (deleteBiltyApiBiltyBiltyIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteBiltyApiBiltyBiltyIdDeleteResponse = (deleteBiltyApiBiltyBiltyIdDeleteResponseSuccess | deleteBiltyApiBiltyBiltyIdDeleteResponseError)

export const getDeleteBiltyApiBiltyBiltyIdDeleteUrl = (biltyId: string,) => {


  

  return `/api/bilty/${biltyId}`
}

export const deleteBiltyApiBiltyBiltyIdDelete = async (biltyId: string, options?: RequestInit): Promise<deleteBiltyApiBiltyBiltyIdDeleteResponse> => {
  
  return customFetch<deleteBiltyApiBiltyBiltyIdDeleteResponse>(getDeleteBiltyApiBiltyBiltyIdDeleteUrl(biltyId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Revise destination charges after delivery (V48 P2) — old→new kept on the bilty.
 * @summary Update Bilty Charges Route
 */
export type updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponse200 = {
  data: BiltyRead
  status: 200
}

export type updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponseSuccess = (updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponse200) & {
  headers: Headers;
};
export type updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponseError = (updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponse422) & {
  headers: Headers;
};

export type updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponse = (updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponseSuccess | updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponseError)

export const getUpdateBiltyChargesRouteApiBiltyBiltyIdChargesPostUrl = (biltyId: string,) => {


  

  return `/api/bilty/${biltyId}/charges`
}

export const updateBiltyChargesRouteApiBiltyBiltyIdChargesPost = async (biltyId: string,
    biltyChargesUpdate: BiltyChargesUpdate, options?: RequestInit): Promise<updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponse> => {
  
  return customFetch<updateBiltyChargesRouteApiBiltyBiltyIdChargesPostResponse>(getUpdateBiltyChargesRouteApiBiltyBiltyIdChargesPostUrl(biltyId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      biltyChargesUpdate,)
  }
);}



/**
 * @summary Promote Bilty Route
 */
export type promoteBiltyRouteApiBiltyBiltyIdPromotePostResponse200 = {
  data: BiltyRead
  status: 200
}

export type promoteBiltyRouteApiBiltyBiltyIdPromotePostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type promoteBiltyRouteApiBiltyBiltyIdPromotePostResponseSuccess = (promoteBiltyRouteApiBiltyBiltyIdPromotePostResponse200) & {
  headers: Headers;
};
export type promoteBiltyRouteApiBiltyBiltyIdPromotePostResponseError = (promoteBiltyRouteApiBiltyBiltyIdPromotePostResponse422) & {
  headers: Headers;
};

export type promoteBiltyRouteApiBiltyBiltyIdPromotePostResponse = (promoteBiltyRouteApiBiltyBiltyIdPromotePostResponseSuccess | promoteBiltyRouteApiBiltyBiltyIdPromotePostResponseError)

export const getPromoteBiltyRouteApiBiltyBiltyIdPromotePostUrl = (biltyId: string,) => {


  

  return `/api/bilty/${biltyId}/promote`
}

export const promoteBiltyRouteApiBiltyBiltyIdPromotePost = async (biltyId: string,
    biltyPromoteBody: BiltyPromoteBody, options?: RequestInit): Promise<promoteBiltyRouteApiBiltyBiltyIdPromotePostResponse> => {
  
  return customFetch<promoteBiltyRouteApiBiltyBiltyIdPromotePostResponse>(getPromoteBiltyRouteApiBiltyBiltyIdPromotePostUrl(biltyId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      biltyPromoteBody,)
  }
);}



/**
 * @summary Cancel Bilty Route
 */
export type cancelBiltyRouteApiBiltyBiltyIdCancelPostResponse200 = {
  data: BiltyRead
  status: 200
}

export type cancelBiltyRouteApiBiltyBiltyIdCancelPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type cancelBiltyRouteApiBiltyBiltyIdCancelPostResponseSuccess = (cancelBiltyRouteApiBiltyBiltyIdCancelPostResponse200) & {
  headers: Headers;
};
export type cancelBiltyRouteApiBiltyBiltyIdCancelPostResponseError = (cancelBiltyRouteApiBiltyBiltyIdCancelPostResponse422) & {
  headers: Headers;
};

export type cancelBiltyRouteApiBiltyBiltyIdCancelPostResponse = (cancelBiltyRouteApiBiltyBiltyIdCancelPostResponseSuccess | cancelBiltyRouteApiBiltyBiltyIdCancelPostResponseError)

export const getCancelBiltyRouteApiBiltyBiltyIdCancelPostUrl = (biltyId: string,) => {


  

  return `/api/bilty/${biltyId}/cancel`
}

export const cancelBiltyRouteApiBiltyBiltyIdCancelPost = async (biltyId: string,
    biltyCancel: BiltyCancel, options?: RequestInit): Promise<cancelBiltyRouteApiBiltyBiltyIdCancelPostResponse> => {
  
  return customFetch<cancelBiltyRouteApiBiltyBiltyIdCancelPostResponse>(getCancelBiltyRouteApiBiltyBiltyIdCancelPostUrl(biltyId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      biltyCancel,)
  }
);}



/**
 * @summary Extract Bilty
 */
export type extractBiltyApiBiltyExtractPostResponse200 = {
  data: ExtractResponse
  status: 200
}

export type extractBiltyApiBiltyExtractPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type extractBiltyApiBiltyExtractPostResponseSuccess = (extractBiltyApiBiltyExtractPostResponse200) & {
  headers: Headers;
};
export type extractBiltyApiBiltyExtractPostResponseError = (extractBiltyApiBiltyExtractPostResponse422) & {
  headers: Headers;
};

export type extractBiltyApiBiltyExtractPostResponse = (extractBiltyApiBiltyExtractPostResponseSuccess | extractBiltyApiBiltyExtractPostResponseError)

export const getExtractBiltyApiBiltyExtractPostUrl = () => {


  

  return `/api/bilty/extract`
}

export const extractBiltyApiBiltyExtractPost = async (extractRequest: ExtractRequest, options?: RequestInit): Promise<extractBiltyApiBiltyExtractPostResponse> => {
  
  return customFetch<extractBiltyApiBiltyExtractPostResponse>(getExtractBiltyApiBiltyExtractPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      extractRequest,)
  }
);}



/**
 * @summary List Loading Slips
 */
export type listLoadingSlipsApiLoadingSlipsGetResponse200 = {
  data: LoadingSlipList
  status: 200
}

export type listLoadingSlipsApiLoadingSlipsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listLoadingSlipsApiLoadingSlipsGetResponseSuccess = (listLoadingSlipsApiLoadingSlipsGetResponse200) & {
  headers: Headers;
};
export type listLoadingSlipsApiLoadingSlipsGetResponseError = (listLoadingSlipsApiLoadingSlipsGetResponse422) & {
  headers: Headers;
};

export type listLoadingSlipsApiLoadingSlipsGetResponse = (listLoadingSlipsApiLoadingSlipsGetResponseSuccess | listLoadingSlipsApiLoadingSlipsGetResponseError)

export const getListLoadingSlipsApiLoadingSlipsGetUrl = (params?: ListLoadingSlipsApiLoadingSlipsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/loading-slips/?${stringifiedParams}` : `/api/loading-slips/`
}

export const listLoadingSlipsApiLoadingSlipsGet = async (params?: ListLoadingSlipsApiLoadingSlipsGetParams, options?: RequestInit): Promise<listLoadingSlipsApiLoadingSlipsGetResponse> => {
  
  return customFetch<listLoadingSlipsApiLoadingSlipsGetResponse>(getListLoadingSlipsApiLoadingSlipsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Loading Slip
 */
export type createLoadingSlipApiLoadingSlipsPostResponse201 = {
  data: CreateLoadingSlipApiLoadingSlipsPost201
  status: 201
}

export type createLoadingSlipApiLoadingSlipsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createLoadingSlipApiLoadingSlipsPostResponseSuccess = (createLoadingSlipApiLoadingSlipsPostResponse201) & {
  headers: Headers;
};
export type createLoadingSlipApiLoadingSlipsPostResponseError = (createLoadingSlipApiLoadingSlipsPostResponse422) & {
  headers: Headers;
};

export type createLoadingSlipApiLoadingSlipsPostResponse = (createLoadingSlipApiLoadingSlipsPostResponseSuccess | createLoadingSlipApiLoadingSlipsPostResponseError)

export const getCreateLoadingSlipApiLoadingSlipsPostUrl = () => {


  

  return `/api/loading-slips/`
}

export const createLoadingSlipApiLoadingSlipsPost = async (loadingSlipCreate: LoadingSlipCreate, options?: RequestInit): Promise<createLoadingSlipApiLoadingSlipsPostResponse> => {
  
  return customFetch<createLoadingSlipApiLoadingSlipsPostResponse>(getCreateLoadingSlipApiLoadingSlipsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      loadingSlipCreate,)
  }
);}



/**
 * @summary Get Loading Slip
 */
export type getLoadingSlipApiLoadingSlipsSlipIdGetResponse200 = {
  data: LoadingSlipDetail
  status: 200
}

export type getLoadingSlipApiLoadingSlipsSlipIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getLoadingSlipApiLoadingSlipsSlipIdGetResponseSuccess = (getLoadingSlipApiLoadingSlipsSlipIdGetResponse200) & {
  headers: Headers;
};
export type getLoadingSlipApiLoadingSlipsSlipIdGetResponseError = (getLoadingSlipApiLoadingSlipsSlipIdGetResponse422) & {
  headers: Headers;
};

export type getLoadingSlipApiLoadingSlipsSlipIdGetResponse = (getLoadingSlipApiLoadingSlipsSlipIdGetResponseSuccess | getLoadingSlipApiLoadingSlipsSlipIdGetResponseError)

export const getGetLoadingSlipApiLoadingSlipsSlipIdGetUrl = (slipId: string,) => {


  

  return `/api/loading-slips/${slipId}`
}

export const getLoadingSlipApiLoadingSlipsSlipIdGet = async (slipId: string, options?: RequestInit): Promise<getLoadingSlipApiLoadingSlipsSlipIdGetResponse> => {
  
  return customFetch<getLoadingSlipApiLoadingSlipsSlipIdGetResponse>(getGetLoadingSlipApiLoadingSlipsSlipIdGetUrl(slipId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Link Bilty To Slip
 */
export type linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponse201 = {
  data: LinkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPost201
  status: 201
}

export type linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponseSuccess = (linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponse201) & {
  headers: Headers;
};
export type linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponseError = (linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponse422) & {
  headers: Headers;
};

export type linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponse = (linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponseSuccess | linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponseError)

export const getLinkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostUrl = (slipId: string,) => {


  

  return `/api/loading-slips/${slipId}/bilties`
}

export const linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPost = async (slipId: string,
    linkBiltyBody: LinkBiltyBody, options?: RequestInit): Promise<linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponse> => {
  
  return customFetch<linkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostResponse>(getLinkBiltyToSlipApiLoadingSlipsSlipIdBiltiesPostUrl(slipId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      linkBiltyBody,)
  }
);}



/**
 * @summary Unlink Bilty From Slip
 */
export type unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponse200 = {
  data: UnlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDelete200
  status: 200
}

export type unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponseSuccess = (unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponse200) & {
  headers: Headers;
};
export type unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponseError = (unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponse422) & {
  headers: Headers;
};

export type unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponse = (unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponseSuccess | unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponseError)

export const getUnlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteUrl = (slipId: string,
    biltyId: string,) => {


  

  return `/api/loading-slips/${slipId}/bilties/${biltyId}`
}

export const unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDelete = async (slipId: string,
    biltyId: string, options?: RequestInit): Promise<unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponse> => {
  
  return customFetch<unlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteResponse>(getUnlinkBiltyFromSlipApiLoadingSlipsSlipIdBiltiesBiltyIdDeleteUrl(slipId,biltyId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Loading Slip Pdf
 */
export type loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponseSuccess = (loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponse200) & {
  headers: Headers;
};
export type loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponseError = (loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponse422) & {
  headers: Headers;
};

export type loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponse = (loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponseSuccess | loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponseError)

export const getLoadingSlipPdfApiLoadingSlipsSlipIdPdfGetUrl = (slipId: string,) => {


  

  return `/api/loading-slips/${slipId}/pdf`
}

export const loadingSlipPdfApiLoadingSlipsSlipIdPdfGet = async (slipId: string, options?: RequestInit): Promise<loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponse> => {
  
  return customFetch<loadingSlipPdfApiLoadingSlipsSlipIdPdfGetResponse>(getLoadingSlipPdfApiLoadingSlipsSlipIdPdfGetUrl(slipId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Pod Upload Url
 */
export type podUploadUrlApiDeliveryMemosPodUploadUrlPostResponse200 = {
  data: PodUploadUrlResponse
  status: 200
}

export type podUploadUrlApiDeliveryMemosPodUploadUrlPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type podUploadUrlApiDeliveryMemosPodUploadUrlPostResponseSuccess = (podUploadUrlApiDeliveryMemosPodUploadUrlPostResponse200) & {
  headers: Headers;
};
export type podUploadUrlApiDeliveryMemosPodUploadUrlPostResponseError = (podUploadUrlApiDeliveryMemosPodUploadUrlPostResponse422) & {
  headers: Headers;
};

export type podUploadUrlApiDeliveryMemosPodUploadUrlPostResponse = (podUploadUrlApiDeliveryMemosPodUploadUrlPostResponseSuccess | podUploadUrlApiDeliveryMemosPodUploadUrlPostResponseError)

export const getPodUploadUrlApiDeliveryMemosPodUploadUrlPostUrl = () => {


  

  return `/api/delivery-memos/pod-upload-url`
}

export const podUploadUrlApiDeliveryMemosPodUploadUrlPost = async (podUploadUrlRequest: PodUploadUrlRequest, options?: RequestInit): Promise<podUploadUrlApiDeliveryMemosPodUploadUrlPostResponse> => {
  
  return customFetch<podUploadUrlApiDeliveryMemosPodUploadUrlPostResponse>(getPodUploadUrlApiDeliveryMemosPodUploadUrlPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      podUploadUrlRequest,)
  }
);}



/**
 * @summary Pod Image Redirect
 */
export type podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponse200 = {
  data: unknown
  status: 200
}

export type podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponseSuccess = (podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponse200) & {
  headers: Headers;
};
export type podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponseError = (podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponse422) & {
  headers: Headers;
};

export type podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponse = (podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponseSuccess | podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponseError)

export const getPodImageRedirectApiDeliveryMemosMemoIdPodImageGetUrl = (memoId: string,) => {


  

  return `/api/delivery-memos/${memoId}/pod-image`
}

export const podImageRedirectApiDeliveryMemosMemoIdPodImageGet = async (memoId: string, options?: RequestInit): Promise<podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponse> => {
  
  return customFetch<podImageRedirectApiDeliveryMemosMemoIdPodImageGetResponse>(getPodImageRedirectApiDeliveryMemosMemoIdPodImageGetUrl(memoId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Or Update Delivery Memo
 */
export type createOrUpdateDeliveryMemoApiDeliveryMemosPostResponse201 = {
  data: CreateOrUpdateDeliveryMemoApiDeliveryMemosPost201
  status: 201
}

export type createOrUpdateDeliveryMemoApiDeliveryMemosPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createOrUpdateDeliveryMemoApiDeliveryMemosPostResponseSuccess = (createOrUpdateDeliveryMemoApiDeliveryMemosPostResponse201) & {
  headers: Headers;
};
export type createOrUpdateDeliveryMemoApiDeliveryMemosPostResponseError = (createOrUpdateDeliveryMemoApiDeliveryMemosPostResponse422) & {
  headers: Headers;
};

export type createOrUpdateDeliveryMemoApiDeliveryMemosPostResponse = (createOrUpdateDeliveryMemoApiDeliveryMemosPostResponseSuccess | createOrUpdateDeliveryMemoApiDeliveryMemosPostResponseError)

export const getCreateOrUpdateDeliveryMemoApiDeliveryMemosPostUrl = () => {


  

  return `/api/delivery-memos/`
}

export const createOrUpdateDeliveryMemoApiDeliveryMemosPost = async (deliveryMemoCreate: DeliveryMemoCreate, options?: RequestInit): Promise<createOrUpdateDeliveryMemoApiDeliveryMemosPostResponse> => {
  
  return customFetch<createOrUpdateDeliveryMemoApiDeliveryMemosPostResponse>(getCreateOrUpdateDeliveryMemoApiDeliveryMemosPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deliveryMemoCreate,)
  }
);}



/**
 * @summary Delivery Memo Pdf
 */
export type deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponseSuccess = (deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponse200) & {
  headers: Headers;
};
export type deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponseError = (deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponse422) & {
  headers: Headers;
};

export type deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponse = (deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponseSuccess | deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponseError)

export const getDeliveryMemoPdfApiDeliveryMemosMemoIdPdfGetUrl = (memoId: string,) => {


  

  return `/api/delivery-memos/${memoId}/pdf`
}

export const deliveryMemoPdfApiDeliveryMemosMemoIdPdfGet = async (memoId: string, options?: RequestInit): Promise<deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponse> => {
  
  return customFetch<deliveryMemoPdfApiDeliveryMemosMemoIdPdfGetResponse>(getDeliveryMemoPdfApiDeliveryMemosMemoIdPdfGetUrl(memoId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Invoices
 */
export type listInvoicesApiInvoicesGetResponse200 = {
  data: InvoiceList
  status: 200
}

export type listInvoicesApiInvoicesGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listInvoicesApiInvoicesGetResponseSuccess = (listInvoicesApiInvoicesGetResponse200) & {
  headers: Headers;
};
export type listInvoicesApiInvoicesGetResponseError = (listInvoicesApiInvoicesGetResponse422) & {
  headers: Headers;
};

export type listInvoicesApiInvoicesGetResponse = (listInvoicesApiInvoicesGetResponseSuccess | listInvoicesApiInvoicesGetResponseError)

export const getListInvoicesApiInvoicesGetUrl = (params?: ListInvoicesApiInvoicesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices/?${stringifiedParams}` : `/api/invoices/`
}

export const listInvoicesApiInvoicesGet = async (params?: ListInvoicesApiInvoicesGetParams, options?: RequestInit): Promise<listInvoicesApiInvoicesGetResponse> => {
  
  return customFetch<listInvoicesApiInvoicesGetResponse>(getListInvoicesApiInvoicesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Invoice
 */
export type createInvoiceApiInvoicesPostResponse201 = {
  data: CreateInvoiceApiInvoicesPost201
  status: 201
}

export type createInvoiceApiInvoicesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createInvoiceApiInvoicesPostResponseSuccess = (createInvoiceApiInvoicesPostResponse201) & {
  headers: Headers;
};
export type createInvoiceApiInvoicesPostResponseError = (createInvoiceApiInvoicesPostResponse422) & {
  headers: Headers;
};

export type createInvoiceApiInvoicesPostResponse = (createInvoiceApiInvoicesPostResponseSuccess | createInvoiceApiInvoicesPostResponseError)

export const getCreateInvoiceApiInvoicesPostUrl = () => {


  

  return `/api/invoices/`
}

export const createInvoiceApiInvoicesPost = async (invoiceCreate: InvoiceCreate, options?: RequestInit): Promise<createInvoiceApiInvoicesPostResponse> => {
  
  return customFetch<createInvoiceApiInvoicesPostResponse>(getCreateInvoiceApiInvoicesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      invoiceCreate,)
  }
);}



/**
 * Header + bilty lines + receipts — the screen the client asked for:
"bill बनने के बाद वो कहाँ reflect हो रहा है" (V49).
 * @summary Get Invoice
 */
export type getInvoiceApiInvoicesInvoiceIdGetResponse200 = {
  data: InvoiceDetail
  status: 200
}

export type getInvoiceApiInvoicesInvoiceIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getInvoiceApiInvoicesInvoiceIdGetResponseSuccess = (getInvoiceApiInvoicesInvoiceIdGetResponse200) & {
  headers: Headers;
};
export type getInvoiceApiInvoicesInvoiceIdGetResponseError = (getInvoiceApiInvoicesInvoiceIdGetResponse422) & {
  headers: Headers;
};

export type getInvoiceApiInvoicesInvoiceIdGetResponse = (getInvoiceApiInvoicesInvoiceIdGetResponseSuccess | getInvoiceApiInvoicesInvoiceIdGetResponseError)

export const getGetInvoiceApiInvoicesInvoiceIdGetUrl = (invoiceId: string,) => {


  

  return `/api/invoices/${invoiceId}`
}

export const getInvoiceApiInvoicesInvoiceIdGet = async (invoiceId: string, options?: RequestInit): Promise<getInvoiceApiInvoicesInvoiceIdGetResponse> => {
  
  return customFetch<getInvoiceApiInvoicesInvoiceIdGetResponse>(getGetInvoiceApiInvoicesInvoiceIdGetUrl(invoiceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Delete Invoice
 */
export type deleteInvoiceApiInvoicesInvoiceIdDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteInvoiceApiInvoicesInvoiceIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteInvoiceApiInvoicesInvoiceIdDeleteResponseSuccess = (deleteInvoiceApiInvoicesInvoiceIdDeleteResponse204) & {
  headers: Headers;
};
export type deleteInvoiceApiInvoicesInvoiceIdDeleteResponseError = (deleteInvoiceApiInvoicesInvoiceIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteInvoiceApiInvoicesInvoiceIdDeleteResponse = (deleteInvoiceApiInvoicesInvoiceIdDeleteResponseSuccess | deleteInvoiceApiInvoicesInvoiceIdDeleteResponseError)

export const getDeleteInvoiceApiInvoicesInvoiceIdDeleteUrl = (invoiceId: string,) => {


  

  return `/api/invoices/${invoiceId}`
}

export const deleteInvoiceApiInvoicesInvoiceIdDelete = async (invoiceId: string, options?: RequestInit): Promise<deleteInvoiceApiInvoicesInvoiceIdDeleteResponse> => {
  
  return customFetch<deleteInvoiceApiInvoicesInvoiceIdDeleteResponse>(getDeleteInvoiceApiInvoicesInvoiceIdDeleteUrl(invoiceId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Create Customer Batch
 */
export type createCustomerBatchApiInvoicesCustomerBatchPostResponse201 = {
  data: InvoiceBatchRead
  status: 201
}

export type createCustomerBatchApiInvoicesCustomerBatchPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createCustomerBatchApiInvoicesCustomerBatchPostResponseSuccess = (createCustomerBatchApiInvoicesCustomerBatchPostResponse201) & {
  headers: Headers;
};
export type createCustomerBatchApiInvoicesCustomerBatchPostResponseError = (createCustomerBatchApiInvoicesCustomerBatchPostResponse422) & {
  headers: Headers;
};

export type createCustomerBatchApiInvoicesCustomerBatchPostResponse = (createCustomerBatchApiInvoicesCustomerBatchPostResponseSuccess | createCustomerBatchApiInvoicesCustomerBatchPostResponseError)

export const getCreateCustomerBatchApiInvoicesCustomerBatchPostUrl = () => {


  

  return `/api/invoices/customer-batch`
}

export const createCustomerBatchApiInvoicesCustomerBatchPost = async (invoiceBatchCreate: InvoiceBatchCreate, options?: RequestInit): Promise<createCustomerBatchApiInvoicesCustomerBatchPostResponse> => {
  
  return customFetch<createCustomerBatchApiInvoicesCustomerBatchPostResponse>(getCreateCustomerBatchApiInvoicesCustomerBatchPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      invoiceBatchCreate,)
  }
);}



/**
 * @summary Link Invoice Bilty
 */
export type linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponse201 = {
  data: LinkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPost201
  status: 201
}

export type linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponseSuccess = (linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponse201) & {
  headers: Headers;
};
export type linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponseError = (linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponse422) & {
  headers: Headers;
};

export type linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponse = (linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponseSuccess | linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponseError)

export const getLinkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostUrl = (invoiceId: string,) => {


  

  return `/api/invoices/${invoiceId}/bilties`
}

export const linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPost = async (invoiceId: string,
    linkBiltyBody: LinkBiltyBody, options?: RequestInit): Promise<linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponse> => {
  
  return customFetch<linkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostResponse>(getLinkInvoiceBiltyApiInvoicesInvoiceIdBiltiesPostUrl(invoiceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      linkBiltyBody,)
  }
);}



/**
 * @summary Invoice Pdf
 */
export type invoicePdfApiInvoicesInvoiceIdPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type invoicePdfApiInvoicesInvoiceIdPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type invoicePdfApiInvoicesInvoiceIdPdfGetResponseSuccess = (invoicePdfApiInvoicesInvoiceIdPdfGetResponse200) & {
  headers: Headers;
};
export type invoicePdfApiInvoicesInvoiceIdPdfGetResponseError = (invoicePdfApiInvoicesInvoiceIdPdfGetResponse422) & {
  headers: Headers;
};

export type invoicePdfApiInvoicesInvoiceIdPdfGetResponse = (invoicePdfApiInvoicesInvoiceIdPdfGetResponseSuccess | invoicePdfApiInvoicesInvoiceIdPdfGetResponseError)

export const getInvoicePdfApiInvoicesInvoiceIdPdfGetUrl = (invoiceId: string,) => {


  

  return `/api/invoices/${invoiceId}/pdf`
}

export const invoicePdfApiInvoicesInvoiceIdPdfGet = async (invoiceId: string, options?: RequestInit): Promise<invoicePdfApiInvoicesInvoiceIdPdfGetResponse> => {
  
  return customFetch<invoicePdfApiInvoicesInvoiceIdPdfGetResponse>(getInvoicePdfApiInvoicesInvoiceIdPdfGetUrl(invoiceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Lhcs
 */
export type listLhcsApiLorryHireChallansGetResponse200 = {
  data: LhcList
  status: 200
}

export type listLhcsApiLorryHireChallansGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listLhcsApiLorryHireChallansGetResponseSuccess = (listLhcsApiLorryHireChallansGetResponse200) & {
  headers: Headers;
};
export type listLhcsApiLorryHireChallansGetResponseError = (listLhcsApiLorryHireChallansGetResponse422) & {
  headers: Headers;
};

export type listLhcsApiLorryHireChallansGetResponse = (listLhcsApiLorryHireChallansGetResponseSuccess | listLhcsApiLorryHireChallansGetResponseError)

export const getListLhcsApiLorryHireChallansGetUrl = (params?: ListLhcsApiLorryHireChallansGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lorry-hire-challans/?${stringifiedParams}` : `/api/lorry-hire-challans/`
}

export const listLhcsApiLorryHireChallansGet = async (params?: ListLhcsApiLorryHireChallansGetParams, options?: RequestInit): Promise<listLhcsApiLorryHireChallansGetResponse> => {
  
  return customFetch<listLhcsApiLorryHireChallansGetResponse>(getListLhcsApiLorryHireChallansGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Lhc
 */
export type createLhcApiLorryHireChallansPostResponse201 = {
  data: LhcRead
  status: 201
}

export type createLhcApiLorryHireChallansPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createLhcApiLorryHireChallansPostResponseSuccess = (createLhcApiLorryHireChallansPostResponse201) & {
  headers: Headers;
};
export type createLhcApiLorryHireChallansPostResponseError = (createLhcApiLorryHireChallansPostResponse422) & {
  headers: Headers;
};

export type createLhcApiLorryHireChallansPostResponse = (createLhcApiLorryHireChallansPostResponseSuccess | createLhcApiLorryHireChallansPostResponseError)

export const getCreateLhcApiLorryHireChallansPostUrl = () => {


  

  return `/api/lorry-hire-challans/`
}

export const createLhcApiLorryHireChallansPost = async (lhcCreate: LhcCreate, options?: RequestInit): Promise<createLhcApiLorryHireChallansPostResponse> => {
  
  return customFetch<createLhcApiLorryHireChallansPostResponse>(getCreateLhcApiLorryHireChallansPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      lhcCreate,)
  }
);}



/**
 * @summary Get Lhc
 */
export type getLhcApiLorryHireChallansLhcIdGetResponse200 = {
  data: LhcRead
  status: 200
}

export type getLhcApiLorryHireChallansLhcIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getLhcApiLorryHireChallansLhcIdGetResponseSuccess = (getLhcApiLorryHireChallansLhcIdGetResponse200) & {
  headers: Headers;
};
export type getLhcApiLorryHireChallansLhcIdGetResponseError = (getLhcApiLorryHireChallansLhcIdGetResponse422) & {
  headers: Headers;
};

export type getLhcApiLorryHireChallansLhcIdGetResponse = (getLhcApiLorryHireChallansLhcIdGetResponseSuccess | getLhcApiLorryHireChallansLhcIdGetResponseError)

export const getGetLhcApiLorryHireChallansLhcIdGetUrl = (lhcId: string,) => {


  

  return `/api/lorry-hire-challans/${lhcId}`
}

export const getLhcApiLorryHireChallansLhcIdGet = async (lhcId: string, options?: RequestInit): Promise<getLhcApiLorryHireChallansLhcIdGetResponse> => {
  
  return customFetch<getLhcApiLorryHireChallansLhcIdGetResponse>(getGetLhcApiLorryHireChallansLhcIdGetUrl(lhcId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Patch Lhc
 */
export type patchLhcApiLorryHireChallansLhcIdPatchResponse200 = {
  data: LhcRead
  status: 200
}

export type patchLhcApiLorryHireChallansLhcIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type patchLhcApiLorryHireChallansLhcIdPatchResponseSuccess = (patchLhcApiLorryHireChallansLhcIdPatchResponse200) & {
  headers: Headers;
};
export type patchLhcApiLorryHireChallansLhcIdPatchResponseError = (patchLhcApiLorryHireChallansLhcIdPatchResponse422) & {
  headers: Headers;
};

export type patchLhcApiLorryHireChallansLhcIdPatchResponse = (patchLhcApiLorryHireChallansLhcIdPatchResponseSuccess | patchLhcApiLorryHireChallansLhcIdPatchResponseError)

export const getPatchLhcApiLorryHireChallansLhcIdPatchUrl = (lhcId: string,) => {


  

  return `/api/lorry-hire-challans/${lhcId}`
}

export const patchLhcApiLorryHireChallansLhcIdPatch = async (lhcId: string,
    lhcUpdate: LhcUpdate, options?: RequestInit): Promise<patchLhcApiLorryHireChallansLhcIdPatchResponse> => {
  
  return customFetch<patchLhcApiLorryHireChallansLhcIdPatchResponse>(getPatchLhcApiLorryHireChallansLhcIdPatchUrl(lhcId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      lhcUpdate,)
  }
);}



/**
 * @summary Add Other Charge
 */
export type addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponse201 = {
  data: LhcRead
  status: 201
}

export type addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponseSuccess = (addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponse201) & {
  headers: Headers;
};
export type addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponseError = (addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponse422) & {
  headers: Headers;
};

export type addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponse = (addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponseSuccess | addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponseError)

export const getAddOtherChargeApiLorryHireChallansLhcIdOtherChargesPostUrl = (lhcId: string,) => {


  

  return `/api/lorry-hire-challans/${lhcId}/other-charges`
}

export const addOtherChargeApiLorryHireChallansLhcIdOtherChargesPost = async (lhcId: string,
    lhcOtherChargeCreate: LhcOtherChargeCreate, options?: RequestInit): Promise<addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponse> => {
  
  return customFetch<addOtherChargeApiLorryHireChallansLhcIdOtherChargesPostResponse>(getAddOtherChargeApiLorryHireChallansLhcIdOtherChargesPostUrl(lhcId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      lhcOtherChargeCreate,)
  }
);}



/**
 * @summary Settle Lhc
 */
export type settleLhcApiLorryHireChallansLhcIdSettlePostResponse200 = {
  data: LhcRead
  status: 200
}

export type settleLhcApiLorryHireChallansLhcIdSettlePostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type settleLhcApiLorryHireChallansLhcIdSettlePostResponseSuccess = (settleLhcApiLorryHireChallansLhcIdSettlePostResponse200) & {
  headers: Headers;
};
export type settleLhcApiLorryHireChallansLhcIdSettlePostResponseError = (settleLhcApiLorryHireChallansLhcIdSettlePostResponse422) & {
  headers: Headers;
};

export type settleLhcApiLorryHireChallansLhcIdSettlePostResponse = (settleLhcApiLorryHireChallansLhcIdSettlePostResponseSuccess | settleLhcApiLorryHireChallansLhcIdSettlePostResponseError)

export const getSettleLhcApiLorryHireChallansLhcIdSettlePostUrl = (lhcId: string,) => {


  

  return `/api/lorry-hire-challans/${lhcId}/settle`
}

export const settleLhcApiLorryHireChallansLhcIdSettlePost = async (lhcId: string, options?: RequestInit): Promise<settleLhcApiLorryHireChallansLhcIdSettlePostResponse> => {
  
  return customFetch<settleLhcApiLorryHireChallansLhcIdSettlePostResponse>(getSettleLhcApiLorryHireChallansLhcIdSettlePostUrl(lhcId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Record a balance payment to the owner; settles the LHC when it hits ₹0 (V49).
 * @summary Add Lhc Payment
 */
export type addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponse201 = {
  data: LhcRead
  status: 201
}

export type addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponseSuccess = (addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponse201) & {
  headers: Headers;
};
export type addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponseError = (addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponse422) & {
  headers: Headers;
};

export type addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponse = (addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponseSuccess | addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponseError)

export const getAddLhcPaymentApiLorryHireChallansLhcIdPaymentsPostUrl = (lhcId: string,) => {


  

  return `/api/lorry-hire-challans/${lhcId}/payments`
}

export const addLhcPaymentApiLorryHireChallansLhcIdPaymentsPost = async (lhcId: string,
    vendorPaymentCreate: VendorPaymentCreate, options?: RequestInit): Promise<addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponse> => {
  
  return customFetch<addLhcPaymentApiLorryHireChallansLhcIdPaymentsPostResponse>(getAddLhcPaymentApiLorryHireChallansLhcIdPaymentsPostUrl(lhcId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vendorPaymentCreate,)
  }
);}



/**
 * Admin undo of a wrong entry — reopens the LHC.
 * @summary Delete Lhc Payment
 */
export type deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponse200 = {
  data: LhcRead
  status: 200
}

export type deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponseSuccess = (deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponse200) & {
  headers: Headers;
};
export type deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponseError = (deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponse = (deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponseSuccess | deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponseError)

export const getDeleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteUrl = (lhcId: string,
    paymentId: string,) => {


  

  return `/api/lorry-hire-challans/${lhcId}/payments/${paymentId}`
}

export const deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDelete = async (lhcId: string,
    paymentId: string, options?: RequestInit): Promise<deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponse> => {
  
  return customFetch<deleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteResponse>(getDeleteLhcPaymentApiLorryHireChallansLhcIdPaymentsPaymentIdDeleteUrl(lhcId,paymentId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Lhc Pdf
 */
export type lhcPdfApiLorryHireChallansLhcIdPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type lhcPdfApiLorryHireChallansLhcIdPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type lhcPdfApiLorryHireChallansLhcIdPdfGetResponseSuccess = (lhcPdfApiLorryHireChallansLhcIdPdfGetResponse200) & {
  headers: Headers;
};
export type lhcPdfApiLorryHireChallansLhcIdPdfGetResponseError = (lhcPdfApiLorryHireChallansLhcIdPdfGetResponse422) & {
  headers: Headers;
};

export type lhcPdfApiLorryHireChallansLhcIdPdfGetResponse = (lhcPdfApiLorryHireChallansLhcIdPdfGetResponseSuccess | lhcPdfApiLorryHireChallansLhcIdPdfGetResponseError)

export const getLhcPdfApiLorryHireChallansLhcIdPdfGetUrl = (lhcId: string,) => {


  

  return `/api/lorry-hire-challans/${lhcId}/pdf`
}

export const lhcPdfApiLorryHireChallansLhcIdPdfGet = async (lhcId: string, options?: RequestInit): Promise<lhcPdfApiLorryHireChallansLhcIdPdfGetResponse> => {
  
  return customFetch<lhcPdfApiLorryHireChallansLhcIdPdfGetResponse>(getLhcPdfApiLorryHireChallansLhcIdPdfGetUrl(lhcId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Toll Plazas
 */
export type listTollPlazasApiTollPlazasGetResponse200 = {
  data: TollPlazaList
  status: 200
}
    
export type listTollPlazasApiTollPlazasGetResponseSuccess = (listTollPlazasApiTollPlazasGetResponse200) & {
  headers: Headers;
};
;

export type listTollPlazasApiTollPlazasGetResponse = (listTollPlazasApiTollPlazasGetResponseSuccess)

export const getListTollPlazasApiTollPlazasGetUrl = () => {


  

  return `/api/toll-plazas/`
}

export const listTollPlazasApiTollPlazasGet = async ( options?: RequestInit): Promise<listTollPlazasApiTollPlazasGetResponse> => {
  
  return customFetch<listTollPlazasApiTollPlazasGetResponse>(getListTollPlazasApiTollPlazasGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Toll Plaza
 */
export type updateTollPlazaApiTollPlazasPlazaIdPatchResponse200 = {
  data: TollPlazaRead
  status: 200
}

export type updateTollPlazaApiTollPlazasPlazaIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updateTollPlazaApiTollPlazasPlazaIdPatchResponseSuccess = (updateTollPlazaApiTollPlazasPlazaIdPatchResponse200) & {
  headers: Headers;
};
export type updateTollPlazaApiTollPlazasPlazaIdPatchResponseError = (updateTollPlazaApiTollPlazasPlazaIdPatchResponse422) & {
  headers: Headers;
};

export type updateTollPlazaApiTollPlazasPlazaIdPatchResponse = (updateTollPlazaApiTollPlazasPlazaIdPatchResponseSuccess | updateTollPlazaApiTollPlazasPlazaIdPatchResponseError)

export const getUpdateTollPlazaApiTollPlazasPlazaIdPatchUrl = (plazaId: string,) => {


  

  return `/api/toll-plazas/${plazaId}`
}

export const updateTollPlazaApiTollPlazasPlazaIdPatch = async (plazaId: string,
    tollPlazaUpdate: TollPlazaUpdate, options?: RequestInit): Promise<updateTollPlazaApiTollPlazasPlazaIdPatchResponse> => {
  
  return customFetch<updateTollPlazaApiTollPlazasPlazaIdPatchResponse>(getUpdateTollPlazaApiTollPlazasPlazaIdPatchUrl(plazaId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tollPlazaUpdate,)
  }
);}



/**
 * @summary List Journeys
 */
export type listJourneysApiTrackJourneysGetResponse200 = {
  data: JourneyList
  status: 200
}
    
export type listJourneysApiTrackJourneysGetResponseSuccess = (listJourneysApiTrackJourneysGetResponse200) & {
  headers: Headers;
};
;

export type listJourneysApiTrackJourneysGetResponse = (listJourneysApiTrackJourneysGetResponseSuccess)

export const getListJourneysApiTrackJourneysGetUrl = () => {


  

  return `/api/track/journeys`
}

export const listJourneysApiTrackJourneysGet = async ( options?: RequestInit): Promise<listJourneysApiTrackJourneysGetResponse> => {
  
  return customFetch<listJourneysApiTrackJourneysGetResponse>(getListJourneysApiTrackJourneysGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Journey For Bilty
 */
export type journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponse200 = {
  data: JourneyRead
  status: 200
}

export type journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponseSuccess = (journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponse200) & {
  headers: Headers;
};
export type journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponseError = (journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponse422) & {
  headers: Headers;
};

export type journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponse = (journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponseSuccess | journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponseError)

export const getJourneyForBiltyApiTrackBiltyBiltyIdJourneyGetUrl = (biltyId: string,) => {


  

  return `/api/track/bilty/${biltyId}/journey`
}

export const journeyForBiltyApiTrackBiltyBiltyIdJourneyGet = async (biltyId: string, options?: RequestInit): Promise<journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponse> => {
  
  return customFetch<journeyForBiltyApiTrackBiltyBiltyIdJourneyGetResponse>(getJourneyForBiltyApiTrackBiltyBiltyIdJourneyGetUrl(biltyId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Read any truck's toll window on demand, with no bilty and no storage.

Admin-only because each call is billable. Nothing is written: this answers
"where has this lorry been" for a truck that may have no paperwork at all.

The provider's own refusal is passed through verbatim — an empty prepaid
wallet is the operator's to fix, and a generic 500 would reach the portal as
"Something went wrong", sending them hunting through our code instead.
 * @summary Lookup Truck
 */
export type lookupTruckApiTrackLookupGetResponse200 = {
  data: TruckLookupRead
  status: 200
}

export type lookupTruckApiTrackLookupGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type lookupTruckApiTrackLookupGetResponseSuccess = (lookupTruckApiTrackLookupGetResponse200) & {
  headers: Headers;
};
export type lookupTruckApiTrackLookupGetResponseError = (lookupTruckApiTrackLookupGetResponse422) & {
  headers: Headers;
};

export type lookupTruckApiTrackLookupGetResponse = (lookupTruckApiTrackLookupGetResponseSuccess | lookupTruckApiTrackLookupGetResponseError)

export const getLookupTruckApiTrackLookupGetUrl = (params: LookupTruckApiTrackLookupGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/track/lookup?${stringifiedParams}` : `/api/track/lookup`
}

export const lookupTruckApiTrackLookupGet = async (params: LookupTruckApiTrackLookupGetParams, options?: RequestInit): Promise<lookupTruckApiTrackLookupGetResponse> => {
  
  return customFetch<lookupTruckApiTrackLookupGetResponse>(getLookupTruckApiTrackLookupGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Poll this bilty's truck right now instead of waiting for the schedule.

Admin-only and rate-limited per truck: every press is a billable IDSPay
call, so the case worth stopping is two people refreshing the same truck.
 * @summary Refresh Bilty Journey
 */
export type refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponse200 = {
  data: JourneyRead
  status: 200
}

export type refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponseSuccess = (refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponse200) & {
  headers: Headers;
};
export type refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponseError = (refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponse422) & {
  headers: Headers;
};

export type refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponse = (refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponseSuccess | refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponseError)

export const getRefreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostUrl = (biltyId: string,) => {


  

  return `/api/track/bilty/${biltyId}/refresh`
}

export const refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPost = async (biltyId: string, options?: RequestInit): Promise<refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponse> => {
  
  return customFetch<refreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostResponse>(getRefreshBiltyJourneyApiTrackBiltyBiltyIdRefreshPostUrl(biltyId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Recipients
 */
export type listRecipientsApiWhatsappRecipientsGetResponse200 = {
  data: WaSessionList
  status: 200
}
    
export type listRecipientsApiWhatsappRecipientsGetResponseSuccess = (listRecipientsApiWhatsappRecipientsGetResponse200) & {
  headers: Headers;
};
;

export type listRecipientsApiWhatsappRecipientsGetResponse = (listRecipientsApiWhatsappRecipientsGetResponseSuccess)

export const getListRecipientsApiWhatsappRecipientsGetUrl = () => {


  

  return `/api/whatsapp/recipients`
}

export const listRecipientsApiWhatsappRecipientsGet = async ( options?: RequestInit): Promise<listRecipientsApiWhatsappRecipientsGetResponse> => {
  
  return customFetch<listRecipientsApiWhatsappRecipientsGetResponse>(getListRecipientsApiWhatsappRecipientsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Recipient
 */
export type createRecipientApiWhatsappRecipientsPostResponse201 = {
  data: WaSessionRead
  status: 201
}

export type createRecipientApiWhatsappRecipientsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createRecipientApiWhatsappRecipientsPostResponseSuccess = (createRecipientApiWhatsappRecipientsPostResponse201) & {
  headers: Headers;
};
export type createRecipientApiWhatsappRecipientsPostResponseError = (createRecipientApiWhatsappRecipientsPostResponse422) & {
  headers: Headers;
};

export type createRecipientApiWhatsappRecipientsPostResponse = (createRecipientApiWhatsappRecipientsPostResponseSuccess | createRecipientApiWhatsappRecipientsPostResponseError)

export const getCreateRecipientApiWhatsappRecipientsPostUrl = () => {


  

  return `/api/whatsapp/recipients`
}

export const createRecipientApiWhatsappRecipientsPost = async (waSessionCreate: WaSessionCreate, options?: RequestInit): Promise<createRecipientApiWhatsappRecipientsPostResponse> => {
  
  return customFetch<createRecipientApiWhatsappRecipientsPostResponse>(getCreateRecipientApiWhatsappRecipientsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      waSessionCreate,)
  }
);}



/**
 * Polled by the settings page every few seconds while a link is pending.
 * @summary Get Recipient Qr
 */
export type getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponse200 = {
  data: WaSessionQr
  status: 200
}

export type getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponseSuccess = (getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponse200) & {
  headers: Headers;
};
export type getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponseError = (getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponse422) & {
  headers: Headers;
};

export type getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponse = (getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponseSuccess | getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponseError)

export const getGetRecipientQrApiWhatsappRecipientsSessionIdQrGetUrl = (sessionId: string,) => {


  

  return `/api/whatsapp/recipients/${sessionId}/qr`
}

export const getRecipientQrApiWhatsappRecipientsSessionIdQrGet = async (sessionId: string, options?: RequestInit): Promise<getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponse> => {
  
  return customFetch<getRecipientQrApiWhatsappRecipientsSessionIdQrGetResponse>(getGetRecipientQrApiWhatsappRecipientsSessionIdQrGetUrl(sessionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Unlink Recipient
 */
export type unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponse200 = {
  data: WaSessionRead
  status: 200
}

export type unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponseSuccess = (unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponse200) & {
  headers: Headers;
};
export type unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponseError = (unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponse422) & {
  headers: Headers;
};

export type unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponse = (unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponseSuccess | unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponseError)

export const getUnlinkRecipientApiWhatsappRecipientsSessionIdDeleteUrl = (sessionId: string,) => {


  

  return `/api/whatsapp/recipients/${sessionId}`
}

export const unlinkRecipientApiWhatsappRecipientsSessionIdDelete = async (sessionId: string, options?: RequestInit): Promise<unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponse> => {
  
  return customFetch<unlinkRecipientApiWhatsappRecipientsSessionIdDeleteResponse>(getUnlinkRecipientApiWhatsappRecipientsSessionIdDeleteUrl(sessionId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Poll Truck Pings
 */
export type pollTruckPingsApiInternalPollTruckPingsPostResponse200 = {
  data: PollSummaryRead
  status: 200
}

export type pollTruckPingsApiInternalPollTruckPingsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type pollTruckPingsApiInternalPollTruckPingsPostResponseSuccess = (pollTruckPingsApiInternalPollTruckPingsPostResponse200) & {
  headers: Headers;
};
export type pollTruckPingsApiInternalPollTruckPingsPostResponseError = (pollTruckPingsApiInternalPollTruckPingsPostResponse422) & {
  headers: Headers;
};

export type pollTruckPingsApiInternalPollTruckPingsPostResponse = (pollTruckPingsApiInternalPollTruckPingsPostResponseSuccess | pollTruckPingsApiInternalPollTruckPingsPostResponseError)

export const getPollTruckPingsApiInternalPollTruckPingsPostUrl = () => {


  

  return `/api/internal/poll-truck-pings`
}

export const pollTruckPingsApiInternalPollTruckPingsPost = async ( options?: RequestInit): Promise<pollTruckPingsApiInternalPollTruckPingsPostResponse> => {
  
  return customFetch<pollTruckPingsApiInternalPollTruckPingsPostResponse>(getPollTruckPingsApiInternalPollTruckPingsPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Fill city/state for plazas nobody has labelled yet.

Scheduled daily rather than run inline when a plaza is first seen: the poll
path must stay fast and must never depend on a third party being up. A new
plaza simply shows its bare name until the next night.
 * @summary Label Toll Plazas
 */
export type labelTollPlazasApiInternalLabelTollPlazasPostResponse200 = {
  data: LabelRunRead
  status: 200
}

export type labelTollPlazasApiInternalLabelTollPlazasPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type labelTollPlazasApiInternalLabelTollPlazasPostResponseSuccess = (labelTollPlazasApiInternalLabelTollPlazasPostResponse200) & {
  headers: Headers;
};
export type labelTollPlazasApiInternalLabelTollPlazasPostResponseError = (labelTollPlazasApiInternalLabelTollPlazasPostResponse422) & {
  headers: Headers;
};

export type labelTollPlazasApiInternalLabelTollPlazasPostResponse = (labelTollPlazasApiInternalLabelTollPlazasPostResponseSuccess | labelTollPlazasApiInternalLabelTollPlazasPostResponseError)

export const getLabelTollPlazasApiInternalLabelTollPlazasPostUrl = () => {


  

  return `/api/internal/label-toll-plazas`
}

export const labelTollPlazasApiInternalLabelTollPlazasPost = async ( options?: RequestInit): Promise<labelTollPlazasApiInternalLabelTollPlazasPostResponse> => {
  
  return customFetch<labelTollPlazasApiInternalLabelTollPlazasPostResponse>(getLabelTollPlazasApiInternalLabelTollPlazasPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Get Bilty 360
 */
export type getBilty360ApiReportsBilty360GetResponse200 = {
  data: Bilty360List
  status: 200
}

export type getBilty360ApiReportsBilty360GetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getBilty360ApiReportsBilty360GetResponseSuccess = (getBilty360ApiReportsBilty360GetResponse200) & {
  headers: Headers;
};
export type getBilty360ApiReportsBilty360GetResponseError = (getBilty360ApiReportsBilty360GetResponse422) & {
  headers: Headers;
};

export type getBilty360ApiReportsBilty360GetResponse = (getBilty360ApiReportsBilty360GetResponseSuccess | getBilty360ApiReportsBilty360GetResponseError)

export const getGetBilty360ApiReportsBilty360GetUrl = (params?: GetBilty360ApiReportsBilty360GetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/bilty-360?${stringifiedParams}` : `/api/reports/bilty-360`
}

export const getBilty360ApiReportsBilty360Get = async (params?: GetBilty360ApiReportsBilty360GetParams, options?: RequestInit): Promise<getBilty360ApiReportsBilty360GetResponse> => {
  
  return customFetch<getBilty360ApiReportsBilty360GetResponse>(getGetBilty360ApiReportsBilty360GetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Document Distribution
 */
export type getDocumentDistributionApiReportsDocumentDistributionGetResponse200 = {
  data: DocumentDistributionResponse
  status: 200
}

export type getDocumentDistributionApiReportsDocumentDistributionGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getDocumentDistributionApiReportsDocumentDistributionGetResponseSuccess = (getDocumentDistributionApiReportsDocumentDistributionGetResponse200) & {
  headers: Headers;
};
export type getDocumentDistributionApiReportsDocumentDistributionGetResponseError = (getDocumentDistributionApiReportsDocumentDistributionGetResponse422) & {
  headers: Headers;
};

export type getDocumentDistributionApiReportsDocumentDistributionGetResponse = (getDocumentDistributionApiReportsDocumentDistributionGetResponseSuccess | getDocumentDistributionApiReportsDocumentDistributionGetResponseError)

export const getGetDocumentDistributionApiReportsDocumentDistributionGetUrl = (params: GetDocumentDistributionApiReportsDocumentDistributionGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/document-distribution?${stringifiedParams}` : `/api/reports/document-distribution`
}

export const getDocumentDistributionApiReportsDocumentDistributionGet = async (params: GetDocumentDistributionApiReportsDocumentDistributionGetParams, options?: RequestInit): Promise<getDocumentDistributionApiReportsDocumentDistributionGetResponse> => {
  
  return customFetch<getDocumentDistributionApiReportsDocumentDistributionGetResponse>(getGetDocumentDistributionApiReportsDocumentDistributionGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Party Ledger
 */
export type partyLedgerApiLedgersPartyPartyIdGetResponse200 = {
  data: PartyLedgerResponse
  status: 200
}

export type partyLedgerApiLedgersPartyPartyIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type partyLedgerApiLedgersPartyPartyIdGetResponseSuccess = (partyLedgerApiLedgersPartyPartyIdGetResponse200) & {
  headers: Headers;
};
export type partyLedgerApiLedgersPartyPartyIdGetResponseError = (partyLedgerApiLedgersPartyPartyIdGetResponse422) & {
  headers: Headers;
};

export type partyLedgerApiLedgersPartyPartyIdGetResponse = (partyLedgerApiLedgersPartyPartyIdGetResponseSuccess | partyLedgerApiLedgersPartyPartyIdGetResponseError)

export const getPartyLedgerApiLedgersPartyPartyIdGetUrl = (partyId: string,
    params: PartyLedgerApiLedgersPartyPartyIdGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ledgers/party/${partyId}?${stringifiedParams}` : `/api/ledgers/party/${partyId}`
}

export const partyLedgerApiLedgersPartyPartyIdGet = async (partyId: string,
    params: PartyLedgerApiLedgersPartyPartyIdGetParams, options?: RequestInit): Promise<partyLedgerApiLedgersPartyPartyIdGetResponse> => {
  
  return customFetch<partyLedgerApiLedgersPartyPartyIdGetResponse>(getPartyLedgerApiLedgersPartyPartyIdGetUrl(partyId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Vendor Ledger
 */
export type vendorLedgerApiLedgersVendorVendorIdGetResponse200 = {
  data: VendorLedgerResponse
  status: 200
}

export type vendorLedgerApiLedgersVendorVendorIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type vendorLedgerApiLedgersVendorVendorIdGetResponseSuccess = (vendorLedgerApiLedgersVendorVendorIdGetResponse200) & {
  headers: Headers;
};
export type vendorLedgerApiLedgersVendorVendorIdGetResponseError = (vendorLedgerApiLedgersVendorVendorIdGetResponse422) & {
  headers: Headers;
};

export type vendorLedgerApiLedgersVendorVendorIdGetResponse = (vendorLedgerApiLedgersVendorVendorIdGetResponseSuccess | vendorLedgerApiLedgersVendorVendorIdGetResponseError)

export const getVendorLedgerApiLedgersVendorVendorIdGetUrl = (vendorId: string,
    params: VendorLedgerApiLedgersVendorVendorIdGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ledgers/vendor/${vendorId}?${stringifiedParams}` : `/api/ledgers/vendor/${vendorId}`
}

export const vendorLedgerApiLedgersVendorVendorIdGet = async (vendorId: string,
    params: VendorLedgerApiLedgersVendorVendorIdGetParams, options?: RequestInit): Promise<vendorLedgerApiLedgersVendorVendorIdGetResponse> => {
  
  return customFetch<vendorLedgerApiLedgersVendorVendorIdGetResponse>(getVendorLedgerApiLedgersVendorVendorIdGetUrl(vendorId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Branch Pl
 */
export type branchPlApiLedgersBranchPlGetResponse200 = {
  data: BranchPLResponse
  status: 200
}

export type branchPlApiLedgersBranchPlGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type branchPlApiLedgersBranchPlGetResponseSuccess = (branchPlApiLedgersBranchPlGetResponse200) & {
  headers: Headers;
};
export type branchPlApiLedgersBranchPlGetResponseError = (branchPlApiLedgersBranchPlGetResponse422) & {
  headers: Headers;
};

export type branchPlApiLedgersBranchPlGetResponse = (branchPlApiLedgersBranchPlGetResponseSuccess | branchPlApiLedgersBranchPlGetResponseError)

export const getBranchPlApiLedgersBranchPlGetUrl = (params: BranchPlApiLedgersBranchPlGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ledgers/branch-pl?${stringifiedParams}` : `/api/ledgers/branch-pl`
}

export const branchPlApiLedgersBranchPlGet = async (params: BranchPlApiLedgersBranchPlGetParams, options?: RequestInit): Promise<branchPlApiLedgersBranchPlGetResponse> => {
  
  return customFetch<branchPlApiLedgersBranchPlGetResponse>(getBranchPlApiLedgersBranchPlGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Party Ledger Pdf
 */
export type partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponseSuccess = (partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponse200) & {
  headers: Headers;
};
export type partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponseError = (partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponse422) & {
  headers: Headers;
};

export type partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponse = (partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponseSuccess | partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponseError)

export const getPartyLedgerPdfApiLedgersPartyPartyIdPdfGetUrl = (partyId: string,
    params: PartyLedgerPdfApiLedgersPartyPartyIdPdfGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ledgers/party/${partyId}/pdf?${stringifiedParams}` : `/api/ledgers/party/${partyId}/pdf`
}

export const partyLedgerPdfApiLedgersPartyPartyIdPdfGet = async (partyId: string,
    params: PartyLedgerPdfApiLedgersPartyPartyIdPdfGetParams, options?: RequestInit): Promise<partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponse> => {
  
  return customFetch<partyLedgerPdfApiLedgersPartyPartyIdPdfGetResponse>(getPartyLedgerPdfApiLedgersPartyPartyIdPdfGetUrl(partyId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Vendor Ledger Pdf
 */
export type vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponseSuccess = (vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponse200) & {
  headers: Headers;
};
export type vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponseError = (vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponse422) & {
  headers: Headers;
};

export type vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponse = (vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponseSuccess | vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponseError)

export const getVendorLedgerPdfApiLedgersVendorVendorIdPdfGetUrl = (vendorId: string,
    params: VendorLedgerPdfApiLedgersVendorVendorIdPdfGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ledgers/vendor/${vendorId}/pdf?${stringifiedParams}` : `/api/ledgers/vendor/${vendorId}/pdf`
}

export const vendorLedgerPdfApiLedgersVendorVendorIdPdfGet = async (vendorId: string,
    params: VendorLedgerPdfApiLedgersVendorVendorIdPdfGetParams, options?: RequestInit): Promise<vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponse> => {
  
  return customFetch<vendorLedgerPdfApiLedgersVendorVendorIdPdfGetResponse>(getVendorLedgerPdfApiLedgersVendorVendorIdPdfGetUrl(vendorId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Branch Pl Pdf
 */
export type branchPlPdfApiLedgersBranchPlPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type branchPlPdfApiLedgersBranchPlPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type branchPlPdfApiLedgersBranchPlPdfGetResponseSuccess = (branchPlPdfApiLedgersBranchPlPdfGetResponse200) & {
  headers: Headers;
};
export type branchPlPdfApiLedgersBranchPlPdfGetResponseError = (branchPlPdfApiLedgersBranchPlPdfGetResponse422) & {
  headers: Headers;
};

export type branchPlPdfApiLedgersBranchPlPdfGetResponse = (branchPlPdfApiLedgersBranchPlPdfGetResponseSuccess | branchPlPdfApiLedgersBranchPlPdfGetResponseError)

export const getBranchPlPdfApiLedgersBranchPlPdfGetUrl = (params: BranchPlPdfApiLedgersBranchPlPdfGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ledgers/branch-pl/pdf?${stringifiedParams}` : `/api/ledgers/branch-pl/pdf`
}

export const branchPlPdfApiLedgersBranchPlPdfGet = async (params: BranchPlPdfApiLedgersBranchPlPdfGetParams, options?: RequestInit): Promise<branchPlPdfApiLedgersBranchPlPdfGetResponse> => {
  
  return customFetch<branchPlPdfApiLedgersBranchPlPdfGetResponse>(getBranchPlPdfApiLedgersBranchPlPdfGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Receipt
 */
export type createReceiptApiPaymentsReceiptsPostResponse201 = {
  data: ReceiptRead
  status: 201
}

export type createReceiptApiPaymentsReceiptsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createReceiptApiPaymentsReceiptsPostResponseSuccess = (createReceiptApiPaymentsReceiptsPostResponse201) & {
  headers: Headers;
};
export type createReceiptApiPaymentsReceiptsPostResponseError = (createReceiptApiPaymentsReceiptsPostResponse422) & {
  headers: Headers;
};

export type createReceiptApiPaymentsReceiptsPostResponse = (createReceiptApiPaymentsReceiptsPostResponseSuccess | createReceiptApiPaymentsReceiptsPostResponseError)

export const getCreateReceiptApiPaymentsReceiptsPostUrl = () => {


  

  return `/api/payments/receipts`
}

export const createReceiptApiPaymentsReceiptsPost = async (receiptCreate: ReceiptCreate, options?: RequestInit): Promise<createReceiptApiPaymentsReceiptsPostResponse> => {
  
  return customFetch<createReceiptApiPaymentsReceiptsPostResponse>(getCreateReceiptApiPaymentsReceiptsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      receiptCreate,)
  }
);}



/**
 * @summary List Receipts
 */
export type listReceiptsApiPaymentsReceiptsGetResponse200 = {
  data: ReceiptList
  status: 200
}

export type listReceiptsApiPaymentsReceiptsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listReceiptsApiPaymentsReceiptsGetResponseSuccess = (listReceiptsApiPaymentsReceiptsGetResponse200) & {
  headers: Headers;
};
export type listReceiptsApiPaymentsReceiptsGetResponseError = (listReceiptsApiPaymentsReceiptsGetResponse422) & {
  headers: Headers;
};

export type listReceiptsApiPaymentsReceiptsGetResponse = (listReceiptsApiPaymentsReceiptsGetResponseSuccess | listReceiptsApiPaymentsReceiptsGetResponseError)

export const getListReceiptsApiPaymentsReceiptsGetUrl = (params?: ListReceiptsApiPaymentsReceiptsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payments/receipts?${stringifiedParams}` : `/api/payments/receipts`
}

export const listReceiptsApiPaymentsReceiptsGet = async (params?: ListReceiptsApiPaymentsReceiptsGetParams, options?: RequestInit): Promise<listReceiptsApiPaymentsReceiptsGetResponse> => {
  
  return customFetch<listReceiptsApiPaymentsReceiptsGetResponse>(getListReceiptsApiPaymentsReceiptsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Receipt
 */
export type getReceiptApiPaymentsReceiptsReceiptIdGetResponse200 = {
  data: ReceiptRead
  status: 200
}

export type getReceiptApiPaymentsReceiptsReceiptIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getReceiptApiPaymentsReceiptsReceiptIdGetResponseSuccess = (getReceiptApiPaymentsReceiptsReceiptIdGetResponse200) & {
  headers: Headers;
};
export type getReceiptApiPaymentsReceiptsReceiptIdGetResponseError = (getReceiptApiPaymentsReceiptsReceiptIdGetResponse422) & {
  headers: Headers;
};

export type getReceiptApiPaymentsReceiptsReceiptIdGetResponse = (getReceiptApiPaymentsReceiptsReceiptIdGetResponseSuccess | getReceiptApiPaymentsReceiptsReceiptIdGetResponseError)

export const getGetReceiptApiPaymentsReceiptsReceiptIdGetUrl = (receiptId: string,) => {


  

  return `/api/payments/receipts/${receiptId}`
}

export const getReceiptApiPaymentsReceiptsReceiptIdGet = async (receiptId: string, options?: RequestInit): Promise<getReceiptApiPaymentsReceiptsReceiptIdGetResponse> => {
  
  return customFetch<getReceiptApiPaymentsReceiptsReceiptIdGetResponse>(getGetReceiptApiPaymentsReceiptsReceiptIdGetUrl(receiptId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Admin undo of a wrong entry — the invoices it covered reopen.
 * @summary Delete Receipt
 */
export type deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponseSuccess = (deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponse204) & {
  headers: Headers;
};
export type deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponseError = (deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponse = (deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponseSuccess | deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponseError)

export const getDeleteReceiptApiPaymentsReceiptsReceiptIdDeleteUrl = (receiptId: string,) => {


  

  return `/api/payments/receipts/${receiptId}`
}

export const deleteReceiptApiPaymentsReceiptsReceiptIdDelete = async (receiptId: string, options?: RequestInit): Promise<deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponse> => {
  
  return customFetch<deleteReceiptApiPaymentsReceiptsReceiptIdDeleteResponse>(getDeleteReceiptApiPaymentsReceiptsReceiptIdDeleteUrl(receiptId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * This customer's invoices with money still outstanding, oldest first.
 * @summary Open Invoices
 */
export type openInvoicesApiPaymentsOpenInvoicesGetResponse200 = {
  data: OpenInvoiceRow[]
  status: 200
}

export type openInvoicesApiPaymentsOpenInvoicesGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type openInvoicesApiPaymentsOpenInvoicesGetResponseSuccess = (openInvoicesApiPaymentsOpenInvoicesGetResponse200) & {
  headers: Headers;
};
export type openInvoicesApiPaymentsOpenInvoicesGetResponseError = (openInvoicesApiPaymentsOpenInvoicesGetResponse422) & {
  headers: Headers;
};

export type openInvoicesApiPaymentsOpenInvoicesGetResponse = (openInvoicesApiPaymentsOpenInvoicesGetResponseSuccess | openInvoicesApiPaymentsOpenInvoicesGetResponseError)

export const getOpenInvoicesApiPaymentsOpenInvoicesGetUrl = (params: OpenInvoicesApiPaymentsOpenInvoicesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payments/open-invoices?${stringifiedParams}` : `/api/payments/open-invoices`
}

export const openInvoicesApiPaymentsOpenInvoicesGet = async (params: OpenInvoicesApiPaymentsOpenInvoicesGetParams, options?: RequestInit): Promise<openInvoicesApiPaymentsOpenInvoicesGetResponse> => {
  
  return customFetch<openInvoicesApiPaymentsOpenInvoicesGetResponse>(getOpenInvoicesApiPaymentsOpenInvoicesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Outstanding
 */
export type outstandingApiPaymentsOutstandingGetResponse200 = {
  data: OutstandingResponse
  status: 200
}

export type outstandingApiPaymentsOutstandingGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type outstandingApiPaymentsOutstandingGetResponseSuccess = (outstandingApiPaymentsOutstandingGetResponse200) & {
  headers: Headers;
};
export type outstandingApiPaymentsOutstandingGetResponseError = (outstandingApiPaymentsOutstandingGetResponse422) & {
  headers: Headers;
};

export type outstandingApiPaymentsOutstandingGetResponse = (outstandingApiPaymentsOutstandingGetResponseSuccess | outstandingApiPaymentsOutstandingGetResponseError)

export const getOutstandingApiPaymentsOutstandingGetUrl = (params?: OutstandingApiPaymentsOutstandingGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payments/outstanding?${stringifiedParams}` : `/api/payments/outstanding`
}

export const outstandingApiPaymentsOutstandingGet = async (params?: OutstandingApiPaymentsOutstandingGetParams, options?: RequestInit): Promise<outstandingApiPaymentsOutstandingGetResponse> => {
  
  return customFetch<outstandingApiPaymentsOutstandingGetResponse>(getOutstandingApiPaymentsOutstandingGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Presigned PUT for a payment advice / covering letter (PDF or image).
 * @summary Attachment Upload Url
 */
export type attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponse200 = {
  data: AttachmentUploadUrlResponse
  status: 200
}

export type attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponseSuccess = (attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponse200) & {
  headers: Headers;
};
export type attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponseError = (attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponse422) & {
  headers: Headers;
};

export type attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponse = (attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponseSuccess | attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponseError)

export const getAttachmentUploadUrlApiPaymentsAttachmentUploadUrlPostUrl = () => {


  

  return `/api/payments/attachment-upload-url`
}

export const attachmentUploadUrlApiPaymentsAttachmentUploadUrlPost = async (attachmentUploadUrlRequest: AttachmentUploadUrlRequest, options?: RequestInit): Promise<attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponse> => {
  
  return customFetch<attachmentUploadUrlApiPaymentsAttachmentUploadUrlPostResponse>(getAttachmentUploadUrlApiPaymentsAttachmentUploadUrlPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      attachmentUploadUrlRequest,)
  }
);}



/**
 * @summary Attachment Redirect
 */
export type attachmentRedirectApiPaymentsAttachmentGetResponse200 = {
  data: unknown
  status: 200
}

export type attachmentRedirectApiPaymentsAttachmentGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type attachmentRedirectApiPaymentsAttachmentGetResponseSuccess = (attachmentRedirectApiPaymentsAttachmentGetResponse200) & {
  headers: Headers;
};
export type attachmentRedirectApiPaymentsAttachmentGetResponseError = (attachmentRedirectApiPaymentsAttachmentGetResponse422) & {
  headers: Headers;
};

export type attachmentRedirectApiPaymentsAttachmentGetResponse = (attachmentRedirectApiPaymentsAttachmentGetResponseSuccess | attachmentRedirectApiPaymentsAttachmentGetResponseError)

export const getAttachmentRedirectApiPaymentsAttachmentGetUrl = (params: AttachmentRedirectApiPaymentsAttachmentGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payments/attachment?${stringifiedParams}` : `/api/payments/attachment`
}

export const attachmentRedirectApiPaymentsAttachmentGet = async (params: AttachmentRedirectApiPaymentsAttachmentGetParams, options?: RequestInit): Promise<attachmentRedirectApiPaymentsAttachmentGetResponse> => {
  
  return customFetch<attachmentRedirectApiPaymentsAttachmentGetResponse>(getAttachmentRedirectApiPaymentsAttachmentGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Categories
 */
export type listCategoriesApiCashBookCategoriesGetResponse200 = {
  data: ExpenseCategoryRead[]
  status: 200
}

export type listCategoriesApiCashBookCategoriesGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listCategoriesApiCashBookCategoriesGetResponseSuccess = (listCategoriesApiCashBookCategoriesGetResponse200) & {
  headers: Headers;
};
export type listCategoriesApiCashBookCategoriesGetResponseError = (listCategoriesApiCashBookCategoriesGetResponse422) & {
  headers: Headers;
};

export type listCategoriesApiCashBookCategoriesGetResponse = (listCategoriesApiCashBookCategoriesGetResponseSuccess | listCategoriesApiCashBookCategoriesGetResponseError)

export const getListCategoriesApiCashBookCategoriesGetUrl = (params?: ListCategoriesApiCashBookCategoriesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/cash-book/categories?${stringifiedParams}` : `/api/cash-book/categories`
}

export const listCategoriesApiCashBookCategoriesGet = async (params?: ListCategoriesApiCashBookCategoriesGetParams, options?: RequestInit): Promise<listCategoriesApiCashBookCategoriesGetResponse> => {
  
  return customFetch<listCategoriesApiCashBookCategoriesGetResponse>(getListCategoriesApiCashBookCategoriesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Category
 */
export type createCategoryApiCashBookCategoriesPostResponse201 = {
  data: ExpenseCategoryRead
  status: 201
}

export type createCategoryApiCashBookCategoriesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createCategoryApiCashBookCategoriesPostResponseSuccess = (createCategoryApiCashBookCategoriesPostResponse201) & {
  headers: Headers;
};
export type createCategoryApiCashBookCategoriesPostResponseError = (createCategoryApiCashBookCategoriesPostResponse422) & {
  headers: Headers;
};

export type createCategoryApiCashBookCategoriesPostResponse = (createCategoryApiCashBookCategoriesPostResponseSuccess | createCategoryApiCashBookCategoriesPostResponseError)

export const getCreateCategoryApiCashBookCategoriesPostUrl = () => {


  

  return `/api/cash-book/categories`
}

export const createCategoryApiCashBookCategoriesPost = async (expenseCategoryCreate: ExpenseCategoryCreate, options?: RequestInit): Promise<createCategoryApiCashBookCategoriesPostResponse> => {
  
  return customFetch<createCategoryApiCashBookCategoriesPostResponse>(getCreateCategoryApiCashBookCategoriesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      expenseCategoryCreate,)
  }
);}



/**
 * @summary List Expenses
 */
export type listExpensesApiCashBookExpensesGetResponse200 = {
  data: ExpenseList
  status: 200
}

export type listExpensesApiCashBookExpensesGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listExpensesApiCashBookExpensesGetResponseSuccess = (listExpensesApiCashBookExpensesGetResponse200) & {
  headers: Headers;
};
export type listExpensesApiCashBookExpensesGetResponseError = (listExpensesApiCashBookExpensesGetResponse422) & {
  headers: Headers;
};

export type listExpensesApiCashBookExpensesGetResponse = (listExpensesApiCashBookExpensesGetResponseSuccess | listExpensesApiCashBookExpensesGetResponseError)

export const getListExpensesApiCashBookExpensesGetUrl = (params?: ListExpensesApiCashBookExpensesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/cash-book/expenses?${stringifiedParams}` : `/api/cash-book/expenses`
}

export const listExpensesApiCashBookExpensesGet = async (params?: ListExpensesApiCashBookExpensesGetParams, options?: RequestInit): Promise<listExpensesApiCashBookExpensesGetResponse> => {
  
  return customFetch<listExpensesApiCashBookExpensesGetResponse>(getListExpensesApiCashBookExpensesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Expense
 */
export type createExpenseApiCashBookExpensesPostResponse201 = {
  data: ExpenseRead
  status: 201
}

export type createExpenseApiCashBookExpensesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createExpenseApiCashBookExpensesPostResponseSuccess = (createExpenseApiCashBookExpensesPostResponse201) & {
  headers: Headers;
};
export type createExpenseApiCashBookExpensesPostResponseError = (createExpenseApiCashBookExpensesPostResponse422) & {
  headers: Headers;
};

export type createExpenseApiCashBookExpensesPostResponse = (createExpenseApiCashBookExpensesPostResponseSuccess | createExpenseApiCashBookExpensesPostResponseError)

export const getCreateExpenseApiCashBookExpensesPostUrl = () => {


  

  return `/api/cash-book/expenses`
}

export const createExpenseApiCashBookExpensesPost = async (expenseCreate: ExpenseCreate, options?: RequestInit): Promise<createExpenseApiCashBookExpensesPostResponse> => {
  
  return customFetch<createExpenseApiCashBookExpensesPostResponse>(getCreateExpenseApiCashBookExpensesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      expenseCreate,)
  }
);}



/**
 * @summary Delete Expense
 */
export type deleteExpenseApiCashBookExpensesExpenseIdDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteExpenseApiCashBookExpensesExpenseIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteExpenseApiCashBookExpensesExpenseIdDeleteResponseSuccess = (deleteExpenseApiCashBookExpensesExpenseIdDeleteResponse204) & {
  headers: Headers;
};
export type deleteExpenseApiCashBookExpensesExpenseIdDeleteResponseError = (deleteExpenseApiCashBookExpensesExpenseIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteExpenseApiCashBookExpensesExpenseIdDeleteResponse = (deleteExpenseApiCashBookExpensesExpenseIdDeleteResponseSuccess | deleteExpenseApiCashBookExpensesExpenseIdDeleteResponseError)

export const getDeleteExpenseApiCashBookExpensesExpenseIdDeleteUrl = (expenseId: string,) => {


  

  return `/api/cash-book/expenses/${expenseId}`
}

export const deleteExpenseApiCashBookExpensesExpenseIdDelete = async (expenseId: string, options?: RequestInit): Promise<deleteExpenseApiCashBookExpensesExpenseIdDeleteResponse> => {
  
  return customFetch<deleteExpenseApiCashBookExpensesExpenseIdDeleteResponse>(getDeleteExpenseApiCashBookExpensesExpenseIdDeleteUrl(expenseId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Summary
 */
export type summaryApiCashBookSummaryGetResponse200 = {
  data: CashSummary
  status: 200
}

export type summaryApiCashBookSummaryGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type summaryApiCashBookSummaryGetResponseSuccess = (summaryApiCashBookSummaryGetResponse200) & {
  headers: Headers;
};
export type summaryApiCashBookSummaryGetResponseError = (summaryApiCashBookSummaryGetResponse422) & {
  headers: Headers;
};

export type summaryApiCashBookSummaryGetResponse = (summaryApiCashBookSummaryGetResponseSuccess | summaryApiCashBookSummaryGetResponseError)

export const getSummaryApiCashBookSummaryGetUrl = (params: SummaryApiCashBookSummaryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/cash-book/summary?${stringifiedParams}` : `/api/cash-book/summary`
}

export const summaryApiCashBookSummaryGet = async (params: SummaryApiCashBookSummaryGetParams, options?: RequestInit): Promise<summaryApiCashBookSummaryGetResponse> => {
  
  return customFetch<summaryApiCashBookSummaryGetResponse>(getSummaryApiCashBookSummaryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Gstr1 Json
 */
export type gstr1JsonApiGstGstr1GetResponse200 = {
  data: GSTR1Response
  status: 200
}

export type gstr1JsonApiGstGstr1GetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type gstr1JsonApiGstGstr1GetResponseSuccess = (gstr1JsonApiGstGstr1GetResponse200) & {
  headers: Headers;
};
export type gstr1JsonApiGstGstr1GetResponseError = (gstr1JsonApiGstGstr1GetResponse422) & {
  headers: Headers;
};

export type gstr1JsonApiGstGstr1GetResponse = (gstr1JsonApiGstGstr1GetResponseSuccess | gstr1JsonApiGstGstr1GetResponseError)

export const getGstr1JsonApiGstGstr1GetUrl = (params: Gstr1JsonApiGstGstr1GetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gst/gstr1?${stringifiedParams}` : `/api/gst/gstr1`
}

export const gstr1JsonApiGstGstr1Get = async (params: Gstr1JsonApiGstGstr1GetParams, options?: RequestInit): Promise<gstr1JsonApiGstGstr1GetResponse> => {
  
  return customFetch<gstr1JsonApiGstGstr1GetResponse>(getGstr1JsonApiGstGstr1GetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Gstr1 Pdf
 */
export type gstr1PdfApiGstGstr1PdfGetResponse200 = {
  data: unknown
  status: 200
}

export type gstr1PdfApiGstGstr1PdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type gstr1PdfApiGstGstr1PdfGetResponseSuccess = (gstr1PdfApiGstGstr1PdfGetResponse200) & {
  headers: Headers;
};
export type gstr1PdfApiGstGstr1PdfGetResponseError = (gstr1PdfApiGstGstr1PdfGetResponse422) & {
  headers: Headers;
};

export type gstr1PdfApiGstGstr1PdfGetResponse = (gstr1PdfApiGstGstr1PdfGetResponseSuccess | gstr1PdfApiGstGstr1PdfGetResponseError)

export const getGstr1PdfApiGstGstr1PdfGetUrl = (params: Gstr1PdfApiGstGstr1PdfGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gst/gstr1/pdf?${stringifiedParams}` : `/api/gst/gstr1/pdf`
}

export const gstr1PdfApiGstGstr1PdfGet = async (params: Gstr1PdfApiGstGstr1PdfGetParams, options?: RequestInit): Promise<gstr1PdfApiGstGstr1PdfGetResponse> => {
  
  return customFetch<gstr1PdfApiGstGstr1PdfGetResponse>(getGstr1PdfApiGstGstr1PdfGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Gstr1 Gstn Upload
 */
export type gstr1GstnUploadApiGstGstr1GstnUploadGetResponse200 = {
  data: unknown
  status: 200
}

export type gstr1GstnUploadApiGstGstr1GstnUploadGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type gstr1GstnUploadApiGstGstr1GstnUploadGetResponseSuccess = (gstr1GstnUploadApiGstGstr1GstnUploadGetResponse200) & {
  headers: Headers;
};
export type gstr1GstnUploadApiGstGstr1GstnUploadGetResponseError = (gstr1GstnUploadApiGstGstr1GstnUploadGetResponse422) & {
  headers: Headers;
};

export type gstr1GstnUploadApiGstGstr1GstnUploadGetResponse = (gstr1GstnUploadApiGstGstr1GstnUploadGetResponseSuccess | gstr1GstnUploadApiGstGstr1GstnUploadGetResponseError)

export const getGstr1GstnUploadApiGstGstr1GstnUploadGetUrl = (params: Gstr1GstnUploadApiGstGstr1GstnUploadGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gst/gstr1/gstn-upload?${stringifiedParams}` : `/api/gst/gstr1/gstn-upload`
}

export const gstr1GstnUploadApiGstGstr1GstnUploadGet = async (params: Gstr1GstnUploadApiGstGstr1GstnUploadGetParams, options?: RequestInit): Promise<gstr1GstnUploadApiGstGstr1GstnUploadGetResponse> => {
  
  return customFetch<gstr1GstnUploadApiGstGstr1GstnUploadGetResponse>(getGstr1GstnUploadApiGstGstr1GstnUploadGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Gstr3B Json
 */
export type gstr3bJsonApiGstGstr3bGetResponse200 = {
  data: GSTR3BResponse
  status: 200
}

export type gstr3bJsonApiGstGstr3bGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type gstr3bJsonApiGstGstr3bGetResponseSuccess = (gstr3bJsonApiGstGstr3bGetResponse200) & {
  headers: Headers;
};
export type gstr3bJsonApiGstGstr3bGetResponseError = (gstr3bJsonApiGstGstr3bGetResponse422) & {
  headers: Headers;
};

export type gstr3bJsonApiGstGstr3bGetResponse = (gstr3bJsonApiGstGstr3bGetResponseSuccess | gstr3bJsonApiGstGstr3bGetResponseError)

export const getGstr3bJsonApiGstGstr3bGetUrl = (params: Gstr3bJsonApiGstGstr3bGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gst/gstr3b?${stringifiedParams}` : `/api/gst/gstr3b`
}

export const gstr3bJsonApiGstGstr3bGet = async (params: Gstr3bJsonApiGstGstr3bGetParams, options?: RequestInit): Promise<gstr3bJsonApiGstGstr3bGetResponse> => {
  
  return customFetch<gstr3bJsonApiGstGstr3bGetResponse>(getGstr3bJsonApiGstGstr3bGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Gstr3B Pdf
 */
export type gstr3bPdfApiGstGstr3bPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type gstr3bPdfApiGstGstr3bPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type gstr3bPdfApiGstGstr3bPdfGetResponseSuccess = (gstr3bPdfApiGstGstr3bPdfGetResponse200) & {
  headers: Headers;
};
export type gstr3bPdfApiGstGstr3bPdfGetResponseError = (gstr3bPdfApiGstGstr3bPdfGetResponse422) & {
  headers: Headers;
};

export type gstr3bPdfApiGstGstr3bPdfGetResponse = (gstr3bPdfApiGstGstr3bPdfGetResponseSuccess | gstr3bPdfApiGstGstr3bPdfGetResponseError)

export const getGstr3bPdfApiGstGstr3bPdfGetUrl = (params: Gstr3bPdfApiGstGstr3bPdfGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gst/gstr3b/pdf?${stringifiedParams}` : `/api/gst/gstr3b/pdf`
}

export const gstr3bPdfApiGstGstr3bPdfGet = async (params: Gstr3bPdfApiGstGstr3bPdfGetParams, options?: RequestInit): Promise<gstr3bPdfApiGstGstr3bPdfGetResponse> => {
  
  return customFetch<gstr3bPdfApiGstGstr3bPdfGetResponse>(getGstr3bPdfApiGstGstr3bPdfGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Manual Tax Invoices
 */
export type listManualTaxInvoicesApiManualTaxInvoicesGetResponse200 = {
  data: ManualTaxInvoiceList
  status: 200
}

export type listManualTaxInvoicesApiManualTaxInvoicesGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type listManualTaxInvoicesApiManualTaxInvoicesGetResponseSuccess = (listManualTaxInvoicesApiManualTaxInvoicesGetResponse200) & {
  headers: Headers;
};
export type listManualTaxInvoicesApiManualTaxInvoicesGetResponseError = (listManualTaxInvoicesApiManualTaxInvoicesGetResponse422) & {
  headers: Headers;
};

export type listManualTaxInvoicesApiManualTaxInvoicesGetResponse = (listManualTaxInvoicesApiManualTaxInvoicesGetResponseSuccess | listManualTaxInvoicesApiManualTaxInvoicesGetResponseError)

export const getListManualTaxInvoicesApiManualTaxInvoicesGetUrl = (params?: ListManualTaxInvoicesApiManualTaxInvoicesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/manual-tax-invoices/?${stringifiedParams}` : `/api/manual-tax-invoices/`
}

export const listManualTaxInvoicesApiManualTaxInvoicesGet = async (params?: ListManualTaxInvoicesApiManualTaxInvoicesGetParams, options?: RequestInit): Promise<listManualTaxInvoicesApiManualTaxInvoicesGetResponse> => {
  
  return customFetch<listManualTaxInvoicesApiManualTaxInvoicesGetResponse>(getListManualTaxInvoicesApiManualTaxInvoicesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Manual Tax Invoice
 */
export type createManualTaxInvoiceApiManualTaxInvoicesPostResponse201 = {
  data: ManualTaxInvoiceRead
  status: 201
}

export type createManualTaxInvoiceApiManualTaxInvoicesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type createManualTaxInvoiceApiManualTaxInvoicesPostResponseSuccess = (createManualTaxInvoiceApiManualTaxInvoicesPostResponse201) & {
  headers: Headers;
};
export type createManualTaxInvoiceApiManualTaxInvoicesPostResponseError = (createManualTaxInvoiceApiManualTaxInvoicesPostResponse422) & {
  headers: Headers;
};

export type createManualTaxInvoiceApiManualTaxInvoicesPostResponse = (createManualTaxInvoiceApiManualTaxInvoicesPostResponseSuccess | createManualTaxInvoiceApiManualTaxInvoicesPostResponseError)

export const getCreateManualTaxInvoiceApiManualTaxInvoicesPostUrl = () => {


  

  return `/api/manual-tax-invoices/`
}

export const createManualTaxInvoiceApiManualTaxInvoicesPost = async (manualTaxInvoiceCreate: ManualTaxInvoiceCreate, options?: RequestInit): Promise<createManualTaxInvoiceApiManualTaxInvoicesPostResponse> => {
  
  return customFetch<createManualTaxInvoiceApiManualTaxInvoicesPostResponse>(getCreateManualTaxInvoiceApiManualTaxInvoicesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      manualTaxInvoiceCreate,)
  }
);}



/**
 * @summary Get Manual Tax Invoice
 */
export type getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponse200 = {
  data: ManualTaxInvoiceRead
  status: 200
}

export type getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponseSuccess = (getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponse200) & {
  headers: Headers;
};
export type getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponseError = (getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponse422) & {
  headers: Headers;
};

export type getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponse = (getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponseSuccess | getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponseError)

export const getGetManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetUrl = (invoiceId: string,) => {


  

  return `/api/manual-tax-invoices/${invoiceId}`
}

export const getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGet = async (invoiceId: string, options?: RequestInit): Promise<getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponse> => {
  
  return customFetch<getManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetResponse>(getGetManualTaxInvoiceApiManualTaxInvoicesInvoiceIdGetUrl(invoiceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Manual Tax Invoice
 */
export type updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponse200 = {
  data: ManualTaxInvoiceRead
  status: 200
}

export type updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponseSuccess = (updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponse200) & {
  headers: Headers;
};
export type updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponseError = (updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponse422) & {
  headers: Headers;
};

export type updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponse = (updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponseSuccess | updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponseError)

export const getUpdateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutUrl = (invoiceId: string,) => {


  

  return `/api/manual-tax-invoices/${invoiceId}`
}

export const updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPut = async (invoiceId: string,
    manualTaxInvoiceUpdate: ManualTaxInvoiceUpdate, options?: RequestInit): Promise<updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponse> => {
  
  return customFetch<updateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutResponse>(getUpdateManualTaxInvoiceApiManualTaxInvoicesInvoiceIdPutUrl(invoiceId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      manualTaxInvoiceUpdate,)
  }
);}



/**
 * @summary Delete Manual Tax Invoice
 */
export type deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponseSuccess = (deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponse204) & {
  headers: Headers;
};
export type deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponseError = (deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponse422) & {
  headers: Headers;
};

export type deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponse = (deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponseSuccess | deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponseError)

export const getDeleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteUrl = (invoiceId: string,) => {


  

  return `/api/manual-tax-invoices/${invoiceId}`
}

export const deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDelete = async (invoiceId: string, options?: RequestInit): Promise<deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponse> => {
  
  return customFetch<deleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteResponse>(getDeleteManualTaxInvoiceApiManualTaxInvoicesInvoiceIdDeleteUrl(invoiceId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Manual Tax Invoice Pdf
 */
export type manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponse200 = {
  data: unknown
  status: 200
}

export type manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponse422 = {
  data: HTTPValidationError
  status: 422
}
    
export type manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponseSuccess = (manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponse200) & {
  headers: Headers;
};
export type manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponseError = (manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponse422) & {
  headers: Headers;
};

export type manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponse = (manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponseSuccess | manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponseError)

export const getManualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetUrl = (invoiceId: string,) => {


  

  return `/api/manual-tax-invoices/${invoiceId}/pdf`
}

export const manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGet = async (invoiceId: string, options?: RequestInit): Promise<manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponse> => {
  
  return customFetch<manualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetResponse>(getManualTaxInvoicePdfApiManualTaxInvoicesInvoiceIdPdfGetUrl(invoiceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
